export const faturamentoMock = [[
{
  "isSuccess": true,
  "data": [
    [
      {
        "id": 892,
        "codigoVendedor": "234182",
        "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
        "basesFaturamento": [
          {
            "id": 1,
            "cards": [
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 8.800000000000002,
                "percentVolumeMesAtual": -0.7904761904761904,
                "volumeProjetado": 10.975824175824203,
                "percentVolumeProjetado": -0.7386708529565666,
                "volumeMeta": 77.18,
                "percentVolumeMeta": -0.857789269553975,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC I",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0.14,
                "percentVolumeD1": 5.76666666666664,
                "volumeMesAtual": 0.48,
                "percentVolumeMesAtual": -2.220446049250313e-16,
                "volumeProjetado": 0.59868131868132,
                "percentVolumeProjetado": 0.2472527472527497,
                "volumeMeta": 0.65,
                "percentVolumeMeta": -0.07895181741335389,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Ceramica",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 216,
                "percentVolumeD1": -0.011207576953434328,
                "volumeMesAtual": 3068,
                "percentVolumeMesAtual": -0.39463299131807417,
                "volumeProjetado": 3826.57142857147,
                "percentVolumeProjetado": -0.2449543353252822,
                "volumeMeta": 5046.47,
                "percentVolumeMeta": -0.24173304734369383,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Todas as Obras",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 61.244,
                "percentVolumeD1": 0.34620524114950735,
                "volumeMesAtual": 575.22,
                "percentVolumeMesAtual": -0.4557881053342643,
                "volumeProjetado": 717.444725274727,
                "percentVolumeProjetado": -0.32123021929053686,
                "volumeMeta": 0,
                "percentVolumeMeta": 1,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Nobres",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0.19799999999999998,
                "percentVolumeD1": 2.594366197183066,
                "volumeMesAtual": 1.3500000000000003,
                "percentVolumeMesAtual": 0.05633802816901423,
                "volumeProjetado": 1.683791208791207,
                "percentVolumeProjetado": 0.3175205076613512,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 1000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.8,
                "percentVolumeMesAtual": -0.5,
                "volumeProjetado": 0.9978021978022,
                "percentVolumeProjetado": -0.37637362637362504,
                "volumeMeta": 77.18,
                "percentVolumeMeta": -0.9870717517776341,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "PSP",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0.36,
                "percentVolumeD1": -0.3982708933717537,
                "volumeMesAtual": 5.640000000000001,
                "percentVolumeMesAtual": -0.5936599423631124,
                "volumeProjetado": 7.03450549450551,
                "percentVolumeProjetado": -0.4931912467935512,
                "volumeMeta": 0,
                "percentVolumeMeta": 1,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Pintura",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 9.200000000000001,
                "percentVolumeMesAtual": 2.2857142857142865,
                "volumeProjetado": 11.474725274725301,
                "percentVolumeProjetado": 3.0981161695447508,
                "volumeMeta": 77.18,
                "percentVolumeMeta": -0.8513251454427921,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC II",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 40,
                "percentVolumeMesAtual": 0.05263157894736836,
                "volumeProjetado": 49.89010989011,
                "percentVolumeProjetado": 0.31289762868710524,
                "volumeMeta": 5046.47,
                "percentVolumeMeta": -0.990113859808914,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Obras Especiais",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 29.8,
                "percentVolumeD1": 0,
                "volumeMesAtual": 59.12,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 73.737582417582,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 1,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Outros",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.018,
                "percentVolumeMesAtual": -0.5,
                "volumeProjetado": 0.022450549450549,
                "percentVolumeProjetado": -0.3763736263736388,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo de Aderência",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 4.16,
                "percentVolumeD1": 1.2095238095238106,
                "volumeMesAtual": 34.84,
                "percentVolumeMesAtual": -0.20238095238095244,
                "volumeProjetado": 43.45428571428623,
                "percentVolumeProjetado": -0.0051674515960113965,
                "volumeMeta": 0,
                "percentVolumeMeta": 1,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Hidratada",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0.19799999999999998,
                "percentVolumeD1": 0.11441048034933576,
                "volumeMesAtual": 0.306,
                "percentVolumeMesAtual": -0.9257641921397379,
                "volumeProjetado": 0.38165934065933904,
                "percentVolumeProjetado": -0.9074091847017616,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 10,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 12.472527472527,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 1,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Liga para Massa",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 5068,
                "percentVolumeMesAtual": -0.00039447731755426485,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.00039447731755426485,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Todas as Obras",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 38,
                "percentVolumeMesAtual": 0.8999999999999999,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.8999999999999999,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Obras Especiais",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1.2780000000000002,
                "percentVolumeMesAtual": -0.9134146341463414,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.9134146341463414,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 1000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.4800000000000001,
                "percentVolumeMesAtual": 0.41176470588235303,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.41176470588235303,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Ceramica",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 42,
                "percentVolumeMesAtual": -0.5047169811320755,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.5047169811320755,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC I",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 13.88,
                "percentVolumeMesAtual": 1.1340713407134073,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 1.1340713407134073,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Pintura",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 2.8,
                "percentVolumeMesAtual": -0.851063829787234,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.851063829787234,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC II",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 43.68000000000001,
                "percentVolumeMesAtual": 0.1351351351351351,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.1351351351351351,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Hidratada",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1056.978,
                "percentVolumeMesAtual": -0.24262348646940546,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.24262348646940546,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Nobres",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 4.122,
                "percentVolumeMesAtual": 0.27222222222222237,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.27222222222222237,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1.6,
                "percentVolumeMesAtual": -0.6923076923076923,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.6923076923076923,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "PSP",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 14,
                "percentVolumeMesAtual": -0.35185185185185175,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.35185185185185175,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC III",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.036,
                "percentVolumeMesAtual": -0.9722222222222222,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.9722222222222222,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo de Aderência",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.108,
                "percentVolumeMesAtual": -0.9807692307692307,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.9807692307692307,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 7000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.3,
                "percentVolumeMesAtual": -0.5,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.5,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Porcelanato",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 5070,
                "percentVolumeMesAtual": 0.1162483487450463,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.1162483487450463,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Todas as Obras",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1395.578,
                "percentVolumeMesAtual": 0.21250860133590033,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.21250860133590033,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Nobres",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 5.2,
                "percentVolumeMesAtual": 1.1666666666666665,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 1.1666666666666665,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "PSP",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 84.8,
                "percentVolumeMesAtual": 2.164179104477612,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 2.164179104477612,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC I",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 6.5040000000000004,
                "percentVolumeMesAtual": 0.9311163895486936,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.9311163895486936,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Pintura",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.34,
                "percentVolumeMesAtual": -0.15000000000000002,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.15000000000000002,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Ceramica",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 14.76,
                "percentVolumeMesAtual": 4.324675324675324,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 4.324675324675324,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 1000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 18.8,
                "percentVolumeMesAtual": 10.75,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 10.75,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC II",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 20,
                "percentVolumeMesAtual": -0.6428571428571428,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.6428571428571428,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Obras Especiais",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 3.2399999999999998,
                "percentVolumeMesAtual": 9.588235294117647,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 9.588235294117647,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 1.296,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo de Aderência",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 21.599999999999998,
                "percentVolumeMesAtual": 16.999999999999996,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 16.999999999999996,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC III",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 38.480000000000004,
                "percentVolumeMesAtual": 0.45098039215686314,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.45098039215686314,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Hidratada",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 8,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Porcelanato Interno",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 5.616,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 7000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 14,
                "percentVolumeMesAtual": 0.9444444444444444,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.9444444444444444,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Liga para Massa",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 38,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cimento 25kg",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 0.6,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Porcelanato",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 4542,
                "percentVolumeMesAtual": 0.0035351303579318483,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.0035351303579318483,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Todas as Obras",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 2.7720000000000002,
                "percentVolumeMesAtual": 2.276595744680851,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 2.276595744680851,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 1000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 26.799999999999997,
                "percentVolumeMesAtual": 0.9705882352941166,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.9705882352941166,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC I",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 28.424,
                "percentVolumeMesAtual": -0.48607796340493237,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.48607796340493237,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Outros",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1150.9840000000002,
                "percentVolumeMesAtual": -0.2973647454117462,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.2973647454117462,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Nobres",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.4,
                "percentVolumeMesAtual": 0.25,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.25,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Ceramica",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1.6,
                "percentVolumeMesAtual": -0.8260869565217391,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.8260869565217391,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC II",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 26.519999999999996,
                "percentVolumeMesAtual": -0.2031250000000001,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.2031250000000001,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Hidratada",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 3.3680000000000003,
                "percentVolumeMesAtual": 0.27575757575757587,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.27575757575757587,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Pintura",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 2.4000000000000004,
                "percentVolumeMesAtual": -0.7,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.7,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "PSP",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 0.306,
                "percentVolumeMesAtual": 0.5454545454545456,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.5454545454545456,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 1.2000000000000002,
                "percentVolumeMesAtual": -0.625,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.625,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC III",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 7.2,
                "percentVolumeMesAtual": -0.64,
                "volumeProjetado": 0,
                "percentVolumeProjetado": -0.64,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Liga para Massa",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": -1,
                "volumeMesAtual": 56,
                "percentVolumeMesAtual": 0.2727272727272727,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0.2727272727272727,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Obras Especiais",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 1638.096,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Nobres",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 4526,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Todas as Obras",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 55.308,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Outros",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 13.600000000000005,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC I",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 0.32,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Ceramica",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 9.2,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC II",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 3.2,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC III",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 8,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "PSP",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 0.8460000000000001,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 1000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 33.28,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Hidratada",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 0.19799999999999998,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 2.64,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Pintura",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 44,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Obras Especiais",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 20,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Liga para Massa",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 30.679999999999996,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Hidratada",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 1367.8339999999998,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Nobres",
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 5891,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Todas as Obras",
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 1.2960000000000005,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Polimerica 1000",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 12.96,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC I",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 3.2,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC II",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 0.26,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Rejunte Ceramica",
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 5.2,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "PSP",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 5.6,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "AC III",
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 0.054,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Aditivo de Aderência",
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 17.52,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Cal Pintura",
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volumeD1": 0,
                "percentVolumeD1": 0,
                "volumeMesAtual": 54,
                "percentVolumeMesAtual": 0,
                "volumeProjetado": 0,
                "percentVolumeProjetado": 0,
                "volumeMeta": 0,
                "percentVolumeMeta": 0,
                "createdAtMeta": "2026-09-25T07:42:37.1346404",
                "createdAtFat": "2026-09-25T07:43:02.3856433",
                "prodHier5": "Obras Especiais",
                "prodHier3": "Cimentos"
              }
            ]
          },
          {
            "id": 2,
            "volumes": [
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 30.679999999999996,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales",
                "volumeDu": 1.278333333333334
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 1367.8339999999998,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA",
                "volumeDu": 56.9930833333336
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 5891,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO",
                "volumeDu": 245.45833333333337
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 1.2960000000000005,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.054000000000000006
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 12.96,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I",
                "volumeDu": 0.539999999999996
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 3.2,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.133333333333333
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 0.26,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.01083333333333333
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 5.2,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.216666666666667
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 5.6,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.233333333333334
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 0.054,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.00225
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 17.52,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales",
                "volumeDu": 0.7300000000000001
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 1638.096,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA",
                "volumeDu": 72.80426666666729
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 4526,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO",
                "volumeDu": 201.15555555555636
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 55.308,
                "prodHier3": "Agregados",
                "prodHier5": "Outros",
                "prodHier6": "BRITA 2",
                "volumeDu": 2.4581333333333
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 13.600000000000005,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I",
                "volumeDu": 0.604444444444454
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 0.32,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.014222222222222292
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 9.2,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.408888888888892
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 3.2,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.14222222222222197
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 8,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.355555555555556
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 0.8460000000000001,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.0376
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 33.28,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales",
                "volumeDu": 1.47911111111111
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 0.19799999999999998,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.008799999999999999
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 2.64,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales",
                "volumeDu": 0.1173333333333326
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 44,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 1.955555555555589
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 4542,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO",
                "volumeDu": 197.4782608695642
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 2.7720000000000002,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.1205217391304337
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 26.799999999999997,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I",
                "volumeDu": 1.165217391304342
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 28.424,
                "prodHier3": "Agregados",
                "prodHier5": "Outros",
                "prodHier6": "BRITA 2",
                "volumeDu": 1.2358260869565
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 1150.9840000000002,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "BRITA 1",
                "volumeDu": 50.04278260869536
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 0.4,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.017391304347825997
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 1.6,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.069565217391304
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 26.519999999999996,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales",
                "volumeDu": 1.1530434782608718
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 3.3680000000000003,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales",
                "volumeDu": 0.14643478260869558
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 2.4000000000000004,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.104347826086956
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 0.306,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.0133043478260868
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 1.2000000000000002,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.052173913043478
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 7.2,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales",
                "volumeDu": 0.31304347826087
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "volume": 56,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 2.43478260869563
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 5070,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO",
                "volumeDu": 202.8
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 1395.578,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA",
                "volumeDu": 55.82312
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 5.2,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.20800000000000002
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 84.8,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I",
                "volumeDu": 3.3920000000000003
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 6.5040000000000004,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales",
                "volumeDu": 0.26016
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 0.34,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.013600000000000003
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 14.76,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.5904
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 18.8,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.752
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 20,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 0.8
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 3.2399999999999998,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.1296
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 1.296,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.05184
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 21.599999999999998,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.8640000000000001
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 38.480000000000004,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales",
                "volumeDu": 1.5392000000000001
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 5068,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO",
                "volumeDu": 218.44827586206918
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 38,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 1.6379310344827722
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 1.2780000000000002,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.05508620689655222
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 0.4800000000000001,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.020689655172413876
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 42,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I",
                "volumeDu": 1.8103448275861698
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 13.88,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales",
                "volumeDu": 0.5982758620689613
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 2.8,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.120689655172414
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 43.68000000000001,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales",
                "volumeDu": 1.8827586206896543
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 1056.978,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "BRITA 1",
                "volumeDu": 45.493805942773285
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 4.122,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.1776724137931049
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 1.6,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.06896551724138
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 14,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.6034482758620701
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 0.036,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.001551724137931
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 8.800000000000002,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I",
                "volumeDu": 0.4835164835164841
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 0.48,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.0263736263736266
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 3068,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO",
                "volumeDu": 168.57142857142804
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 575.22,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "BRITA 1",
                "volumeDu": 31.6054945054947
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 1.3500000000000003,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.07417582417582459
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 0.8,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.043956043956044
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 5.640000000000001,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales",
                "volumeDu": 0.30989010989010796
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 9.200000000000001,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.505494505494506
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 40,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 2.19780219780222
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 59.12,
                "prodHier3": "Agregados",
                "prodHier5": "Outros",
                "prodHier6": "BRITA 2",
                "volumeDu": 3.2483516483516
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 0.018,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.00098901098901099
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 34.84,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales",
                "volumeDu": 1.914285714285743
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 0.306,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.01681318681318679
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 8,
                "prodHier3": "Colantes",
                "prodHier5": "Porcelanato Interno",
                "prodHier6": "Outras Colas",
                "volumeDu": 0.32
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 5.616,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 7000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.22463999999999998
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "volume": 10,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales",
                "volumeDu": 0.54945054945055
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 14,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales",
                "volumeDu": 0.56
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 38,
                "prodHier3": "Cimentos",
                "prodHier5": "Cimento 25kg",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 1.52
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "volume": 0.6,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Porcelanato",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.024
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 0.108,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 7000",
                "prodHier6": "Impermeabilizantes",
                "volumeDu": 0.0046551724137932
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "volume": 0.3,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Porcelanato",
                "prodHier6": "Rejuntes",
                "volumeDu": 0.012931034482759
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "volume": 54,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE",
                "volumeDu": 2.25
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "volume": 20,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales",
                "volumeDu": 0.88888888888889
              },
              {
                "volume": 5046.47,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "volume": 77.18,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "volume": 0,
                "prodHier3": "Basicas"
              },
              {
                "volume": 0,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "volume": 0,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA"
              },
              {
                "volume": 0,
                "prodHier3": "Concreto"
              },
              {
                "volume": 0.65,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              }
            ]
          },
          {
            "id": 3,
            "faturamentos": [
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 27779.31,
                "fobLiquido": 12145.12,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 77407.64,
                "fobLiquido": 58262.009999999995,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 3868433.34,
                "fobLiquido": 2157298.1262440095,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 3063.109999999999,
                "fobLiquido": 2073.31,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 7360.619999999999,
                "fobLiquido": 2681.6499999999996,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 3750.73,
                "fobLiquido": 1944.15,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 1479.64,
                "fobLiquido": 946.86,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 6661.010000000001,
                "fobLiquido": 4220.59,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 8053.6,
                "fobLiquido": 4633.73,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 442.42,
                "fobLiquido": 328.24,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 28520.26,
                "fobLiquido": 15785.83,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 104539.09,
                "fobLiquido": 78741.5,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 3163806.170000001,
                "fobLiquido": 1664356.0459064748,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 4510.37,
                "fobLiquido": 3397.31,
                "prodHier3": "Agregados",
                "prodHier5": "Outros",
                "prodHier6": "BRITA 2"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 8281.37,
                "fobLiquido": 2521.4900000000002,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 2046.2699999999998,
                "fobLiquido": 1180.76,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 11581.57,
                "fobLiquido": 6063.169999999999,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 5144.98,
                "fobLiquido": 2848.52,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 11633.39,
                "fobLiquido": 6650.550000000001,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 2165.07,
                "fobLiquido": 1402.48,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 29202.76,
                "fobLiquido": 12231.28,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 974.45,
                "fobLiquido": 702.84,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 4733.61,
                "fobLiquido": 2702.37,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 35779,
                "fobLiquido": 15953.400184253,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 3316047.0999999996,
                "fobLiquido": 1838449.585000001,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 6733.990000000001,
                "fobLiquido": 4567.29,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 16669.010000000002,
                "fobLiquido": 4978.92,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 2317.98,
                "fobLiquido": 1745.96,
                "prodHier3": "Agregados",
                "prodHier5": "Outros",
                "prodHier6": "BRITA 2"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 79118.65000000001,
                "fobLiquido": 59594.200000000004,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "BRITA 1"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 2563.6,
                "fobLiquido": 1526.56,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 2034.25,
                "fobLiquido": 991.75,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 23489.559999999994,
                "fobLiquido": 8380.75,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 8891.75,
                "fobLiquido": 3412.24,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 3307,
                "fobLiquido": 1878.47,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 1499.74,
                "fobLiquido": 1042.27,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 1886.47,
                "fobLiquido": 1041.52,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 4242.27,
                "fobLiquido": 1385.74,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "faturamento": 44850.5,
                "fobLiquido": 21292.11,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 3846707.3799999994,
                "fobLiquido": 2129439.1895628013,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 87697.64000000001,
                "fobLiquido": 65642.84,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "AREIA/PO DE PEDRA"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 7658.1900000000005,
                "fobLiquido": 4076.3900000000003,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 70416.92,
                "fobLiquido": 7307.688657183493,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 11283.550000000001,
                "fobLiquido": 5986.752023232,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 2216.33,
                "fobLiquido": 1439.070460849157,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 38679.14,
                "fobLiquido": 19465.108482673102,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 32225.510000000002,
                "fobLiquido": 9038.630000000001,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 16665,
                "fobLiquido": 7591.53,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 12941.34,
                "fobLiquido": 9591.79,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 10002.740000000002,
                "fobLiquido": 7473.69,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 34926.57,
                "fobLiquido": 16219.5182831537,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 32436.359999999997,
                "fobLiquido": 9907.14999842672,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 3726173.24,
                "fobLiquido": 2003750.1650096246,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 31333.510000000002,
                "fobLiquido": 14158.811168613,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 3419.52,
                "fobLiquido": 2235.8199999999997,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 3022.3799999999997,
                "fobLiquido": 1883.9600000000003,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 26014.18,
                "fobLiquido": 7452.6369446502995,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 26212.24,
                "fobLiquido": 13566.979999999998,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 4078.54,
                "fobLiquido": 1806.32,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 38830.56999999999,
                "fobLiquido": 13280.78,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 66009.08,
                "fobLiquido": 50092.72,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "BRITA 1"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 10358.76,
                "fobLiquido": 4519.47,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 2288.1400000000003,
                "fobLiquido": 1113.73,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 24018.809999999998,
                "fobLiquido": 13269.433055349698,
                "prodHier3": "Colantes",
                "prodHier5": "AC III",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 328.96,
                "fobLiquido": 238.9,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 5190.749999999999,
                "fobLiquido": 1292.3774637681129,
                "prodHier3": "Colantes",
                "prodHier5": "AC I",
                "prodHier6": "AC I"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 2898.39,
                "fobLiquido": 1869.4393333333,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Ceramica",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 2395185.4699999997,
                "fobLiquido": 1389377.9766717637,
                "prodHier3": "Cimentos",
                "prodHier5": "Todas as Obras",
                "prodHier6": "Cimentos-TO"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 38001.47,
                "fobLiquido": 28623.680000000004,
                "prodHier3": "Agregados",
                "prodHier5": "Nobres",
                "prodHier6": "BRITA 1"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 3531.6800000000003,
                "fobLiquido": 2300.42,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 1000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 1072.2,
                "fobLiquido": 578.04,
                "prodHier3": "Colantes",
                "prodHier5": "PSP",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 10194.46,
                "fobLiquido": 5283.899156941649,
                "prodHier3": "Cales",
                "prodHier5": "Cal Pintura",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 15504.060000000001,
                "fobLiquido": 5393.84,
                "prodHier3": "Colantes",
                "prodHier5": "AC II",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 33874,
                "fobLiquido": 15440.375,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 5356.87,
                "fobLiquido": 4034.93,
                "prodHier3": "Agregados",
                "prodHier5": "Outros",
                "prodHier6": "BRITA 2"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 164.02,
                "fobLiquido": 119.83,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo de Aderência",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 30119.180000000004,
                "fobLiquido": 9939.82256880729,
                "prodHier3": "Cales",
                "prodHier5": "Cal Hidratada",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 1498.95,
                "fobLiquido": 949.43,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Aditivo Impermeabili",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 8661,
                "fobLiquido": 2714.98705680871,
                "prodHier3": "Colantes",
                "prodHier5": "Porcelanato Interno",
                "prodHier6": "Outras Colas"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 67796.8,
                "fobLiquido": 31660.546727523248,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 7000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "faturamento": 5880,
                "fobLiquido": 1583.7175757576,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 7777,
                "fobLiquido": 2316.71,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 29366.4,
                "fobLiquido": 11456.86,
                "prodHier3": "Cimentos",
                "prodHier5": "Cimento 25kg",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "faturamento": 5512,
                "fobLiquido": 3576.7695391508,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Porcelanato",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 1039.26,
                "fobLiquido": 724.0799999999999,
                "prodHier3": "Impermeabilizantes",
                "prodHier5": "Polimerica 7000",
                "prodHier6": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "faturamento": 3072,
                "fobLiquido": 1448.04,
                "prodHier3": "Rejuntes",
                "prodHier5": "Rejunte Porcelanato",
                "prodHier6": "Rejuntes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "faturamento": 43900.47,
                "fobLiquido": 23376.435416204,
                "prodHier3": "Cimentos",
                "prodHier5": "Obras Especiais",
                "prodHier6": "Cimentos-OE"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "faturamento": 11014,
                "fobLiquido": 3900.05,
                "prodHier3": "Cales",
                "prodHier5": "Liga para Massa",
                "prodHier6": "Cales"
              }
            ]
          },
          {
            "id": 4,
            "positivacoes": [
              {
                "inicioMes": "2025-09-01T00:00:00",
                "quantidade": 13,
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "quantidade": 6,
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "quantidade": 65,
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "quantidade": 13,
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "quantidade": 17,
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2025-09-01T00:00:00",
                "quantidade": 4,
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "quantidade": 7,
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "quantidade": 78,
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "quantidade": 23,
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "quantidade": 13,
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "quantidade": 11,
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-05-01T00:00:00",
                "quantidade": 10,
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "quantidade": 77,
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "quantidade": 13,
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "quantidade": 22,
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "quantidade": 8,
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "quantidade": 11,
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-06-01T00:00:00",
                "quantidade": 9,
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "quantidade": 66,
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "quantidade": 9,
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "quantidade": 23,
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "quantidade": 13,
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "quantidade": 6,
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-07-01T00:00:00",
                "quantidade": 11,
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "quantidade": 77,
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "quantidade": 19,
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "quantidade": 10,
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "quantidade": 22,
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "quantidade": 16,
                "prodHier3": "Cales"
              },
              {
                "inicioMes": "2026-08-01T00:00:00",
                "quantidade": 10,
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "quantidade": 14,
                "prodHier3": "Colantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "quantidade": 4,
                "prodHier3": "Rejuntes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "quantidade": 62,
                "prodHier3": "Cimentos"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "quantidade": 6,
                "prodHier3": "Agregados"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "quantidade": 14,
                "prodHier3": "Impermeabilizantes"
              },
              {
                "inicioMes": "2026-09-01T00:00:00",
                "quantidade": 8,
                "prodHier3": "Cales"
              }
            ]
          },
          {
            "id": 5,
            "listagem": [
              {
                "codigoCliente": "1669301",
                "razaoSocial": "M V MATERIAIS PARA CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 15127,
                "volumeAtual": 20.86,
                "volumeAnterior": 34.84,
                "projetado": 26.017692307692364,
                "percentVolume": -0.40126291618828935,
                "percentProjetado": -0.25322352733374387,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.9978021978022,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.9978021978022,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.06,
                    "volumeAnterior": 0.04,
                    "projetado": 0.074835164835165,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.8708791208791251,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.06,
                        "volumeAnterior": 0.04,
                        "projetado": 0.074835164835165,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.8708791208791251,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 34,
                    "projetado": 24.945054945055,
                    "percentVolume": -0.4117647058823529,
                    "percentProjetado": -0.2663219133807353,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 34,
                        "projetado": 24.945054945055,
                        "percentVolume": -0.4117647058823529,
                        "percentProjetado": -0.2663219133807353,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1721038",
                "razaoSocial": "DMJ EMPREENDIMENTOS LTDA",
                "usuarioId": 892,
                "clienteId": 12397,
                "volumeAtual": 111.31200000000001,
                "volumeAnterior": 48.9,
                "projetado": 138.834197802198,
                "percentVolume": 1.2763190184049082,
                "percentProjetado": 1.8391451493292021,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 18,
                    "projetado": 22.450549450549,
                    "percentVolume": 0,
                    "percentProjetado": 0.2472527472527224,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 18,
                        "projetado": 22.450549450549,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527224,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 93.312,
                    "volumeAnterior": 30.9,
                    "projetado": 116.383648351649,
                    "percentVolume": 2.0198058252427185,
                    "percentProjetado": 2.766461111703851,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 93.312,
                        "volumeAnterior": 30.9,
                        "projetado": 116.383648351649,
                        "percentVolume": 2.0198058252427185,
                        "percentProjetado": 2.766461111703851,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1127081",
                "razaoSocial": "RENOVE MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16244,
                "volumeAtual": 50.013999999999996,
                "volumeAnterior": 74.90999999999998,
                "projetado": 62.38009890109904,
                "percentVolume": -0.3323454812441595,
                "percentProjetado": -0.1672660672660652,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.36,
                    "volumeAnterior": 0.24,
                    "projetado": 0.44901098901099,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.8708791208791251,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.36,
                        "volumeAnterior": 0.24,
                        "projetado": 0.44901098901099,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.8708791208791251,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 48,
                    "volumeAnterior": 72,
                    "projetado": 59.868131868132,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.16849816849816668,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 48,
                        "volumeAnterior": 72,
                        "projetado": 59.868131868132,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.16849816849816668,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0.27,
                    "projetado": 0.067351648351648,
                    "percentVolume": -0.8,
                    "percentProjetado": -0.7505494505494519,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.27,
                        "projetado": 0.067351648351648,
                        "percentVolume": -0.8,
                        "percentProjetado": -0.7505494505494519,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 2.4000000000000004,
                    "projetado": 1.9956043956044,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.1684981684981668,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.9978021978022,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.6,
                        "projetado": 0.9978021978022,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.37637362637362504,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1127407",
                "razaoSocial": "JOSE MARIANO DOS SANTOS",
                "usuarioId": 892,
                "clienteId": 16289,
                "volumeAtual": 55.694,
                "volumeAnterior": 57.147999999999996,
                "projetado": 69.46449450549414,
                "percentVolume": -0.02544271015608579,
                "percentProjetado": 0.21551925711300735,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.84,
                    "volumeAnterior": 0.24,
                    "projetado": 1.0476923076923,
                    "percentVolume": 2.5,
                    "percentProjetado": 3.365384615384583,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.84,
                        "volumeAnterior": 0.24,
                        "projetado": 1.0476923076923,
                        "percentVolume": 2.5,
                        "percentProjetado": 3.365384615384583,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.9978021978022,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.9978021978022,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 56,
                    "projetado": 67.351648351648,
                    "percentVolume": -0.0357142857142857,
                    "percentProjetado": 0.20270800627942842,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 56,
                        "projetado": 67.351648351648,
                        "percentVolume": -0.0357142857142857,
                        "percentProjetado": 0.20270800627942842,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0.108,
                    "projetado": 0.067351648351648,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.3763736263736296,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.054,
                        "projetado": 0.067351648351648,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274082,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1563084",
                "razaoSocial": "CASTANHEIRA PRESTADORA DE SERVICOS",
                "usuarioId": 892,
                "clienteId": 15417,
                "volumeAtual": 8.876,
                "volumeAnterior": 0.2,
                "projetado": 11.070615384615397,
                "percentVolume": 43.379999999999995,
                "percentProjetado": 54.35307692307698,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.044901098901099,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.044901098901099,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 0,
                    "projetado": 9.978021978022,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 0,
                        "projetado": 9.978021978022,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.84,
                    "volumeAnterior": 0.2,
                    "projetado": 1.0476923076923,
                    "percentVolume": 3.1999999999999993,
                    "percentProjetado": 4.238461538461499,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.84,
                        "volumeAnterior": 0.2,
                        "projetado": 1.0476923076923,
                        "percentVolume": 3.1999999999999993,
                        "percentProjetado": 4.238461538461499,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1170311",
                "razaoSocial": "M DE F OLIVEIRA",
                "usuarioId": 892,
                "clienteId": 16125,
                "volumeAtual": 30,
                "volumeAnterior": 63.4,
                "projetado": 37.417582417582,
                "percentVolume": -0.526813880126183,
                "percentProjetado": -0.4098173120255205,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 30,
                    "volumeAnterior": 48,
                    "projetado": 37.417582417582,
                    "percentVolume": -0.375,
                    "percentProjetado": -0.22046703296704173,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 30,
                        "volumeAnterior": 48,
                        "projetado": 37.417582417582,
                        "percentVolume": -0.375,
                        "percentProjetado": -0.22046703296704173,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1863089",
                "razaoSocial": "HC ENTREGA E TRANSPORTE DE MATERIAI",
                "usuarioId": 892,
                "clienteId": 1055623,
                "volumeAtual": 20.4,
                "volumeAnterior": 48.144,
                "projetado": 25.4439560439561,
                "percentVolume": -0.576271186440678,
                "percentProjetado": -0.47150307319798723,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4989010989011,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 48,
                    "projetado": 24.945054945055,
                    "percentVolume": -0.5833333333333333,
                    "percentProjetado": -0.48031135531135416,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 48,
                        "projetado": 24.945054945055,
                        "percentVolume": -0.5833333333333333,
                        "percentProjetado": -0.48031135531135416,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1145418",
                "razaoSocial": "BOHN DA VIDA MATERIAL PARA",
                "usuarioId": 892,
                "clienteId": 16279,
                "volumeAtual": 28.4,
                "volumeAnterior": 57.094,
                "projetado": 35.4219780219781,
                "percentVolume": -0.5025747013696711,
                "percentProjetado": -0.37958492973030267,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 56,
                    "projetado": 34.923076923077,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.37637362637362504,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 56,
                        "projetado": 34.923076923077,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.37637362637362504,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4989010989011,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4989010989011,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1512063",
                "razaoSocial": "FT DOS SANTOS MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 15458,
                "volumeAtual": 44.27,
                "volumeAnterior": 52.8,
                "projetado": 55.21587912087924,
                "percentVolume": -0.16155303030303025,
                "percentProjetado": 0.045755286380288585,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.27,
                    "volumeAnterior": 0,
                    "projetado": 0.33675824175824,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.27,
                        "volumeAnterior": 0,
                        "projetado": 0.33675824175824,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 44,
                    "volumeAnterior": 52,
                    "projetado": 54.879120879121,
                    "percentVolume": -0.15384615384615385,
                    "percentProjetado": 0.05536770921386536,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 44,
                        "volumeAnterior": 52,
                        "projetado": 54.879120879121,
                        "percentVolume": -0.15384615384615385,
                        "percentProjetado": 0.05536770921386536,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1056890",
                "razaoSocial": "COMERCIAL JACARE MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16336,
                "volumeAtual": 134.06799999999998,
                "volumeAnterior": 122.712,
                "projetado": 167.216681318681,
                "percentVolume": 0.09254188669404773,
                "percentProjetado": 0.36267586966784826,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 84.068,
                    "volumeAnterior": 52.712,
                    "projetado": 104.854043956044,
                    "percentVolume": 0.5948550614660797,
                    "percentProjetado": 0.9891873568835177,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 84.068,
                        "volumeAnterior": 52.712,
                        "projetado": 104.854043956044,
                        "percentVolume": 0.5948550614660797,
                        "percentProjetado": 0.9891873568835177,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 50,
                    "volumeAnterior": 70,
                    "projetado": 62.362637362637,
                    "percentVolume": -0.2857142857142857,
                    "percentProjetado": -0.10910518053375706,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 50,
                        "volumeAnterior": 70,
                        "projetado": 62.362637362637,
                        "percentVolume": -0.2857142857142857,
                        "percentProjetado": -0.10910518053375706,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1060546",
                "razaoSocial": "MADESUL MADEIRAS E MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16297,
                "volumeAtual": 252,
                "volumeAnterior": 360.46000000000004,
                "projetado": 314.30769230769,
                "percentVolume": -0.3008933030017201,
                "percentProjetado": -0.1280372515461079,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 252,
                    "volumeAnterior": 266,
                    "projetado": 314.30769230769,
                    "percentVolume": -0.052631578947368474,
                    "percentProjetado": 0.1816078658183835,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 252,
                        "volumeAnterior": 266,
                        "projetado": 314.30769230769,
                        "percentVolume": -0.052631578947368474,
                        "percentProjetado": 0.1816078658183835,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1401430",
                "razaoSocial": "G  DOS S  MELLO",
                "usuarioId": 892,
                "clienteId": 15881,
                "volumeAtual": 4,
                "volumeAnterior": 0,
                "projetado": 4.989010989011,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4.989010989011,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4.989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1475913",
                "razaoSocial": "MARCOS CLAROS ESPINOZA LTDA",
                "usuarioId": 892,
                "clienteId": 15637,
                "volumeAtual": 88.74000000000001,
                "volumeAnterior": 204.2,
                "projetado": 110.681208791209,
                "percentVolume": -0.5654260528893241,
                "percentProjetado": -0.4579764505817384,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 54,
                    "projetado": 34.923076923077,
                    "percentVolume": -0.4814814814814815,
                    "percentProjetado": -0.3532763532763519,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 54,
                        "projetado": 34.923076923077,
                        "percentVolume": -0.4814814814814815,
                        "percentProjetado": -0.3532763532763519,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 60.74,
                    "volumeAnterior": 150.2,
                    "projetado": 75.758131868132,
                    "percentVolume": -0.5956058588548601,
                    "percentProjetado": -0.4956182964838083,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 60.74,
                        "volumeAnterior": 150.2,
                        "projetado": 75.758131868132,
                        "percentVolume": -0.5956058588548601,
                        "percentProjetado": -0.4956182964838083,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1783291",
                "razaoSocial": "VERISSIMO COMERCIO LTDA",
                "usuarioId": 892,
                "clienteId": 14608,
                "volumeAtual": 16.799999999999997,
                "volumeAnterior": 7.2,
                "projetado": 20.9538461538462,
                "percentVolume": 1.333333333333333,
                "percentProjetado": 1.9102564102564168,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 6,
                    "projetado": 19.956043956044,
                    "percentVolume": 1.6666666666666665,
                    "percentProjetado": 2.3260073260073333,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 6,
                        "projetado": 19.956043956044,
                        "percentVolume": 1.6666666666666665,
                        "percentProjetado": 2.3260073260073333,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 1.2000000000000002,
                    "projetado": 0.9978021978022,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.1684981684981668,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4989010989011,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1885287",
                "razaoSocial": "R  L  BRAGA LTDA",
                "usuarioId": 892,
                "clienteId": 1093541,
                "volumeAtual": 4,
                "volumeAnterior": 4,
                "projetado": 4.989010989011,
                "percentVolume": 0,
                "percentProjetado": 0.24725274725274993,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 4,
                    "projetado": 4.989010989011,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 2,
                        "projetado": 4.989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1.4945054945054999,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1527581",
                "razaoSocial": "ALVES CONSTRUCAO E AGRO LTDA",
                "usuarioId": 892,
                "clienteId": 15429,
                "volumeAtual": 28,
                "volumeAnterior": 42,
                "projetado": 34.923076923077,
                "percentVolume": -0.33333333333333337,
                "percentProjetado": -0.16849816849816668,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 42,
                    "projetado": 34.923076923077,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.16849816849816668,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 42,
                        "projetado": 34.923076923077,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.16849816849816668,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1809150",
                "razaoSocial": "J  E  S  MORON LTDA",
                "usuarioId": 892,
                "clienteId": 28606,
                "volumeAtual": 92.36,
                "volumeAnterior": 56.68,
                "projetado": 115.19626373626352,
                "percentVolume": 0.629498941425547,
                "percentProjetado": 1.0323970313384532,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 26,
                    "projetado": 2.4945054945055,
                    "percentVolume": -0.9230769230769231,
                    "percentProjetado": -0.9040574809805577,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 26,
                        "projetado": 2.4945054945055,
                        "percentVolume": -0.9230769230769231,
                        "percentProjetado": -0.9040574809805577,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 90.36,
                    "volumeAnterior": 30.68,
                    "projetado": 112.701758241758,
                    "percentVolume": 1.9452411994784877,
                    "percentProjetado": 2.6734601773715125,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 59.12,
                        "volumeAnterior": 0,
                        "projetado": 73.737582417582,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Outros",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 31.24,
                        "volumeAnterior": 30.68,
                        "projetado": 38.964175824176,
                        "percentVolume": 0.018252933507170832,
                        "percentProjetado": 0.27001876871499353,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1658949",
                "razaoSocial": "SILVA & TORRES MATERIAIS PARA",
                "usuarioId": 892,
                "clienteId": 15211,
                "volumeAtual": 20.072,
                "volumeAnterior": 24.8,
                "projetado": 25.034857142857195,
                "percentVolume": -0.1906451612903226,
                "percentProjetado": 0.009470046082951322,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 24,
                    "projetado": 24.945054945055,
                    "percentVolume": -0.16666666666666663,
                    "percentProjetado": 0.03937728937729168,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 24,
                        "projetado": 24.945054945055,
                        "percentVolume": -0.16666666666666663,
                        "percentProjetado": 0.03937728937729168,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.072,
                    "volumeAnterior": 0,
                    "projetado": 0.089802197802198,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.072,
                        "volumeAnterior": 0,
                        "projetado": 0.089802197802198,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1584302",
                "razaoSocial": "JULIO MANOEL DA SILVA NETO LTDA",
                "usuarioId": 892,
                "clienteId": 15480,
                "volumeAtual": 36,
                "volumeAnterior": 48,
                "projetado": 44.901098901099,
                "percentVolume": -0.25,
                "percentProjetado": -0.06456043956043755,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 36,
                    "volumeAnterior": 48,
                    "projetado": 44.901098901099,
                    "percentVolume": -0.25,
                    "percentProjetado": -0.06456043956043755,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 36,
                        "volumeAnterior": 48,
                        "projetado": 44.901098901099,
                        "percentVolume": -0.25,
                        "percentProjetado": -0.06456043956043755,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1779252",
                "razaoSocial": "G & A COMERCIO E SERVICOS LTDA",
                "usuarioId": 892,
                "clienteId": 14648,
                "volumeAtual": 20,
                "volumeAnterior": 22,
                "projetado": 24.945054945055,
                "percentVolume": -0.09090909090909094,
                "percentProjetado": 0.13386613386613622,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 22,
                    "projetado": 24.945054945055,
                    "percentVolume": -0.09090909090909094,
                    "percentProjetado": 0.13386613386613622,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 20,
                        "projetado": 24.945054945055,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 2,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1125047",
                "razaoSocial": "ITALAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16318,
                "volumeAtual": 69.726,
                "volumeAnterior": 43.674,
                "projetado": 86.96594505494525,
                "percentVolume": 0.5965105096853964,
                "percentProjetado": 0.9912521192229988,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 68,
                    "volumeAnterior": 42,
                    "projetado": 84.813186813187,
                    "percentVolume": 0.6190476190476191,
                    "percentProjetado": 1.0193615907901665,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 68,
                        "volumeAnterior": 42,
                        "projetado": 84.813186813187,
                        "percentVolume": 0.6190476190476191,
                        "percentProjetado": 1.0193615907901665,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.126,
                    "volumeAnterior": 0.054,
                    "projetado": 0.157153846153849,
                    "percentVolume": 1.3333333333333335,
                    "percentProjetado": 1.910256410256463,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0.054,
                        "projetado": 0.1347032967033,
                        "percentVolume": 1,
                        "percentProjetado": 1.4945054945055558,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.018,
                        "volumeAnterior": 0,
                        "projetado": 0.022450549450549,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo de Aderência",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 1.6,
                    "projetado": 1.9956043956044,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 1.6,
                        "projetado": 1.9956043956044,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1793420",
                "razaoSocial": "TALITA COSTA DE SOUZA",
                "usuarioId": 892,
                "clienteId": 14643,
                "volumeAtual": 12,
                "volumeAnterior": 16,
                "projetado": 14.967032967033,
                "percentVolume": -0.25,
                "percentProjetado": -0.06456043956043755,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 16,
                    "projetado": 14.967032967033,
                    "percentVolume": -0.25,
                    "percentProjetado": -0.06456043956043755,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 16,
                        "projetado": 14.967032967033,
                        "percentVolume": -0.25,
                        "percentProjetado": -0.06456043956043755,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1830860",
                "razaoSocial": "K L J ELETRICA & CONSTRUCOES LTDA",
                "usuarioId": 892,
                "clienteId": 623958,
                "volumeAtual": 14,
                "volumeAnterior": 10,
                "projetado": 17.461538461538,
                "percentVolume": 0.3999999999999999,
                "percentProjetado": 0.7461538461538002,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 10,
                    "projetado": 17.461538461538,
                    "percentVolume": 0.3999999999999999,
                    "percentProjetado": 0.7461538461538002,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 10,
                        "projetado": 17.461538461538,
                        "percentVolume": 0.3999999999999999,
                        "percentProjetado": 0.7461538461538002,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1894886",
                "razaoSocial": "62 594 274 VILMA DINIZ DE ARRUDA",
                "usuarioId": 892,
                "clienteId": 1116248,
                "volumeAtual": 6,
                "volumeAnterior": 6,
                "projetado": 7.4835164835165,
                "percentVolume": 0,
                "percentProjetado": 0.24725274725274993,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 6,
                    "projetado": 7.4835164835165,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 6,
                        "projetado": 7.4835164835165,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1699502",
                "razaoSocial": "M  M  DE MATTOS LTDA",
                "usuarioId": 892,
                "clienteId": 15139,
                "volumeAtual": 41.6,
                "volumeAnterior": 40.854,
                "projetado": 51.8857142857139,
                "percentVolume": 0.018260145885347967,
                "percentProjetado": 0.27002776437347387,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 3.6,
                    "volumeAnterior": 2.8,
                    "projetado": 4.4901098901099,
                    "percentVolume": 0.2857142857142858,
                    "percentProjetado": 0.60361067503925,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 0.8,
                        "projetado": 1.9956043956044,
                        "percentVolume": 1,
                        "percentProjetado": 1.4945054945054999,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 1.2,
                        "projetado": 2.4945054945055,
                        "percentVolume": 0.6666666666666667,
                        "percentProjetado": 1.0787545787545834,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 38,
                    "volumeAnterior": 38,
                    "projetado": 47.395604395604,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725273683,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 38,
                        "volumeAnterior": 38,
                        "projetado": 47.395604395604,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725273683,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1377304",
                "razaoSocial": "DOMINGOS E GOMES LTDA",
                "usuarioId": 892,
                "clienteId": 17394,
                "volumeAtual": 12.108,
                "volumeAnterior": 14.436,
                "projetado": 15.1017362637363,
                "percentVolume": -0.16126350789692434,
                "percentProjetado": 0.04611639399669576,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0.036,
                    "projetado": 0.1347032967033,
                    "percentVolume": 2,
                    "percentProjetado": 2.7417582417583337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0.036,
                        "projetado": 0.1347032967033,
                        "percentVolume": 2,
                        "percentProjetado": 2.7417582417583337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 14,
                    "projetado": 14.967032967033,
                    "percentVolume": -0.1428571428571429,
                    "percentProjetado": 0.06907378335949987,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 14,
                        "projetado": 14.967032967033,
                        "percentVolume": -0.1428571428571429,
                        "percentProjetado": 0.06907378335949987,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1062632",
                "razaoSocial": "G5 CASA & CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 649981,
                "volumeAtual": 8.4,
                "volumeAnterior": 8.4,
                "projetado": 10.4769230769231,
                "percentVolume": 0,
                "percentProjetado": 0.24725274725274993,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4989010989011,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4989010989011,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 8,
                    "projetado": 9.978021978022,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 8,
                        "projetado": 9.978021978022,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1334606",
                "razaoSocial": "JOSE DE SOUZA AGUIAR E CIA LTDA",
                "usuarioId": 892,
                "clienteId": 16014,
                "volumeAtual": 8,
                "volumeAnterior": 70.162,
                "projetado": 9.978021978022,
                "percentVolume": -0.8859781648185627,
                "percentProjetado": -0.8577859528231522,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 70,
                    "projetado": 9.978021978022,
                    "percentVolume": -0.8857142857142857,
                    "percentProjetado": -0.8574568288854,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 70,
                        "projetado": 9.978021978022,
                        "percentVolume": -0.8857142857142857,
                        "percentProjetado": -0.8574568288854,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1730277",
                "razaoSocial": "SUPERMERCADO ROCHEDO LTDA",
                "usuarioId": 892,
                "clienteId": 15056,
                "volumeAtual": 28,
                "volumeAnterior": 56.55800000000001,
                "projetado": 34.923076923077,
                "percentVolume": -0.5049329891438877,
                "percentProjetado": -0.382526310635507,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 56,
                    "projetado": 34.923076923077,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.37637362637362504,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 56,
                        "projetado": 34.923076923077,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.37637362637362504,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1558982",
                "razaoSocial": "BALBINO E BARBOSA LTDA",
                "usuarioId": 892,
                "clienteId": 15468,
                "volumeAtual": 26.8,
                "volumeAnterior": 41.6,
                "projetado": 33.4263736263732,
                "percentVolume": -0.3557692307692307,
                "percentProjetado": -0.19648140321218277,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 40,
                    "projetado": 32.428571428571,
                    "percentVolume": -0.35,
                    "percentProjetado": -0.18928571428572505,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 40,
                        "projetado": 32.428571428571,
                        "percentVolume": -0.35,
                        "percentProjetado": -0.18928571428572505,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 1.6,
                    "projetado": 0.9978021978022,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.37637362637362504,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.6,
                        "projetado": 0.9978021978022,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.37637362637362504,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1415861",
                "razaoSocial": "LUANA CLAUDIA GALESKI PESUSKI",
                "usuarioId": 892,
                "clienteId": 15850,
                "volumeAtual": 6,
                "volumeAnterior": 10.036,
                "projetado": 7.4835164835165,
                "percentVolume": -0.4021522518931845,
                "percentProjetado": -0.2543327537349044,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 10,
                    "projetado": 7.4835164835165,
                    "percentVolume": -0.4,
                    "percentProjetado": -0.2516483516483501,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 10,
                        "projetado": 7.4835164835165,
                        "percentVolume": -0.4,
                        "percentProjetado": -0.2516483516483501,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1058301",
                "razaoSocial": "HUGO LANDIVAR LTDA",
                "usuarioId": 892,
                "clienteId": 16290,
                "volumeAtual": 2,
                "volumeAnterior": 6,
                "projetado": 2.4945054945055,
                "percentVolume": -0.6666666666666667,
                "percentProjetado": -0.5842490842490833,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 6,
                    "projetado": 2.4945054945055,
                    "percentVolume": -0.6666666666666667,
                    "percentProjetado": -0.5842490842490833,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 6,
                        "projetado": 2.4945054945055,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.5842490842490833,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1080145",
                "razaoSocial": "PIRES MARTINS & MARTINS LTDA",
                "usuarioId": 892,
                "clienteId": 16223,
                "volumeAtual": 14.036,
                "volumeAnterior": 14.036,
                "projetado": 17.5064395604391,
                "percentVolume": 0,
                "percentProjetado": 0.24725274725271462,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 17.461538461538,
                    "percentVolume": 0,
                    "percentProjetado": 0.2472527472527144,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 17.461538461538,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527144,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0.036,
                    "projetado": 0.044901098901099,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725275015,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.044901098901099,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1458429",
                "razaoSocial": "AGRO SHOPPING LTDA",
                "usuarioId": 892,
                "clienteId": 15688,
                "volumeAtual": 14,
                "volumeAnterior": 28.24,
                "projetado": 17.461538461538,
                "percentVolume": -0.5042492917847026,
                "percentProjetado": -0.38167356722599144,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 28,
                    "projetado": 17.461538461538,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.3763736263736428,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 28,
                        "projetado": 17.461538461538,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.3763736263736428,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1827357",
                "razaoSocial": "E  R  O  FORTE LTDA",
                "usuarioId": 892,
                "clienteId": 464151,
                "volumeAtual": 14.4,
                "volumeAnterior": 14.036,
                "projetado": 17.960439560439102,
                "percentVolume": 0.025933314334568358,
                "percentProjetado": 0.27959814480187406,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4989010989011,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 17.461538461538,
                    "percentVolume": 0,
                    "percentProjetado": 0.2472527472527144,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 17.461538461538,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527144,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1875709",
                "razaoSocial": "UNIAO MATERIAIS DE CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 1079118,
                "volumeAtual": 10,
                "volumeAnterior": 10,
                "projetado": 12.472527472527,
                "percentVolume": 0,
                "percentProjetado": 0.24725274725269997,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 10,
                    "projetado": 12.472527472527,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725269997,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 10,
                        "projetado": 12.472527472527,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725269997,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1820312",
                "razaoSocial": "WOLNEY GABRYELL NUNES DE CAMARGO LT",
                "usuarioId": 892,
                "clienteId": 397927,
                "volumeAtual": 13.28,
                "volumeAnterior": 20.02,
                "projetado": 16.56351648351656,
                "percentVolume": -0.3366633366633367,
                "percentProjetado": -0.17265152429987218,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.28,
                    "volumeAnterior": 0,
                    "projetado": 1.59648351648356,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0,
                        "projetado": 0.29934065934066,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.04,
                        "volumeAnterior": 0,
                        "projetado": 1.2971428571429,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 20,
                    "projetado": 14.967032967033,
                    "percentVolume": -0.4,
                    "percentProjetado": -0.2516483516483501,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 20,
                        "projetado": 14.967032967033,
                        "percentVolume": -0.4,
                        "percentProjetado": -0.2516483516483501,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1835859",
                "razaoSocial": "AERO LAR UTILIDADES LTDA",
                "usuarioId": 892,
                "clienteId": 644124,
                "volumeAtual": 2,
                "volumeAnterior": 6,
                "projetado": 2.4945054945055,
                "percentVolume": -0.6666666666666667,
                "percentProjetado": -0.5842490842490833,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 6,
                    "projetado": 2.4945054945055,
                    "percentVolume": -0.6666666666666667,
                    "percentProjetado": -0.5842490842490833,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 6,
                        "projetado": 2.4945054945055,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.5842490842490833,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1532186",
                "razaoSocial": "COOPERATIVA AGROINDUSTRIAL ALFA",
                "usuarioId": 892,
                "clienteId": 15506,
                "volumeAtual": 14,
                "volumeAnterior": 14,
                "projetado": 17.461538461538,
                "percentVolume": 0,
                "percentProjetado": 0.2472527472527144,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 17.461538461538,
                    "percentVolume": 0,
                    "percentProjetado": 0.2472527472527144,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 17.461538461538,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527144,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1790769",
                "razaoSocial": "J&F SOLUCOES EM MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 14629,
                "volumeAtual": 6.036,
                "volumeAnterior": 0,
                "projetado": 7.528417582417598,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 7.4835164835165,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 7.4835164835165,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.044901098901098,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.018,
                        "volumeAnterior": 0,
                        "projetado": 0.022450549450549,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.018,
                        "volumeAnterior": 0,
                        "projetado": 0.022450549450549,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1937359",
                "razaoSocial": "G  GRACIELA OLIVEIRA DE SOUZA E M",
                "usuarioId": 892,
                "clienteId": 1174170,
                "volumeAtual": 6.800000000000001,
                "volumeAnterior": 11.479999999999999,
                "projetado": 8.4813186813187,
                "percentVolume": -0.4076655052264807,
                "percentProjetado": -0.2612091741011585,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 10,
                    "projetado": 7.4835164835165,
                    "percentVolume": -0.4,
                    "percentProjetado": -0.2516483516483501,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 10,
                        "projetado": 7.4835164835165,
                        "percentVolume": -0.4,
                        "percentProjetado": -0.2516483516483501,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.9978021978022,
                    "percentVolume": 0,
                    "percentProjetado": 0.24725274725274993,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4989010989011,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725274993,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1097413",
                "razaoSocial": "JEFERSON DIAS DE VASCONCELOS",
                "usuarioId": 892,
                "clienteId": 16268,
                "volumeAtual": 14.52,
                "volumeAnterior": 0,
                "projetado": 18.11010989010938,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4.16,
                    "volumeAnterior": 0,
                    "projetado": 5.1885714285714,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 4.16,
                        "volumeAnterior": 0,
                        "projetado": 5.1885714285714,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.36,
                    "volumeAnterior": 0,
                    "projetado": 0.44901098901098,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.18,
                        "volumeAnterior": 0,
                        "projetado": 0.22450549450549,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.18,
                        "volumeAnterior": 0,
                        "projetado": 0.22450549450549,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 12.472527472527,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 12.472527472527,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1702388",
                "razaoSocial": "BRENO ANTHONY LACERDA",
                "usuarioId": 892,
                "clienteId": 15199,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2.4945054945055,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2.4945054945055,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2.4945054945055,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1495935",
                "razaoSocial": "T C F MATERIAIS DE CONSTRUCAO EIREL",
                "usuarioId": 892,
                "clienteId": 15568,
                "volumeAtual": 4.04,
                "volumeAnterior": 0,
                "projetado": 5.03890109890111,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4.989010989011,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4.989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0,
                    "projetado": 0.04989010989011,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0,
                        "projetado": 0.04989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1217329",
                "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                "usuarioId": 892,
                "clienteId": 16133,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2.4945054945055,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2.4945054945055,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2.4945054945055,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1058365",
                "razaoSocial": "JOAO MARIA NANTES DE SOUZA",
                "usuarioId": 892,
                "clienteId": 16295,
                "volumeAtual": 2.36,
                "volumeAnterior": 0,
                "projetado": 2.9435164835164898,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2.4945054945055,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2.4945054945055,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.36,
                    "volumeAnterior": 0,
                    "projetado": 0.44901098901099,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.36,
                        "volumeAnterior": 0,
                        "projetado": 0.44901098901099,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1391694",
                "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                "grupoCentralizador": "LEROY MERLIN",
                "usuarioId": 892,
                "clienteId": 57075,
                "volumeAtual": 42,
                "volumeAnterior": 28,
                "projetado": 52.384615384615,
                "percentVolume": 0.5,
                "percentProjetado": 0.8708791208791073,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 28,
                    "projetado": 52.384615384615,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.8708791208791073,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 28,
                        "projetado": 52.384615384615,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.8708791208791073,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1057754",
                "razaoSocial": "GUARAPORA MATERIAIS PARA CONSTRUCAO",
                "grupoCentralizador": "FERRAGENS BARATAO",
                "usuarioId": 892,
                "clienteId": 16219,
                "volumeAtual": 4,
                "volumeAnterior": 6.4,
                "projetado": 4.989010989011,
                "percentVolume": -0.375,
                "percentProjetado": -0.2204670329670313,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 6,
                    "projetado": 4.989010989011,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.16849816849816668,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 6,
                        "projetado": 4.989010989011,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.16849816849816668,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1552268",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116105,
                "volumeAtual": 18,
                "volumeAnterior": 2,
                "projetado": 22.450549450549,
                "percentVolume": 8,
                "percentProjetado": 10.2252747252745,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 2,
                    "projetado": 22.450549450549,
                    "percentVolume": 8,
                    "percentProjetado": 10.2252747252745,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 2,
                        "projetado": 22.450549450549,
                        "percentVolume": 8,
                        "percentProjetado": 10.2252747252745,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1529731",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116104,
                "volumeAtual": 54,
                "volumeAnterior": 111.8,
                "projetado": 67.351648351648,
                "percentVolume": -0.516994633273703,
                "percentProjetado": -0.3975702294128086,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 104,
                    "projetado": 67.351648351648,
                    "percentVolume": -0.4807692307692307,
                    "percentProjetado": -0.3523879966187693,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 104,
                        "projetado": 67.351648351648,
                        "percentVolume": -0.4807692307692307,
                        "percentProjetado": -0.3523879966187693,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1060663",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 20743,
                "volumeAtual": 10,
                "volumeAnterior": 14,
                "projetado": 12.472527472527,
                "percentVolume": -0.2857142857142857,
                "percentProjetado": -0.1091051805337857,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 14,
                    "projetado": 12.472527472527,
                    "percentVolume": -0.2857142857142857,
                    "percentProjetado": -0.1091051805337857,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 14,
                        "projetado": 12.472527472527,
                        "percentVolume": -0.2857142857142857,
                        "percentProjetado": -0.1091051805337857,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1367137",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 8231,
                "volumeAtual": 1246.08,
                "volumeAnterior": 2488.1200000000003,
                "projetado": 1554.17670329675,
                "percentVolume": -0.4991881420510266,
                "percentProjetado": -0.37536103431637147,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 38.08,
                    "volumeAnterior": 14.040000000000001,
                    "projetado": 47.4953846153846,
                    "percentVolume": 1.7122507122507118,
                    "percentProjetado": 2.3828621520929203,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 24.96,
                        "volumeAnterior": 12.48,
                        "projetado": 31.131428571429,
                        "percentVolume": 1,
                        "percentProjetado": 1.4945054945055287,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 3.12,
                        "volumeAnterior": 1.56,
                        "projetado": 3.8914285714286,
                        "percentVolume": 1,
                        "percentProjetado": 1.4945054945055127,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 12.472527472527,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Liga para Massa",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 38,
                    "projetado": 7.4835164835165,
                    "percentVolume": -0.8421052631578947,
                    "percentProjetado": -0.8030653556969343,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 7.4835164835165,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1202,
                    "volumeAnterior": 2432,
                    "projetado": 1499.197802197849,
                    "percentVolume": -0.5057565789473684,
                    "percentProjetado": -0.38355353528048974,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 36,
                        "volumeAnterior": 32,
                        "projetado": 44.901098901099,
                        "percentVolume": 0.125,
                        "percentProjetado": 0.40315934065934367,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1166,
                        "volumeAnterior": 2400,
                        "projetado": 1454.29670329675,
                        "percentVolume": -0.5141666666666667,
                        "percentProjetado": -0.39404304029302084,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1186391",
                "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                "grupoCentralizador": "ESMAEL",
                "usuarioId": 892,
                "clienteId": 16081,
                "volumeAtual": 84.344,
                "volumeAnterior": 176.83800000000002,
                "projetado": 105.19828571428494,
                "percentVolume": -0.5230436897047015,
                "percentProjetado": -0.4051149316646596,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 84,
                    "volumeAnterior": 176,
                    "projetado": 104.76923076923,
                    "percentVolume": -0.5227272727272727,
                    "percentProjetado": -0.404720279720284,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 84,
                        "volumeAnterior": 176,
                        "projetado": 104.76923076923,
                        "percentVolume": -0.5227272727272727,
                        "percentProjetado": -0.404720279720284,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0.06,
                    "projetado": 0.024945054945055,
                    "percentVolume": -0.6666666666666666,
                    "percentProjetado": -0.5842490842490833,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0.06,
                        "projetado": 0.024945054945055,
                        "percentVolume": -0.6666666666666666,
                        "percentProjetado": -0.5842490842490833,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.324,
                    "volumeAnterior": 0.378,
                    "projetado": 0.40410989010989,
                    "percentVolume": -0.1428571428571428,
                    "percentProjetado": 0.06907378335949743,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0.108,
                        "projetado": 0.1347032967033,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527779,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.216,
                        "volumeAnterior": 0.216,
                        "projetado": 0.26940659340659,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527315,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1206763",
                "razaoSocial": "WANDERSON S GALVAO",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16139,
                "volumeAtual": 121.88,
                "volumeAnterior": 68.24000000000001,
                "projetado": 152.0151648351647,
                "percentVolume": 0.7860492379835871,
                "percentProjetado": 1.2276548188037029,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 118,
                    "volumeAnterior": 68,
                    "projetado": 147.175824175824,
                    "percentVolume": 0.7352941176470589,
                    "percentProjetado": 1.1643503555268238,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 118,
                        "volumeAnterior": 68,
                        "projetado": 147.175824175824,
                        "percentVolume": 0.7352941176470589,
                        "percentProjetado": 1.1643503555268238,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 3.8800000000000003,
                    "volumeAnterior": 0.24,
                    "projetado": 4.8393406593406905,
                    "percentVolume": 15.166666666666668,
                    "percentProjetado": 19.163919413919544,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 3.64,
                        "volumeAnterior": 0,
                        "projetado": 4.54000000000003,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0.24,
                        "projetado": 0.29934065934066,
                        "percentVolume": 0,
                        "percentProjetado": 0.24725274725275015,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1536936",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 15498,
                "volumeAtual": 32,
                "volumeAnterior": 64,
                "projetado": 39.912087912088,
                "percentVolume": -0.5,
                "percentProjetado": -0.37637362637362504,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 32,
                    "volumeAnterior": 64,
                    "projetado": 39.912087912088,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.37637362637362504,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 32,
                        "volumeAnterior": 64,
                        "projetado": 39.912087912088,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.37637362637362504,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1049264",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16403,
                "volumeAtual": 600.816,
                "volumeAnterior": 938.1099999999999,
                "projetado": 749.3694065934101,
                "percentVolume": -0.35954632185990976,
                "percentProjetado": -0.20119239045164194,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 352,
                    "volumeAnterior": 416,
                    "projetado": 439.03296703297,
                    "percentVolume": -0.15384615384615385,
                    "percentProjetado": 0.05536770921387024,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 352,
                        "volumeAnterior": 416,
                        "projetado": 439.03296703297,
                        "percentVolume": -0.15384615384615385,
                        "percentProjetado": 0.05536770921387024,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 248.816,
                    "volumeAnterior": 515.87,
                    "projetado": 310.33643956044,
                    "percentVolume": -0.5176769341113071,
                    "percentProjetado": -0.39842123100695914,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 248.816,
                        "volumeAnterior": 515.87,
                        "projetado": 310.33643956044,
                        "percentVolume": -0.5176769341113071,
                        "percentProjetado": -0.39842123100695914,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1476567",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15629,
                "volumeAtual": 28.49,
                "volumeAnterior": 42,
                "projetado": 35.534230769230845,
                "percentVolume": -0.32166666666666666,
                "percentProjetado": -0.1539468864468846,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4989010989011,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4989010989011,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 42,
                    "projetado": 34.923076923077,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.16849816849816668,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 42,
                        "projetado": 34.923076923077,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.16849816849816668,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.09,
                    "volumeAnterior": 0,
                    "projetado": 0.11225274725275,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.09,
                        "volumeAnterior": 0,
                        "projetado": 0.11225274725275,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1548795",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15437,
                "volumeAtual": 14.054,
                "volumeAnterior": 14,
                "projetado": 17.528890109889648,
                "percentVolume": 0.0038571428571427813,
                "percentProjetado": 0.2520635792778321,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 17.461538461538,
                    "percentVolume": 0,
                    "percentProjetado": 0.2472527472527144,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 17.461538461538,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527144,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.067351648351648,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.067351648351648,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1660429",
                "razaoSocial": "SERTAO COMERCIAL DE EQUIPAMENTOS LT",
                "grupoCentralizador": "SERTÃO",
                "usuarioId": 892,
                "clienteId": 15229,
                "volumeAtual": 14,
                "volumeAnterior": 15.56,
                "projetado": 17.461538461538,
                "percentVolume": -0.10025706940874035,
                "percentProjetado": 0.12220684200115683,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 17.461538461538,
                    "percentVolume": 0,
                    "percentProjetado": 0.2472527472527144,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 17.461538461538,
                        "percentVolume": 0,
                        "percentProjetado": 0.2472527472527144,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1473763",
                "razaoSocial": "WILIAN DA CUNHA",
                "grupoCentralizador": "WILIAN DA CUNHA",
                "usuarioId": 892,
                "clienteId": 15616,
                "volumeAtual": 13.04,
                "volumeAnterior": 14.054,
                "projetado": 16.2641758241759,
                "percentVolume": -0.0721502775010674,
                "percentProjetado": 0.15726311542449833,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 14,
                    "projetado": 14.967032967033,
                    "percentVolume": -0.1428571428571429,
                    "percentProjetado": 0.06907378335949987,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 14,
                        "projetado": 14.967032967033,
                        "percentVolume": -0.1428571428571429,
                        "percentProjetado": 0.06907378335949987,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.04,
                    "volumeAnterior": 0,
                    "projetado": 1.2971428571429,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.04,
                        "volumeAnterior": 0,
                        "projetado": 1.2971428571429,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1463567",
                "razaoSocial": "CECOM COMERCIO DE MATERIAIS PARA",
                "grupoCentralizador": "CECOM",
                "usuarioId": 892,
                "clienteId": 15780,
                "volumeAtual": 105.044,
                "volumeAnterior": 76,
                "projetado": 131.016417582418,
                "percentVolume": 0.38215789473684203,
                "percentProjetado": 0.7239002313476053,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 48,
                    "volumeAnterior": 76,
                    "projetado": 59.868131868132,
                    "percentVolume": -0.368421052631579,
                    "percentProjetado": -0.21226142278773685,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 48,
                        "volumeAnterior": 76,
                        "projetado": 59.868131868132,
                        "percentVolume": -0.368421052631579,
                        "percentProjetado": -0.21226142278773685,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 57.044,
                    "volumeAnterior": 0,
                    "projetado": 71.148285714286,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 57.044,
                        "volumeAnterior": 0,
                        "projetado": 71.148285714286,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1917096",
                "razaoSocial": "2J MIX LTDA",
                "grupoCentralizador": "BOVEDA",
                "usuarioId": 892,
                "clienteId": 1147717,
                "volumeAtual": 6.054,
                "volumeAnterior": 0,
                "projetado": 7.550868131868148,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.067351648351648,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.067351648351648,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 7.4835164835165,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 7.4835164835165,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-09-01T00:00:00"
              },
              {
                "codigoCliente": "1779252",
                "razaoSocial": "G & A COMERCIO E SERVICOS LTDA",
                "usuarioId": 892,
                "clienteId": 14648,
                "volumeAtual": 22,
                "volumeAnterior": 6,
                "projetado": 22,
                "percentVolume": 2.6666666666666665,
                "percentProjetado": 2.6666666666666665,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 22,
                    "volumeAnterior": 6,
                    "projetado": 22,
                    "percentVolume": 2.6666666666666665,
                    "percentProjetado": 2.6666666666666665,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 6,
                        "projetado": 20,
                        "percentVolume": 2.3333333333333335,
                        "percentProjetado": 2.3333333333333335,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1125047",
                "razaoSocial": "ITALAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16318,
                "volumeAtual": 43.674,
                "volumeAnterior": 90.126,
                "projetado": 43.674,
                "percentVolume": -0.5154117568737102,
                "percentProjetado": -0.5154117568737102,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0.126,
                    "projetado": 0.054,
                    "percentVolume": -0.5714285714285714,
                    "percentProjetado": -0.5714285714285714,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.09,
                        "projetado": 0.054,
                        "percentVolume": -0.4,
                        "percentProjetado": -0.4,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 0,
                    "projetado": 1.6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 0,
                        "projetado": 1.6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 90,
                    "projetado": 42,
                    "percentVolume": -0.5333333333333333,
                    "percentProjetado": -0.5333333333333333,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 90,
                        "projetado": 42,
                        "percentVolume": -0.5333333333333333,
                        "percentProjetado": -0.5333333333333333,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1145418",
                "razaoSocial": "BOHN DA VIDA MATERIAL PARA",
                "usuarioId": 892,
                "clienteId": 16279,
                "volumeAtual": 57.094,
                "volumeAnterior": 20.8,
                "projetado": 57.094,
                "percentVolume": 1.744903846153846,
                "percentProjetado": 1.744903846153846,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 56,
                    "volumeAnterior": 20,
                    "projetado": 56,
                    "percentVolume": 1.7999999999999998,
                    "percentProjetado": 1.7999999999999998,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 56,
                        "volumeAnterior": 20,
                        "projetado": 56,
                        "percentVolume": 1.7999999999999998,
                        "percentProjetado": 1.7999999999999998,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.64,
                    "volumeAnterior": 0,
                    "projetado": 0.64,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.12,
                        "volumeAnterior": 0,
                        "projetado": 0.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.8,
                    "projetado": 0.4,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.8,
                        "projetado": 0.4,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1936727",
                "razaoSocial": "SOLUTION BUSINESS PRESTACAO DE",
                "usuarioId": 892,
                "clienteId": 1173270,
                "volumeAtual": 119.2,
                "volumeAnterior": 0,
                "projetado": 119.2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 119.2,
                    "volumeAnterior": 0,
                    "projetado": 119.2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 119.2,
                        "volumeAnterior": 0,
                        "projetado": 119.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1402454",
                "razaoSocial": "D  H  MOYA DIONISIO",
                "usuarioId": 892,
                "clienteId": 15865,
                "volumeAtual": 14.054,
                "volumeAnterior": 56.216,
                "projetado": 14.054,
                "percentVolume": -0.75,
                "percentProjetado": -0.75,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 56,
                    "projetado": 14,
                    "percentVolume": -0.75,
                    "percentProjetado": -0.75,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 56,
                        "projetado": 14,
                        "percentVolume": -0.75,
                        "percentProjetado": -0.75,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0.216,
                    "projetado": 0.054,
                    "percentVolume": -0.75,
                    "percentProjetado": -0.75,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.216,
                        "projetado": 0.054,
                        "percentVolume": -0.75,
                        "percentProjetado": -0.75,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1127081",
                "razaoSocial": "RENOVE MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16244,
                "volumeAtual": 74.90999999999998,
                "volumeAnterior": 83.726,
                "projetado": 74.90999999999998,
                "percentVolume": -0.10529584597377184,
                "percentProjetado": -0.10529584597377184,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2.4000000000000004,
                    "volumeAnterior": 3.6,
                    "projetado": 2.4000000000000004,
                    "percentVolume": -0.33333333333333326,
                    "percentProjetado": -0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.6,
                        "projetado": 0.8,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 2,
                        "projetado": 1.6,
                        "percentVolume": -0.19999999999999996,
                        "percentProjetado": -0.19999999999999996,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 72,
                    "volumeAnterior": 80,
                    "projetado": 72,
                    "percentVolume": -0.09999999999999998,
                    "percentProjetado": -0.09999999999999998,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 72,
                        "volumeAnterior": 80,
                        "projetado": 72,
                        "percentVolume": -0.09999999999999998,
                        "percentProjetado": -0.09999999999999998,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.24,
                    "volumeAnterior": 0,
                    "projetado": 0.24,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0,
                        "projetado": 0.24,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.27,
                    "volumeAnterior": 0.126,
                    "projetado": 0.27,
                    "percentVolume": 1.1428571428571428,
                    "percentProjetado": 1.1428571428571428,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.27,
                        "volumeAnterior": 0.072,
                        "projetado": 0.27,
                        "percentVolume": 2.7500000000000004,
                        "percentProjetado": 2.7500000000000004,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1512063",
                "razaoSocial": "FT DOS SANTOS MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 15458,
                "volumeAtual": 52.8,
                "volumeAnterior": 56,
                "projetado": 52.8,
                "percentVolume": -0.05714285714285716,
                "percentProjetado": -0.05714285714285716,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 2,
                    "projetado": 0.8,
                    "percentVolume": -0.6,
                    "percentProjetado": -0.6,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.2,
                        "projetado": 0.8,
                        "percentVolume": -0.33333333333333326,
                        "percentProjetado": -0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 52,
                    "volumeAnterior": 54,
                    "projetado": 52,
                    "percentVolume": -0.03703703703703709,
                    "percentProjetado": -0.03703703703703709,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 52,
                        "volumeAnterior": 54,
                        "projetado": 52,
                        "percentVolume": -0.03703703703703709,
                        "percentProjetado": -0.03703703703703709,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1127407",
                "razaoSocial": "JOSE MARIANO DOS SANTOS",
                "usuarioId": 892,
                "clienteId": 16289,
                "volumeAtual": 57.147999999999996,
                "volumeAnterior": 57.6,
                "projetado": 57.147999999999996,
                "percentVolume": -0.007847222222222339,
                "percentProjetado": -0.007847222222222339,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0,
                    "projetado": 0.108,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 56,
                    "volumeAnterior": 56,
                    "projetado": 56,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 56,
                        "volumeAnterior": 56,
                        "projetado": 56,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.24,
                    "volumeAnterior": 0,
                    "projetado": 0.24,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0,
                        "projetado": 0.24,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0,
                    "projetado": 0,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 0,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0,
                        "projetado": 0,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 0,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 1.6,
                    "projetado": 0.8,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.6,
                        "projetado": 0.8,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1835859",
                "razaoSocial": "AERO LAR UTILIDADES LTDA",
                "usuarioId": 892,
                "clienteId": 644124,
                "volumeAtual": 6,
                "volumeAnterior": 4,
                "projetado": 6,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 4,
                    "projetado": 6,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 4,
                        "projetado": 6,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1658949",
                "razaoSocial": "SILVA & TORRES MATERIAIS PARA",
                "usuarioId": 892,
                "clienteId": 15211,
                "volumeAtual": 24.8,
                "volumeAnterior": 27.872,
                "projetado": 24.8,
                "percentVolume": -0.1102181400688863,
                "percentProjetado": -0.1102181400688863,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 24,
                    "volumeAnterior": 24,
                    "projetado": 24,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 24,
                        "volumeAnterior": 24,
                        "projetado": 24,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 3.5999999999999996,
                    "projetado": 0.8,
                    "percentVolume": -0.7777777777777777,
                    "percentProjetado": -0.7777777777777777,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 2.4,
                        "projetado": 0.8,
                        "percentVolume": -0.6666666666666666,
                        "percentProjetado": -0.6666666666666666,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1863089",
                "razaoSocial": "HC ENTREGA E TRANSPORTE DE MATERIAI",
                "usuarioId": 892,
                "clienteId": 1055623,
                "volumeAtual": 48.144,
                "volumeAnterior": 32.112,
                "projetado": 48.144,
                "percentVolume": 0.49925261584454406,
                "percentProjetado": 0.49925261584454406,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.144,
                    "volumeAnterior": 0.072,
                    "projetado": 0.144,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.144,
                        "volumeAnterior": 0.072,
                        "projetado": 0.144,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 48,
                    "volumeAnterior": 32,
                    "projetado": 48,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 48,
                        "volumeAnterior": 32,
                        "projetado": 48,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1060546",
                "razaoSocial": "MADESUL MADEIRAS E MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16297,
                "volumeAtual": 360.46000000000004,
                "volumeAnterior": 336,
                "projetado": 360.46000000000004,
                "percentVolume": 0.07279761904761917,
                "percentProjetado": 0.07279761904761917,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6.24,
                    "volumeAnterior": 0,
                    "projetado": 6.24,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 3.12,
                        "volumeAnterior": 0,
                        "projetado": 3.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 3.12,
                        "volumeAnterior": 0,
                        "projetado": 3.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 266,
                    "volumeAnterior": 336,
                    "projetado": 266,
                    "percentVolume": -0.20833333333333337,
                    "percentProjetado": -0.20833333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 266,
                        "volumeAnterior": 336,
                        "projetado": 266,
                        "percentVolume": -0.20833333333333337,
                        "percentProjetado": -0.20833333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 88.22,
                    "volumeAnterior": 0,
                    "projetado": 88.22,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 88.22,
                        "volumeAnterior": 0,
                        "projetado": 88.22,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1699502",
                "razaoSocial": "M  M  DE MATTOS LTDA",
                "usuarioId": 892,
                "clienteId": 15139,
                "volumeAtual": 40.854,
                "volumeAnterior": 43.2,
                "projetado": 40.854,
                "percentVolume": -0.05430555555555561,
                "percentProjetado": -0.05430555555555561,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 2.8,
                    "volumeAnterior": 1.2,
                    "projetado": 2.8,
                    "percentVolume": 1.3333333333333335,
                    "percentProjetado": 1.3333333333333335,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 1.2,
                        "projetado": 1.2,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 38,
                    "volumeAnterior": 42,
                    "projetado": 38,
                    "percentVolume": -0.09523809523809523,
                    "percentProjetado": -0.09523809523809523,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 38,
                        "volumeAnterior": 42,
                        "projetado": 38,
                        "percentVolume": -0.09523809523809523,
                        "percentProjetado": -0.09523809523809523,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1563084",
                "razaoSocial": "CASTANHEIRA PRESTADORA DE SERVICOS",
                "usuarioId": 892,
                "clienteId": 15417,
                "volumeAtual": 0.2,
                "volumeAnterior": 21.156,
                "projetado": 0.2,
                "percentVolume": -0.9905464170920779,
                "percentProjetado": -0.9905464170920779,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.2,
                    "volumeAnterior": 1.12,
                    "projetado": 0.2,
                    "percentVolume": -0.8214285714285714,
                    "percentProjetado": -0.8214285714285714,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.2,
                        "volumeAnterior": 1.12,
                        "projetado": 0.2,
                        "percentVolume": -0.8214285714285714,
                        "percentProjetado": -0.8214285714285714,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1141525",
                "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16276,
                "volumeAtual": 4,
                "volumeAnterior": 6,
                "projetado": 4,
                "percentVolume": -0.33333333333333337,
                "percentProjetado": -0.33333333333333337,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 6,
                    "projetado": 4,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.33333333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 6,
                        "projetado": 4,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.33333333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1415861",
                "razaoSocial": "LUANA CLAUDIA GALESKI PESUSKI",
                "usuarioId": 892,
                "clienteId": 15850,
                "volumeAtual": 10.036,
                "volumeAnterior": 0,
                "projetado": 10.036,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.036,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 10,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 10,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1669301",
                "razaoSocial": "M V MATERIAIS PARA CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 15127,
                "volumeAtual": 34.84,
                "volumeAnterior": 32.94,
                "projetado": 34.84,
                "percentVolume": 0.05768063145112334,
                "percentProjetado": 0.05768063145112334,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 34,
                    "volumeAnterior": 32,
                    "projetado": 34,
                    "percentVolume": 0.0625,
                    "percentProjetado": 0.0625,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 34,
                        "volumeAnterior": 32,
                        "projetado": 34,
                        "percentVolume": 0.0625,
                        "percentProjetado": 0.0625,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0.14,
                    "projetado": 0.04,
                    "percentVolume": -0.7142857142857143,
                    "percentProjetado": -0.7142857142857143,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0.14,
                        "projetado": 0.04,
                        "percentVolume": -0.7142857142857143,
                        "percentProjetado": -0.7142857142857143,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.8,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1056890",
                "razaoSocial": "COMERCIAL JACARE MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16336,
                "volumeAtual": 122.712,
                "volumeAnterior": 225.496,
                "projetado": 122.712,
                "percentVolume": -0.4558129634228545,
                "percentProjetado": -0.4558129634228545,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 70,
                    "volumeAnterior": 60,
                    "projetado": 70,
                    "percentVolume": 0.16666666666666674,
                    "percentProjetado": 0.16666666666666674,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 70,
                        "volumeAnterior": 60,
                        "projetado": 70,
                        "percentVolume": 0.16666666666666674,
                        "percentProjetado": 0.16666666666666674,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 52.712,
                    "volumeAnterior": 165.496,
                    "projetado": 52.712,
                    "percentVolume": -0.6814907913182191,
                    "percentProjetado": -0.6814907913182191,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 52.712,
                        "volumeAnterior": 165.496,
                        "projetado": 52.712,
                        "percentVolume": -0.6814907913182191,
                        "percentProjetado": -0.6814907913182191,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1061121",
                "razaoSocial": "MATERIAIS DE CONSTRUCAO ANDRADE LTD",
                "usuarioId": 892,
                "clienteId": 16324,
                "volumeAtual": 17.34,
                "volumeAnterior": 12.908,
                "projetado": 17.34,
                "percentVolume": 0.3433529594050202,
                "percentProjetado": 0.3433529594050202,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.8,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0.108,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.108,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.52,
                    "volumeAnterior": 0,
                    "projetado": 0.52,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 12,
                    "projetado": 16,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 12,
                        "projetado": 16,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1078633",
                "razaoSocial": "MARCILIO DE BARROS ALBUQUERQUE",
                "usuarioId": 892,
                "clienteId": 16260,
                "volumeAtual": 6.054,
                "volumeAnterior": 8,
                "projetado": 6.054,
                "percentVolume": -0.24324999999999997,
                "percentProjetado": -0.24324999999999997,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 8,
                    "projetado": 6,
                    "percentVolume": -0.25,
                    "percentProjetado": -0.25,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 8,
                        "projetado": 6,
                        "percentVolume": -0.25,
                        "percentProjetado": -0.25,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1730277",
                "razaoSocial": "SUPERMERCADO ROCHEDO LTDA",
                "usuarioId": 892,
                "clienteId": 15056,
                "volumeAtual": 56.55800000000001,
                "volumeAnterior": 56.8,
                "projetado": 56.55800000000001,
                "percentVolume": -0.004260563380281468,
                "percentProjetado": -0.004260563380281468,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 56,
                    "volumeAnterior": 56,
                    "projetado": 56,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 56,
                        "volumeAnterior": 56,
                        "projetado": 56,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.018,
                    "volumeAnterior": 0,
                    "projetado": 0.018,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.018,
                        "volumeAnterior": 0,
                        "projetado": 0.018,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.52,
                    "volumeAnterior": 0,
                    "projetado": 0.52,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1584302",
                "razaoSocial": "JULIO MANOEL DA SILVA NETO LTDA",
                "usuarioId": 892,
                "clienteId": 15480,
                "volumeAtual": 48,
                "volumeAnterior": 48.7,
                "projetado": 48,
                "percentVolume": -0.014373716632443578,
                "percentProjetado": -0.014373716632443578,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 48,
                    "volumeAnterior": 22,
                    "projetado": 48,
                    "percentVolume": 1.1818181818181817,
                    "percentProjetado": 1.1818181818181817,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 48,
                        "volumeAnterior": 22,
                        "projetado": 48,
                        "percentVolume": 1.1818181818181817,
                        "percentProjetado": 1.1818181818181817,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1060252",
                "razaoSocial": "CLODOMIRO SANTOS DA SILVA",
                "usuarioId": 892,
                "clienteId": 16234,
                "volumeAtual": 8,
                "volumeAnterior": 0,
                "projetado": 8,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 0,
                    "projetado": 8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 0,
                        "projetado": 8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1527581",
                "razaoSocial": "ALVES CONSTRUCAO E AGRO LTDA",
                "usuarioId": 892,
                "clienteId": 15429,
                "volumeAtual": 42,
                "volumeAnterior": 70,
                "projetado": 42,
                "percentVolume": -0.4,
                "percentProjetado": -0.4,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 70,
                    "projetado": 42,
                    "percentVolume": -0.4,
                    "percentProjetado": -0.4,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 70,
                        "projetado": 42,
                        "percentVolume": -0.4,
                        "percentProjetado": -0.4,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1475913",
                "razaoSocial": "MARCOS CLAROS ESPINOZA LTDA",
                "usuarioId": 892,
                "clienteId": 15637,
                "volumeAtual": 204.2,
                "volumeAnterior": 295.5,
                "projetado": 204.2,
                "percentVolume": -0.3089678510998308,
                "percentProjetado": -0.3089678510998308,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 150.2,
                    "volumeAnterior": 269.5,
                    "projetado": 150.2,
                    "percentVolume": -0.4426716141001855,
                    "percentProjetado": -0.4426716141001855,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 150.2,
                        "volumeAnterior": 269.5,
                        "projetado": 150.2,
                        "percentVolume": -0.4426716141001855,
                        "percentProjetado": -0.4426716141001855,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 26,
                    "projetado": 54,
                    "percentVolume": 1.076923076923077,
                    "percentProjetado": 1.076923076923077,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 26,
                        "projetado": 54,
                        "percentVolume": 1.076923076923077,
                        "percentProjetado": 1.076923076923077,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1820312",
                "razaoSocial": "WOLNEY GABRYELL NUNES DE CAMARGO LT",
                "usuarioId": 892,
                "clienteId": 397927,
                "volumeAtual": 20.02,
                "volumeAnterior": 16.4,
                "projetado": 20.02,
                "percentVolume": 0.22073170731707314,
                "percentProjetado": 0.22073170731707314,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 16,
                    "projetado": 20,
                    "percentVolume": 0.25,
                    "percentProjetado": 0.25,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 16,
                        "projetado": 20,
                        "percentVolume": 0.25,
                        "percentProjetado": 0.25,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1058301",
                "razaoSocial": "HUGO LANDIVAR LTDA",
                "usuarioId": 892,
                "clienteId": 16290,
                "volumeAtual": 6,
                "volumeAnterior": 6,
                "projetado": 6,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 6,
                    "projetado": 6,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 6,
                        "projetado": 6,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1937359",
                "razaoSocial": "G  GRACIELA OLIVEIRA DE SOUZA E M",
                "usuarioId": 892,
                "clienteId": 1174170,
                "volumeAtual": 11.479999999999999,
                "volumeAnterior": 0,
                "projetado": 11.479999999999999,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 10,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 10,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0,
                    "projetado": 0.04,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0,
                        "projetado": 0.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.64,
                    "volumeAnterior": 0,
                    "projetado": 0.64,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.12,
                        "volumeAnterior": 0,
                        "projetado": 0.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1334606",
                "razaoSocial": "JOSE DE SOUZA AGUIAR E CIA LTDA",
                "usuarioId": 892,
                "clienteId": 16014,
                "volumeAtual": 70.162,
                "volumeAnterior": 0,
                "projetado": 70.162,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.162,
                    "volumeAnterior": 0,
                    "projetado": 0.162,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.162,
                        "volumeAnterior": 0,
                        "projetado": 0.162,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 70,
                    "volumeAnterior": 0,
                    "projetado": 70,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 70,
                        "volumeAnterior": 0,
                        "projetado": 70,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1809150",
                "razaoSocial": "J  E  S  MORON LTDA",
                "usuarioId": 892,
                "clienteId": 28606,
                "volumeAtual": 56.68,
                "volumeAnterior": 54,
                "projetado": 56.68,
                "percentVolume": 0.04962962962962969,
                "percentProjetado": 0.04962962962962969,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 30.68,
                    "volumeAnterior": 0,
                    "projetado": 30.68,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 30.68,
                        "volumeAnterior": 0,
                        "projetado": 30.68,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 54,
                    "projetado": 26,
                    "percentVolume": -0.5185185185185186,
                    "percentProjetado": -0.5185185185185186,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 54,
                        "projetado": 26,
                        "percentVolume": -0.5185185185185186,
                        "percentProjetado": -0.5185185185185186,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1936531",
                "razaoSocial": "CHAPARRO COMERCIO DE TINTAS LTDA",
                "usuarioId": 892,
                "clienteId": 1172990,
                "volumeAtual": 43.36,
                "volumeAnterior": 0,
                "projetado": 43.36,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 29.36,
                    "volumeAnterior": 0,
                    "projetado": 29.36,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 29.36,
                        "volumeAnterior": 0,
                        "projetado": 29.36,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1875709",
                "razaoSocial": "UNIAO MATERIAIS DE CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 1079118,
                "volumeAtual": 10,
                "volumeAnterior": 0,
                "projetado": 10,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 10,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 10,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1827357",
                "razaoSocial": "E  R  O  FORTE LTDA",
                "usuarioId": 892,
                "clienteId": 464151,
                "volumeAtual": 14.036,
                "volumeAnterior": 14.036,
                "projetado": 14.036,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0.036,
                    "projetado": 0.036,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0.036,
                        "projetado": 0.036,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 14,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 14,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1366654",
                "razaoSocial": "GONCALVES E CASTRO LTDA",
                "usuarioId": 892,
                "clienteId": 16028,
                "volumeAtual": 14.02,
                "volumeAnterior": 0,
                "projetado": 14.02,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1721038",
                "razaoSocial": "DMJ EMPREENDIMENTOS LTDA",
                "usuarioId": 892,
                "clienteId": 12397,
                "volumeAtual": 48.9,
                "volumeAnterior": 73.24000000000001,
                "projetado": 48.9,
                "percentVolume": -0.33233205898416174,
                "percentProjetado": -0.33233205898416174,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 30.9,
                    "volumeAnterior": 61.239999999999995,
                    "projetado": 30.9,
                    "percentVolume": -0.49542782495101234,
                    "percentProjetado": -0.49542782495101234,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 30.9,
                        "volumeAnterior": 61.239999999999995,
                        "projetado": 30.9,
                        "percentVolume": -0.49542782495101234,
                        "percentProjetado": -0.49542782495101234,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 12,
                    "projetado": 18,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 12,
                        "projetado": 18,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1657382",
                "razaoSocial": "RURAL MIX LTDA",
                "usuarioId": 892,
                "clienteId": 15324,
                "volumeAtual": 6.4,
                "volumeAnterior": 0,
                "projetado": 6.4,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1894886",
                "razaoSocial": "62 594 274 VILMA DINIZ DE ARRUDA",
                "usuarioId": 892,
                "clienteId": 1116248,
                "volumeAtual": 6,
                "volumeAnterior": 10,
                "projetado": 6,
                "percentVolume": -0.4,
                "percentProjetado": -0.4,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 10,
                    "projetado": 6,
                    "percentVolume": -0.4,
                    "percentProjetado": -0.4,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 10,
                        "projetado": 6,
                        "percentVolume": -0.4,
                        "percentProjetado": -0.4,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1793420",
                "razaoSocial": "TALITA COSTA DE SOUZA",
                "usuarioId": 892,
                "clienteId": 14643,
                "volumeAtual": 16,
                "volumeAnterior": 12,
                "projetado": 16,
                "percentVolume": 0.33333333333333326,
                "percentProjetado": 0.33333333333333326,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 12,
                    "projetado": 16,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 12,
                        "projetado": 16,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1558982",
                "razaoSocial": "BALBINO E BARBOSA LTDA",
                "usuarioId": 892,
                "clienteId": 15468,
                "volumeAtual": 41.6,
                "volumeAnterior": 40.8,
                "projetado": 41.6,
                "percentVolume": 0.019607843137255054,
                "percentProjetado": 0.019607843137255054,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 0.8,
                    "projetado": 1.6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 0.8,
                        "projetado": 1.6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 40,
                    "volumeAnterior": 40,
                    "projetado": 40,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 40,
                        "volumeAnterior": 40,
                        "projetado": 40,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1783291",
                "razaoSocial": "VERISSIMO COMERCIO LTDA",
                "usuarioId": 892,
                "clienteId": 14608,
                "volumeAtual": 7.2,
                "volumeAnterior": 18.799999999999997,
                "projetado": 7.2,
                "percentVolume": -0.6170212765957446,
                "percentProjetado": -0.6170212765957446,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.2000000000000002,
                    "volumeAnterior": 0.8,
                    "projetado": 1.2000000000000002,
                    "percentVolume": 0.5000000000000002,
                    "percentProjetado": 0.5000000000000002,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 18,
                    "projetado": 6,
                    "percentVolume": -0.6666666666666667,
                    "percentProjetado": -0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 18,
                        "projetado": 6,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1532186",
                "razaoSocial": "COOPERATIVA AGROINDUSTRIAL ALFA",
                "usuarioId": 892,
                "clienteId": 15506,
                "volumeAtual": 14,
                "volumeAnterior": 42,
                "projetado": 14,
                "percentVolume": -0.6666666666666667,
                "percentProjetado": -0.6666666666666667,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 42,
                    "projetado": 14,
                    "percentVolume": -0.6666666666666667,
                    "percentProjetado": -0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 42,
                        "projetado": 14,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1170311",
                "razaoSocial": "M DE F OLIVEIRA",
                "usuarioId": 892,
                "clienteId": 16125,
                "volumeAtual": 63.4,
                "volumeAnterior": 75.04,
                "projetado": 63.4,
                "percentVolume": -0.1551172707889127,
                "percentProjetado": -0.1551172707889127,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 48,
                    "volumeAnterior": 42,
                    "projetado": 48,
                    "percentVolume": 0.1428571428571428,
                    "percentProjetado": 0.1428571428571428,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 48,
                        "volumeAnterior": 42,
                        "projetado": 48,
                        "percentVolume": 0.1428571428571428,
                        "percentProjetado": 0.1428571428571428,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 15.4,
                    "volumeAnterior": 33.04,
                    "projetado": 15.4,
                    "percentVolume": -0.5338983050847457,
                    "percentProjetado": -0.5338983050847457,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 15.4,
                        "volumeAnterior": 33.04,
                        "projetado": 15.4,
                        "percentVolume": -0.5338983050847457,
                        "percentProjetado": -0.5338983050847457,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1896441",
                "razaoSocial": "A&V MATERIAIS DE CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 1118348,
                "volumeAtual": 8,
                "volumeAnterior": 0,
                "projetado": 8,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 0,
                    "projetado": 8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 0,
                        "projetado": 8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1477870",
                "razaoSocial": "TRANSCAMARGO COMERCIO E SERVICOS LT",
                "usuarioId": 892,
                "clienteId": 15544,
                "volumeAtual": 6,
                "volumeAnterior": 14,
                "projetado": 6,
                "percentVolume": -0.5714285714285714,
                "percentProjetado": -0.5714285714285714,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 14,
                    "projetado": 6,
                    "percentVolume": -0.5714285714285714,
                    "percentProjetado": -0.5714285714285714,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 14,
                        "projetado": 6,
                        "percentVolume": -0.5714285714285714,
                        "percentProjetado": -0.5714285714285714,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1489185",
                "razaoSocial": "AGEU MATERIAIS DE CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 15630,
                "volumeAtual": 0,
                "volumeAnterior": 0,
                "projetado": 0,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 0,
                "gruposProduto": [
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0,
                    "projetado": 0,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 0,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0,
                        "projetado": 0,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 0,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1058365",
                "razaoSocial": "JOAO MARIA NANTES DE SOUZA",
                "usuarioId": 892,
                "clienteId": 16295,
                "volumeAtual": 0,
                "volumeAnterior": 2,
                "projetado": 0,
                "percentVolume": -1,
                "percentProjetado": -1,
                "positivacaoM1": 1,
                "positivacaoM0": 0,
                "gruposProduto": [
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 2,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 2,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1377304",
                "razaoSocial": "DOMINGOS E GOMES LTDA",
                "usuarioId": 892,
                "clienteId": 17394,
                "volumeAtual": 14.436,
                "volumeAnterior": 0,
                "projetado": 14.436,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.036,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1062632",
                "razaoSocial": "G5 CASA & CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 649981,
                "volumeAtual": 8.4,
                "volumeAnterior": 24.36,
                "projetado": 8.4,
                "percentVolume": -0.6551724137931034,
                "percentProjetado": -0.6551724137931034,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.8,
                    "projetado": 0.4,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.8,
                        "projetado": 0.4,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 22,
                    "projetado": 8,
                    "percentVolume": -0.6363636363636364,
                    "percentProjetado": -0.6363636363636364,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 22,
                        "projetado": 8,
                        "percentVolume": -0.6363636363636364,
                        "percentProjetado": -0.6363636363636364,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1540227",
                "razaoSocial": "3A COMERCIO DE TINTAS E MATERIAIS D",
                "usuarioId": 892,
                "clienteId": 15464,
                "volumeAtual": 6,
                "volumeAnterior": 0,
                "projetado": 6,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1315755",
                "razaoSocial": "ABREGO & RODRIGUES LTDA",
                "usuarioId": 892,
                "clienteId": 118111,
                "volumeAtual": 13.92,
                "volumeAnterior": 9.36,
                "projetado": 13.92,
                "percentVolume": 0.4871794871794872,
                "percentProjetado": 0.4871794871794872,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 13.92,
                    "volumeAnterior": 9.36,
                    "projetado": 13.92,
                    "percentVolume": 0.4871794871794872,
                    "percentProjetado": 0.4871794871794872,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 12.48,
                        "volumeAnterior": 9.36,
                        "projetado": 12.48,
                        "percentVolume": 0.3333333333333335,
                        "percentProjetado": 0.3333333333333335,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.44,
                        "volumeAnterior": 0,
                        "projetado": 1.44,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1937930",
                "razaoSocial": "WAKUTAS BLOCOS E TIJOLOS LTDA",
                "usuarioId": 892,
                "clienteId": 1174943,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1334484",
                "razaoSocial": "R  A  KNAUF LTDA",
                "usuarioId": 892,
                "clienteId": 15970,
                "volumeAtual": 24.436,
                "volumeAnterior": 149.93,
                "projetado": 24.436,
                "percentVolume": -0.8370172747282065,
                "percentProjetado": -0.8370172747282065,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 24.436,
                    "volumeAnterior": 149.93,
                    "projetado": 24.436,
                    "percentVolume": -0.8370172747282065,
                    "percentProjetado": -0.8370172747282065,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 24.436,
                        "volumeAnterior": 149.93,
                        "projetado": 24.436,
                        "percentVolume": -0.8370172747282065,
                        "percentProjetado": -0.8370172747282065,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1830860",
                "razaoSocial": "K L J ELETRICA & CONSTRUCOES LTDA",
                "usuarioId": 892,
                "clienteId": 623958,
                "volumeAtual": 10,
                "volumeAnterior": 58,
                "projetado": 10,
                "percentVolume": -0.8275862068965517,
                "percentProjetado": -0.8275862068965517,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 54,
                    "projetado": 10,
                    "percentVolume": -0.8148148148148149,
                    "percentProjetado": -0.8148148148148149,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 54,
                        "projetado": 10,
                        "percentVolume": -0.8148148148148149,
                        "percentProjetado": -0.8148148148148149,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1443413",
                "razaoSocial": "MANOEL RODRIGUES FILHO",
                "usuarioId": 892,
                "clienteId": 15666,
                "volumeAtual": 11.2,
                "volumeAnterior": 0,
                "projetado": 11.2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.2,
                    "volumeAnterior": 0,
                    "projetado": 1.2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0,
                        "projetado": 1.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 10,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 10,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1113701",
                "razaoSocial": "MERCANTIL MATERIAIS DE CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16218,
                "volumeAtual": 4.4,
                "volumeAnterior": 9.2,
                "projetado": 4.4,
                "percentVolume": -0.5217391304347825,
                "percentProjetado": -0.5217391304347825,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 1.2,
                    "projetado": 0.4,
                    "percentVolume": -0.6666666666666666,
                    "percentProjetado": -0.6666666666666666,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 1.2,
                        "projetado": 0.4,
                        "percentVolume": -0.6666666666666666,
                        "percentProjetado": -0.6666666666666666,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 8,
                    "projetado": 4,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 8,
                        "projetado": 4,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1057403",
                "razaoSocial": "ROSANGELA JORGE DA SILVA",
                "usuarioId": 892,
                "clienteId": 16360,
                "volumeAtual": 4,
                "volumeAnterior": 17.04,
                "projetado": 4,
                "percentVolume": -0.7652582159624413,
                "percentProjetado": -0.7652582159624413,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 16,
                    "projetado": 4,
                    "percentVolume": -0.75,
                    "percentProjetado": -0.75,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 16,
                        "projetado": 4,
                        "percentVolume": -0.75,
                        "percentProjetado": -0.75,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1938785",
                "razaoSocial": "CIMENTAO PANTANAL LTDA",
                "usuarioId": 892,
                "clienteId": 1175950,
                "volumeAtual": 2.4,
                "volumeAnterior": 0,
                "projetado": 2.4,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1737225",
                "razaoSocial": "PAULO NONATO DE OLIVEIRA",
                "usuarioId": 892,
                "clienteId": 14974,
                "volumeAtual": 10,
                "volumeAnterior": 0,
                "projetado": 10,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 10,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 0,
                        "projetado": 10,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1080145",
                "razaoSocial": "PIRES MARTINS & MARTINS LTDA",
                "usuarioId": 892,
                "clienteId": 16223,
                "volumeAtual": 14.036,
                "volumeAnterior": 28,
                "projetado": 14.036,
                "percentVolume": -0.4987142857142858,
                "percentProjetado": -0.4987142857142858,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.036,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo de Aderência",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 28,
                    "projetado": 14,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 28,
                        "projetado": 14,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1885287",
                "razaoSocial": "R  L  BRAGA LTDA",
                "usuarioId": 892,
                "clienteId": 1093541,
                "volumeAtual": 4,
                "volumeAnterior": 10,
                "projetado": 4,
                "percentVolume": -0.6,
                "percentProjetado": -0.6,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 10,
                    "projetado": 4,
                    "percentVolume": -0.6,
                    "percentProjetado": -0.6,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 6,
                        "projetado": 2,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 4,
                        "projetado": 2,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1331022",
                "razaoSocial": "COSTA MATERIAIS PARA CONSTRUCAO LTD",
                "usuarioId": 892,
                "clienteId": 15949,
                "volumeAtual": 4,
                "volumeAnterior": 0,
                "projetado": 4,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1458429",
                "razaoSocial": "AGRO SHOPPING LTDA",
                "usuarioId": 892,
                "clienteId": 15688,
                "volumeAtual": 28.24,
                "volumeAnterior": 14,
                "projetado": 28.24,
                "percentVolume": 1.017142857142857,
                "percentProjetado": 1.017142857142857,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.24,
                    "volumeAnterior": 0,
                    "projetado": 0.24,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0,
                        "projetado": 0.24,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 14,
                    "projetado": 28,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 14,
                        "projetado": 28,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1391694",
                "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                "grupoCentralizador": "LEROY MERLIN",
                "usuarioId": 892,
                "clienteId": 57075,
                "volumeAtual": 28,
                "volumeAnterior": 41.224000000000004,
                "projetado": 28,
                "percentVolume": -0.3207840093149622,
                "percentProjetado": -0.3207840093149622,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 28,
                    "projetado": 28,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 28,
                        "projetado": 28,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1258703",
                "razaoSocial": "FERRAGEM ALVORADA LTDA",
                "grupoCentralizador": "ALVORADA",
                "usuarioId": 892,
                "clienteId": 16070,
                "volumeAtual": 0,
                "volumeAnterior": 0,
                "projetado": 0,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 0,
                "gruposProduto": [
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0,
                    "projetado": 0,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 0,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0,
                        "projetado": 0,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 0,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1057754",
                "razaoSocial": "GUARAPORA MATERIAIS PARA CONSTRUCAO",
                "grupoCentralizador": "FERRAGENS BARATAO",
                "usuarioId": 892,
                "clienteId": 16219,
                "volumeAtual": 6.4,
                "volumeAnterior": 8.92,
                "projetado": 6.4,
                "percentVolume": -0.28251121076233177,
                "percentProjetado": -0.28251121076233177,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 8,
                    "projetado": 6,
                    "percentVolume": -0.25,
                    "percentProjetado": -0.25,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 8,
                        "projetado": 6,
                        "percentVolume": -0.25,
                        "percentProjetado": -0.25,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1552268",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116105,
                "volumeAtual": 2,
                "volumeAnterior": 18,
                "projetado": 2,
                "percentVolume": -0.8888888888888888,
                "percentProjetado": -0.8888888888888888,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 18,
                    "projetado": 2,
                    "percentVolume": -0.8888888888888888,
                    "percentProjetado": -0.8888888888888888,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 18,
                        "projetado": 2,
                        "percentVolume": -0.8888888888888888,
                        "percentProjetado": -0.8888888888888888,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1529731",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116104,
                "volumeAtual": 111.8,
                "volumeAnterior": 54,
                "projetado": 111.8,
                "percentVolume": 1.0703703703703704,
                "percentProjetado": 1.0703703703703704,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 7.8,
                    "volumeAnterior": 0,
                    "projetado": 7.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 7.8,
                        "volumeAnterior": 0,
                        "projetado": 7.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 104,
                    "volumeAnterior": 54,
                    "projetado": 104,
                    "percentVolume": 0.9259259259259258,
                    "percentProjetado": 0.9259259259259258,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 104,
                        "volumeAnterior": 54,
                        "projetado": 104,
                        "percentVolume": 0.9259259259259258,
                        "percentProjetado": 0.9259259259259258,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1538881",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116106,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1060663",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 20743,
                "volumeAtual": 14,
                "volumeAnterior": 14,
                "projetado": 14,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 14,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 14,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1367137",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 8231,
                "volumeAtual": 2488.1200000000003,
                "volumeAnterior": 2778.84,
                "projetado": 2488.1200000000003,
                "percentVolume": -0.10461919362035954,
                "percentProjetado": -0.10461919362035954,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 3.78,
                    "volumeAnterior": 23.939999999999998,
                    "projetado": 3.78,
                    "percentVolume": -0.8421052631578947,
                    "percentProjetado": -0.8421052631578947,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 14.22,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 5.58,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Polimerica 7000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 3.78,
                        "volumeAnterior": 2.88,
                        "projetado": 3.78,
                        "percentVolume": 0.3125,
                        "percentProjetado": 0.3125,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 2432,
                    "volumeAnterior": 2626,
                    "projetado": 2432,
                    "percentVolume": -0.07387661843107385,
                    "percentProjetado": -0.07387661843107385,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2400,
                        "volumeAnterior": 2574,
                        "projetado": 2400,
                        "percentVolume": -0.06759906759906764,
                        "percentProjetado": -0.06759906759906764,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 32,
                        "volumeAnterior": 14,
                        "projetado": 32,
                        "percentVolume": 1.2857142857142856,
                        "percentProjetado": 1.2857142857142856,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 38,
                    "volumeAnterior": 94,
                    "projetado": 38,
                    "percentVolume": -0.5957446808510638,
                    "percentProjetado": -0.5957446808510638,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 64,
                        "projetado": 28,
                        "percentVolume": -0.5625,
                        "percentProjetado": -0.5625,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 12,
                        "projetado": 10,
                        "percentVolume": -0.16666666666666663,
                        "percentProjetado": -0.16666666666666663,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14.040000000000001,
                    "volumeAnterior": 34.28,
                    "projetado": 14.040000000000001,
                    "percentVolume": -0.5904317386231038,
                    "percentProjetado": -0.5904317386231038,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 12.48,
                        "volumeAnterior": 20.28,
                        "projetado": 12.48,
                        "percentVolume": -0.3846153846153846,
                        "percentProjetado": -0.3846153846153846,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.3,
                    "volumeAnterior": 0.62,
                    "projetado": 0.3,
                    "percentVolume": -0.5161290322580645,
                    "percentProjetado": -0.5161290322580645,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.3,
                        "volumeAnterior": 0.6,
                        "projetado": 0.3,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Porcelanato",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1186391",
                "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                "grupoCentralizador": "ESMAEL",
                "usuarioId": 892,
                "clienteId": 16081,
                "volumeAtual": 176.83800000000002,
                "volumeAnterior": 130.66,
                "projetado": 176.83800000000002,
                "percentVolume": 0.353421092912904,
                "percentProjetado": 0.353421092912904,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 1.6,
                    "projetado": 0.4,
                    "percentVolume": -0.75,
                    "percentProjetado": -0.75,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 176,
                    "volumeAnterior": 128,
                    "projetado": 176,
                    "percentVolume": 0.375,
                    "percentProjetado": 0.375,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 176,
                        "volumeAnterior": 128,
                        "projetado": 176,
                        "percentVolume": 0.375,
                        "percentProjetado": 0.375,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.378,
                    "volumeAnterior": 0,
                    "projetado": 0.378,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0,
                        "projetado": 0.108,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.216,
                        "volumeAnterior": 0,
                        "projetado": 0.216,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 7000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.06,
                    "volumeAnterior": 0.02,
                    "projetado": 0.06,
                    "percentVolume": 2,
                    "percentProjetado": 2,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.06,
                        "volumeAnterior": 0.02,
                        "projetado": 0.06,
                        "percentVolume": 2,
                        "percentProjetado": 2,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1536936",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 15498,
                "volumeAtual": 64,
                "volumeAnterior": 32,
                "projetado": 64,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 64,
                    "volumeAnterior": 32,
                    "projetado": 64,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 64,
                        "volumeAnterior": 32,
                        "projetado": 64,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1206763",
                "razaoSocial": "WANDERSON S GALVAO",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16139,
                "volumeAtual": 68.24000000000001,
                "volumeAnterior": 66.24000000000001,
                "projetado": 68.24000000000001,
                "percentVolume": 0.030193236714975757,
                "percentProjetado": 0.030193236714975757,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 68,
                    "volumeAnterior": 66,
                    "projetado": 68,
                    "percentVolume": 0.030303030303030276,
                    "percentProjetado": 0.030303030303030276,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 68,
                        "volumeAnterior": 66,
                        "projetado": 68,
                        "percentVolume": 0.030303030303030276,
                        "percentProjetado": 0.030303030303030276,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.24,
                    "volumeAnterior": 0.24,
                    "projetado": 0.24,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0.24,
                        "projetado": 0.24,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1049264",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16403,
                "volumeAtual": 938.1099999999999,
                "volumeAnterior": 965.8879999999999,
                "projetado": 938.1099999999999,
                "percentVolume": -0.02875902796183416,
                "percentProjetado": -0.02875902796183416,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 515.87,
                    "volumeAnterior": 609.208,
                    "projetado": 515.87,
                    "percentVolume": -0.15321203923783,
                    "percentProjetado": -0.15321203923783,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 515.87,
                        "volumeAnterior": 609.208,
                        "projetado": 515.87,
                        "percentVolume": -0.15321203923783,
                        "percentProjetado": -0.15321203923783,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 416,
                    "volumeAnterior": 352,
                    "projetado": 416,
                    "percentVolume": 0.18181818181818188,
                    "percentProjetado": 0.18181818181818188,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 416,
                        "volumeAnterior": 352,
                        "projetado": 416,
                        "percentVolume": 0.18181818181818188,
                        "percentProjetado": 0.18181818181818188,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 6.24,
                    "volumeAnterior": 4.68,
                    "projetado": 6.24,
                    "percentVolume": 0.3333333333333335,
                    "percentProjetado": 0.3333333333333335,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 4.68,
                        "volumeAnterior": 3.12,
                        "projetado": 4.68,
                        "percentVolume": 0.4999999999999998,
                        "percentProjetado": 0.4999999999999998,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 1.56,
                        "projetado": 1.56,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1548795",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15437,
                "volumeAtual": 14,
                "volumeAnterior": 14,
                "projetado": 14,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 14,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 14,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1476567",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15629,
                "volumeAtual": 42,
                "volumeAnterior": 41.2,
                "projetado": 42,
                "percentVolume": 0.01941747572815533,
                "percentProjetado": 0.01941747572815533,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 36,
                    "projetado": 42,
                    "percentVolume": 0.16666666666666674,
                    "percentProjetado": 0.16666666666666674,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 36,
                        "projetado": 42,
                        "percentVolume": 0.16666666666666674,
                        "percentProjetado": 0.16666666666666674,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1783272",
                "razaoSocial": "COMERCIO COPACABANA LTDA",
                "grupoCentralizador": "COPACABANA",
                "usuarioId": 892,
                "clienteId": 14649,
                "volumeAtual": 55.708000000000006,
                "volumeAnterior": 28.112000000000002,
                "projetado": 55.708000000000006,
                "percentVolume": 0.9816448491747298,
                "percentProjetado": 0.9816448491747298,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0,
                    "projetado": 0,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 0,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0,
                        "projetado": 0,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 0,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 3.5999999999999996,
                    "volumeAnterior": 2,
                    "projetado": 3.5999999999999996,
                    "percentVolume": 0.7999999999999998,
                    "percentProjetado": 0.7999999999999998,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0.8,
                        "projetado": 1.2,
                        "percentVolume": 0.4999999999999998,
                        "percentProjetado": 0.4999999999999998,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2.4,
                        "volumeAnterior": 1.2,
                        "projetado": 2.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 52,
                    "volumeAnterior": 26,
                    "projetado": 52,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 52,
                        "volumeAnterior": 26,
                        "projetado": 52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0.072,
                    "projetado": 0.108,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.036,
                        "projetado": 0.054,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.036,
                        "projetado": 0.054,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 7000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0.04,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.04,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1660429",
                "razaoSocial": "SERTAO COMERCIAL DE EQUIPAMENTOS LT",
                "grupoCentralizador": "SERTÃO",
                "usuarioId": 892,
                "clienteId": 15229,
                "volumeAtual": 15.56,
                "volumeAnterior": 17.04,
                "projetado": 15.56,
                "percentVolume": -0.08685446009389663,
                "percentProjetado": -0.08685446009389663,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.56,
                    "volumeAnterior": 1.04,
                    "projetado": 1.56,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 1.04,
                        "projetado": 1.56,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 16,
                    "projetado": 14,
                    "percentVolume": -0.125,
                    "percentProjetado": -0.125,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 16,
                        "projetado": 14,
                        "percentVolume": -0.125,
                        "percentProjetado": -0.125,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1615426",
                "razaoSocial": "SERTAO COMERCIAL DE EQUIPAMENTOS LT",
                "grupoCentralizador": "SERTÃO",
                "usuarioId": 892,
                "clienteId": 15227,
                "volumeAtual": 17.12,
                "volumeAnterior": 27.56,
                "projetado": 17.12,
                "percentVolume": -0.378809869375907,
                "percentProjetado": -0.378809869375907,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 26,
                    "projetado": 14,
                    "percentVolume": -0.46153846153846156,
                    "percentProjetado": -0.46153846153846156,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 26,
                        "projetado": 14,
                        "percentVolume": -0.46153846153846156,
                        "percentProjetado": -0.46153846153846156,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 3.12,
                    "volumeAnterior": 1.56,
                    "projetado": 3.12,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 1.56,
                        "projetado": 1.56,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1330360",
                "razaoSocial": "MIRANDA PEREIRA MATERIAIS PARA",
                "grupoCentralizador": "CASABELLA",
                "usuarioId": 892,
                "clienteId": 15931,
                "volumeAtual": 6,
                "volumeAnterior": 0,
                "projetado": 6,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1582572",
                "razaoSocial": "RECANTO MATERIAIS DE CONSTRUCAO LTD",
                "grupoCentralizador": "CASABELLA",
                "usuarioId": 892,
                "clienteId": 15500,
                "volumeAtual": 6,
                "volumeAnterior": 0,
                "projetado": 6,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1059174",
                "razaoSocial": "JOSE GOMES DA COSTA & CIA LTDA",
                "grupoCentralizador": "GOMES DA COSTA",
                "usuarioId": 892,
                "clienteId": 16215,
                "volumeAtual": 41.507999999999996,
                "volumeAnterior": 0,
                "projetado": 41.507999999999996,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.4,
                    "volumeAnterior": 0,
                    "projetado": 1.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.36,
                        "volumeAnterior": 0,
                        "projetado": 0.36,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.04,
                        "volumeAnterior": 0,
                        "projetado": 1.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 40,
                    "volumeAnterior": 0,
                    "projetado": 40,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 40,
                        "volumeAnterior": 0,
                        "projetado": 40,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0,
                    "projetado": 0.108,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0,
                        "projetado": 0.108,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1473763",
                "razaoSocial": "WILIAN DA CUNHA",
                "grupoCentralizador": "WILIAN DA CUNHA",
                "usuarioId": 892,
                "clienteId": 15616,
                "volumeAtual": 14.054,
                "volumeAnterior": 28.107999999999997,
                "projetado": 14.054,
                "percentVolume": -0.4999999999999999,
                "percentProjetado": -0.4999999999999999,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 28,
                    "projetado": 14,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 28,
                        "projetado": 14,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0.108,
                    "projetado": 0.054,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.054,
                        "projetado": 0.054,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1463567",
                "razaoSocial": "CECOM COMERCIO DE MATERIAIS PARA",
                "grupoCentralizador": "CECOM",
                "usuarioId": 892,
                "clienteId": 15780,
                "volumeAtual": 76,
                "volumeAnterior": 83.53999999999999,
                "projetado": 76,
                "percentVolume": -0.09025616471151532,
                "percentProjetado": -0.09025616471151532,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 76,
                    "volumeAnterior": 30,
                    "projetado": 76,
                    "percentVolume": 1.5333333333333332,
                    "percentProjetado": 1.5333333333333332,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 76,
                        "volumeAnterior": 30,
                        "projetado": 76,
                        "percentVolume": 1.5333333333333332,
                        "percentProjetado": 1.5333333333333332,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-08-01T00:00:00"
              },
              {
                "codigoCliente": "1141525",
                "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16276,
                "volumeAtual": 6,
                "volumeAnterior": 4,
                "projetado": 6,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 4,
                    "projetado": 6,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 4,
                        "projetado": 6,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1056890",
                "razaoSocial": "COMERCIAL JACARE MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16336,
                "volumeAtual": 225.496,
                "volumeAnterior": 193.762,
                "projetado": 225.496,
                "percentVolume": 0.16377824341202096,
                "percentProjetado": 0.16377824341202096,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 60,
                    "volumeAnterior": 60,
                    "projetado": 60,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 60,
                        "volumeAnterior": 60,
                        "projetado": 60,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 165.496,
                    "volumeAnterior": 133.762,
                    "projetado": 165.496,
                    "percentVolume": 0.2372422661144422,
                    "percentProjetado": 0.2372422661144422,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 165.496,
                        "volumeAnterior": 133.762,
                        "projetado": 165.496,
                        "percentVolume": 0.2372422661144422,
                        "percentProjetado": 0.2372422661144422,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1783291",
                "razaoSocial": "VERISSIMO COMERCIO LTDA",
                "usuarioId": 892,
                "clienteId": 14608,
                "volumeAtual": 18.799999999999997,
                "volumeAnterior": 4.44,
                "projetado": 18.799999999999997,
                "percentVolume": 3.2342342342342336,
                "percentProjetado": 3.2342342342342336,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 4,
                    "projetado": 18,
                    "percentVolume": 3.5,
                    "percentProjetado": 3.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 4,
                        "projetado": 18,
                        "percentVolume": 3.5,
                        "percentProjetado": 3.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1057403",
                "razaoSocial": "ROSANGELA JORGE DA SILVA",
                "usuarioId": 892,
                "clienteId": 16360,
                "volumeAtual": 17.04,
                "volumeAnterior": 19.32,
                "projetado": 17.04,
                "percentVolume": -0.11801242236024856,
                "percentProjetado": -0.11801242236024856,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.24,
                    "volumeAnterior": 0.12,
                    "projetado": 0.24,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0.12,
                        "projetado": 0.24,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 18,
                    "projetado": 16,
                    "percentVolume": -0.11111111111111116,
                    "percentProjetado": -0.11111111111111116,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 18,
                        "projetado": 16,
                        "percentVolume": -0.11111111111111116,
                        "percentProjetado": -0.11111111111111116,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 1.2,
                    "projetado": 0.8,
                    "percentVolume": -0.33333333333333326,
                    "percentProjetado": -0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.2,
                        "projetado": 0.8,
                        "percentVolume": -0.33333333333333326,
                        "percentProjetado": -0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1170311",
                "razaoSocial": "M DE F OLIVEIRA",
                "usuarioId": 892,
                "clienteId": 16125,
                "volumeAtual": 75.04,
                "volumeAnterior": 53.120000000000005,
                "projetado": 75.04,
                "percentVolume": 0.4126506024096386,
                "percentProjetado": 0.4126506024096386,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 33.04,
                    "volumeAnterior": 17.12,
                    "projetado": 33.04,
                    "percentVolume": 0.9299065420560746,
                    "percentProjetado": 0.9299065420560746,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 33.04,
                        "volumeAnterior": 17.12,
                        "projetado": 33.04,
                        "percentVolume": 0.9299065420560746,
                        "percentProjetado": 0.9299065420560746,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 36,
                    "projetado": 42,
                    "percentVolume": 0.16666666666666674,
                    "percentProjetado": 0.16666666666666674,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 36,
                        "projetado": 42,
                        "percentVolume": 0.16666666666666674,
                        "percentProjetado": 0.16666666666666674,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1584302",
                "razaoSocial": "JULIO MANOEL DA SILVA NETO LTDA",
                "usuarioId": 892,
                "clienteId": 15480,
                "volumeAtual": 48.7,
                "volumeAnterior": 36,
                "projetado": 48.7,
                "percentVolume": 0.35277777777777786,
                "percentProjetado": 0.35277777777777786,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 22,
                    "volumeAnterior": 36,
                    "projetado": 22,
                    "percentVolume": -0.38888888888888884,
                    "percentProjetado": -0.38888888888888884,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 22,
                        "volumeAnterior": 36,
                        "projetado": 22,
                        "percentVolume": -0.38888888888888884,
                        "percentProjetado": -0.38888888888888884,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26.7,
                    "volumeAnterior": 0,
                    "projetado": 26.7,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 26.7,
                        "volumeAnterior": 0,
                        "projetado": 26.7,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1527581",
                "razaoSocial": "ALVES CONSTRUCAO E AGRO LTDA",
                "usuarioId": 892,
                "clienteId": 15429,
                "volumeAtual": 70,
                "volumeAnterior": 42,
                "projetado": 70,
                "percentVolume": 0.6666666666666667,
                "percentProjetado": 0.6666666666666667,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 70,
                    "volumeAnterior": 42,
                    "projetado": 70,
                    "percentVolume": 0.6666666666666667,
                    "percentProjetado": 0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 70,
                        "volumeAnterior": 42,
                        "projetado": 70,
                        "percentVolume": 0.6666666666666667,
                        "percentProjetado": 0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1127407",
                "razaoSocial": "JOSE MARIANO DOS SANTOS",
                "usuarioId": 892,
                "clienteId": 16289,
                "volumeAtual": 57.6,
                "volumeAnterior": 70.4,
                "projetado": 57.6,
                "percentVolume": -0.18181818181818188,
                "percentProjetado": -0.18181818181818188,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 56,
                    "volumeAnterior": 70,
                    "projetado": 56,
                    "percentVolume": -0.19999999999999996,
                    "percentProjetado": -0.19999999999999996,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 56,
                        "volumeAnterior": 70,
                        "projetado": 56,
                        "percentVolume": -0.19999999999999996,
                        "percentProjetado": -0.19999999999999996,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 0.4,
                    "projetado": 1.6,
                    "percentVolume": 3,
                    "percentProjetado": 3,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 0.4,
                        "projetado": 1.6,
                        "percentVolume": 3,
                        "percentProjetado": 3,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1669301",
                "razaoSocial": "M V MATERIAIS PARA CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 15127,
                "volumeAtual": 32.94,
                "volumeAnterior": 22.894,
                "projetado": 32.94,
                "percentVolume": 0.43880492705512353,
                "percentProjetado": 0.43880492705512353,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.14,
                    "volumeAnterior": 0.04,
                    "projetado": 0.14,
                    "percentVolume": 2.5000000000000004,
                    "percentProjetado": 2.5000000000000004,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.14,
                        "volumeAnterior": 0.04,
                        "projetado": 0.14,
                        "percentVolume": 2.5000000000000004,
                        "percentProjetado": 2.5000000000000004,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.8,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 32,
                    "volumeAnterior": 22,
                    "projetado": 32,
                    "percentVolume": 0.4545454545454546,
                    "percentProjetado": 0.4545454545454546,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 32,
                        "volumeAnterior": 22,
                        "projetado": 32,
                        "percentVolume": 0.4545454545454546,
                        "percentProjetado": 0.4545454545454546,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1060546",
                "razaoSocial": "MADESUL MADEIRAS E MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16297,
                "volumeAtual": 336,
                "volumeAnterior": 351.156,
                "projetado": 336,
                "percentVolume": -0.043160304821788675,
                "percentProjetado": -0.043160304821788675,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 336,
                    "volumeAnterior": 252,
                    "projetado": 336,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 336,
                        "volumeAnterior": 252,
                        "projetado": 336,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1809150",
                "razaoSocial": "J  E  S  MORON LTDA",
                "usuarioId": 892,
                "clienteId": 28606,
                "volumeAtual": 54,
                "volumeAnterior": 64,
                "projetado": 54,
                "percentVolume": -0.15625,
                "percentProjetado": -0.15625,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 64,
                    "projetado": 54,
                    "percentVolume": -0.15625,
                    "percentProjetado": -0.15625,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 64,
                        "projetado": 54,
                        "percentVolume": -0.15625,
                        "percentProjetado": -0.15625,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1563084",
                "razaoSocial": "CASTANHEIRA PRESTADORA DE SERVICOS",
                "usuarioId": 892,
                "clienteId": 15417,
                "volumeAtual": 21.156,
                "volumeAnterior": 5,
                "projetado": 21.156,
                "percentVolume": 3.2311999999999994,
                "percentProjetado": 3.2311999999999994,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.12,
                    "volumeAnterior": 1,
                    "projetado": 1.12,
                    "percentVolume": 0.1200000000000001,
                    "percentProjetado": 0.1200000000000001,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.12,
                        "volumeAnterior": 0.48,
                        "projetado": 1.12,
                        "percentVolume": 1.3333333333333335,
                        "percentProjetado": 1.3333333333333335,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.036,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 4,
                    "projetado": 20,
                    "percentVolume": 4,
                    "percentProjetado": 4,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 4,
                        "projetado": 20,
                        "percentVolume": 4,
                        "percentProjetado": 4,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1658949",
                "razaoSocial": "SILVA & TORRES MATERIAIS PARA",
                "usuarioId": 892,
                "clienteId": 15211,
                "volumeAtual": 27.872,
                "volumeAnterior": 26.968,
                "projetado": 27.872,
                "percentVolume": 0.03352121032334621,
                "percentProjetado": 0.03352121032334621,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 3.5999999999999996,
                    "volumeAnterior": 0.8,
                    "projetado": 3.5999999999999996,
                    "percentVolume": 3.499999999999999,
                    "percentProjetado": 3.499999999999999,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 2.4,
                        "volumeAnterior": 0,
                        "projetado": 2.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 24,
                    "volumeAnterior": 26,
                    "projetado": 24,
                    "percentVolume": -0.07692307692307687,
                    "percentProjetado": -0.07692307692307687,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 24,
                        "volumeAnterior": 26,
                        "projetado": 24,
                        "percentVolume": -0.07692307692307687,
                        "percentProjetado": -0.07692307692307687,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.08,
                    "volumeAnterior": 0.06,
                    "projetado": 0.08,
                    "percentVolume": 0.3333333333333335,
                    "percentProjetado": 0.3333333333333335,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.08,
                        "volumeAnterior": 0.06,
                        "projetado": 0.08,
                        "percentVolume": 0.3333333333333335,
                        "percentProjetado": 0.3333333333333335,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.072,
                    "volumeAnterior": 0.108,
                    "projetado": 0.072,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.33333333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.072,
                        "volumeAnterior": 0.054,
                        "projetado": 0.072,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.12,
                    "volumeAnterior": 0,
                    "projetado": 0.12,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.12,
                        "volumeAnterior": 0,
                        "projetado": 0.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1885287",
                "razaoSocial": "R  L  BRAGA LTDA",
                "usuarioId": 892,
                "clienteId": 1093541,
                "volumeAtual": 10,
                "volumeAnterior": 6,
                "projetado": 10,
                "percentVolume": 0.6666666666666667,
                "percentProjetado": 0.6666666666666667,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 6,
                    "projetado": 10,
                    "percentVolume": 0.6666666666666667,
                    "percentProjetado": 0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 2,
                        "projetado": 6,
                        "percentVolume": 2,
                        "percentProjetado": 2,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 4,
                        "projetado": 4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1512063",
                "razaoSocial": "FT DOS SANTOS MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 15458,
                "volumeAtual": 56,
                "volumeAnterior": 45.654,
                "projetado": 56,
                "percentVolume": 0.22661760196258807,
                "percentProjetado": 0.22661760196258807,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 1.6,
                    "projetado": 2,
                    "percentVolume": 0.25,
                    "percentProjetado": 0.25,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 1.6,
                        "projetado": 1.2,
                        "percentVolume": -0.2500000000000001,
                        "percentProjetado": -0.2500000000000001,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 44,
                    "projetado": 54,
                    "percentVolume": 0.2272727272727273,
                    "percentProjetado": 0.2272727272727273,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 44,
                        "projetado": 54,
                        "percentVolume": 0.2272727272727273,
                        "percentProjetado": 0.2272727272727273,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1532186",
                "razaoSocial": "COOPERATIVA AGROINDUSTRIAL ALFA",
                "usuarioId": 892,
                "clienteId": 15506,
                "volumeAtual": 42,
                "volumeAnterior": 14,
                "projetado": 42,
                "percentVolume": 2,
                "percentProjetado": 2,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 14,
                    "projetado": 42,
                    "percentVolume": 2,
                    "percentProjetado": 2,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 14,
                        "projetado": 42,
                        "percentVolume": 2,
                        "percentProjetado": 2,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1127081",
                "razaoSocial": "RENOVE MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16244,
                "volumeAtual": 83.726,
                "volumeAnterior": 50.562000000000005,
                "projetado": 83.726,
                "percentVolume": 0.6559075985918277,
                "percentProjetado": 0.6559075985918277,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 80,
                    "volumeAnterior": 48,
                    "projetado": 80,
                    "percentVolume": 0.6666666666666667,
                    "percentProjetado": 0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 80,
                        "volumeAnterior": 48,
                        "projetado": 80,
                        "percentVolume": 0.6666666666666667,
                        "percentProjetado": 0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 3.6,
                    "volumeAnterior": 2.4000000000000004,
                    "projetado": 3.6,
                    "percentVolume": 0.4999999999999998,
                    "percentProjetado": 0.4999999999999998,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 1.6,
                        "projetado": 1.6,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0.8,
                        "projetado": 2,
                        "percentVolume": 1.5,
                        "percentProjetado": 1.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.126,
                    "volumeAnterior": 0.162,
                    "projetado": 0.126,
                    "percentVolume": -0.2222222222222222,
                    "percentProjetado": -0.2222222222222222,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.072,
                        "volumeAnterior": 0.108,
                        "projetado": 0.072,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.33333333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.054,
                        "projetado": 0.054,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1061121",
                "razaoSocial": "MATERIAIS DE CONSTRUCAO ANDRADE LTD",
                "usuarioId": 892,
                "clienteId": 16324,
                "volumeAtual": 12.908,
                "volumeAnterior": 8.4,
                "projetado": 12.908,
                "percentVolume": 0.5366666666666666,
                "percentProjetado": 0.5366666666666666,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.4,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.4,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0,
                    "projetado": 0.108,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0,
                        "projetado": 0.108,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 8,
                    "projetado": 12,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 8,
                        "projetado": 12,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1125047",
                "razaoSocial": "ITALAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16318,
                "volumeAtual": 90.126,
                "volumeAnterior": 100.108,
                "projetado": 90.126,
                "percentVolume": -0.0997123107044392,
                "percentProjetado": -0.0997123107044392,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.126,
                    "volumeAnterior": 0.108,
                    "projetado": 0.126,
                    "percentVolume": 0.16666666666666674,
                    "percentProjetado": 0.16666666666666674,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo de Aderência",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.09,
                        "volumeAnterior": 0.108,
                        "projetado": 0.09,
                        "percentVolume": -0.16666666666666674,
                        "percentProjetado": -0.16666666666666674,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 90,
                    "volumeAnterior": 100,
                    "projetado": 90,
                    "percentVolume": -0.09999999999999998,
                    "percentProjetado": -0.09999999999999998,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 90,
                        "volumeAnterior": 100,
                        "projetado": 90,
                        "percentVolume": -0.09999999999999998,
                        "percentProjetado": -0.09999999999999998,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1721038",
                "razaoSocial": "DMJ EMPREENDIMENTOS LTDA",
                "usuarioId": 892,
                "clienteId": 12397,
                "volumeAtual": 73.24000000000001,
                "volumeAnterior": 104.38,
                "projetado": 73.24000000000001,
                "percentVolume": -0.2983330139873538,
                "percentProjetado": -0.2983330139873538,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 61.239999999999995,
                    "volumeAnterior": 92.38,
                    "projetado": 61.239999999999995,
                    "percentVolume": -0.33708594933968394,
                    "percentProjetado": -0.33708594933968394,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 61.239999999999995,
                        "volumeAnterior": 92.38,
                        "projetado": 61.239999999999995,
                        "percentVolume": -0.33708594933968394,
                        "percentProjetado": -0.33708594933968394,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 12,
                    "projetado": 12,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 12,
                        "projetado": 12,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1113701",
                "razaoSocial": "MERCANTIL MATERIAIS DE CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16218,
                "volumeAtual": 9.2,
                "volumeAnterior": 16.436,
                "projetado": 9.2,
                "percentVolume": -0.4402531029447555,
                "percentProjetado": -0.4402531029447555,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.2,
                    "volumeAnterior": 0.4,
                    "projetado": 1.2,
                    "percentVolume": 1.9999999999999996,
                    "percentProjetado": 1.9999999999999996,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0.4,
                        "projetado": 1.2,
                        "percentVolume": 1.9999999999999996,
                        "percentProjetado": 1.9999999999999996,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 16,
                    "projetado": 8,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 16,
                        "projetado": 8,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1475913",
                "razaoSocial": "MARCOS CLAROS ESPINOZA LTDA",
                "usuarioId": 892,
                "clienteId": 15637,
                "volumeAtual": 295.5,
                "volumeAnterior": 256.02,
                "projetado": 295.5,
                "percentVolume": 0.15420670260135938,
                "percentProjetado": 0.15420670260135938,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 269.5,
                    "volumeAnterior": 210.02,
                    "projetado": 269.5,
                    "percentVolume": 0.2832111227502141,
                    "percentProjetado": 0.2832111227502141,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 269.5,
                        "volumeAnterior": 210.02,
                        "projetado": 269.5,
                        "percentVolume": 0.2832111227502141,
                        "percentProjetado": 0.2832111227502141,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 46,
                    "projetado": 26,
                    "percentVolume": -0.4347826086956522,
                    "percentProjetado": -0.4347826086956522,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 46,
                        "projetado": 26,
                        "percentVolume": -0.4347826086956522,
                        "percentProjetado": -0.4347826086956522,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1779252",
                "razaoSocial": "G & A COMERCIO E SERVICOS LTDA",
                "usuarioId": 892,
                "clienteId": 14648,
                "volumeAtual": 6,
                "volumeAnterior": 4,
                "projetado": 6,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 4,
                    "projetado": 6,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 4,
                        "projetado": 6,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1558982",
                "razaoSocial": "BALBINO E BARBOSA LTDA",
                "usuarioId": 892,
                "clienteId": 15468,
                "volumeAtual": 40.8,
                "volumeAnterior": 12.8,
                "projetado": 40.8,
                "percentVolume": 2.1874999999999996,
                "percentProjetado": 2.1874999999999996,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.8,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 40,
                    "volumeAnterior": 12,
                    "projetado": 40,
                    "percentVolume": 2.3333333333333335,
                    "percentProjetado": 2.3333333333333335,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 40,
                        "volumeAnterior": 12,
                        "projetado": 40,
                        "percentVolume": 2.3333333333333335,
                        "percentProjetado": 2.3333333333333335,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1080145",
                "razaoSocial": "PIRES MARTINS & MARTINS LTDA",
                "usuarioId": 892,
                "clienteId": 16223,
                "volumeAtual": 28,
                "volumeAnterior": 28,
                "projetado": 28,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 28,
                    "projetado": 28,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 28,
                        "projetado": 28,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1062632",
                "razaoSocial": "G5 CASA & CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 649981,
                "volumeAtual": 24.36,
                "volumeAnterior": 28.8,
                "projetado": 24.36,
                "percentVolume": -0.15416666666666667,
                "percentProjetado": -0.15416666666666667,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.8,
                    "projetado": 0.8,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.56,
                    "volumeAnterior": 0,
                    "projetado": 1.56,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 22,
                    "volumeAnterior": 28,
                    "projetado": 22,
                    "percentVolume": -0.2142857142857143,
                    "percentProjetado": -0.2142857142857143,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 22,
                        "volumeAnterior": 28,
                        "projetado": 22,
                        "percentVolume": -0.2142857142857143,
                        "percentProjetado": -0.2142857142857143,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1472823",
                "razaoSocial": "CASA MIX COMERCIO DE MATERIAIS",
                "usuarioId": 892,
                "clienteId": 15602,
                "volumeAtual": 27.2,
                "volumeAnterior": 111.22,
                "projetado": 27.2,
                "percentVolume": -0.7554396691242582,
                "percentProjetado": -0.7554396691242582,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.2000000000000002,
                    "volumeAnterior": 1.2000000000000002,
                    "projetado": 1.2000000000000002,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 110,
                    "projetado": 26,
                    "percentVolume": -0.7636363636363637,
                    "percentProjetado": -0.7636363636363637,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 110,
                        "projetado": 26,
                        "percentVolume": -0.7636363636363637,
                        "percentProjetado": -0.7636363636363637,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0.02,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.02,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1863089",
                "razaoSocial": "HC ENTREGA E TRANSPORTE DE MATERIAI",
                "usuarioId": 892,
                "clienteId": 1055623,
                "volumeAtual": 32.112,
                "volumeAnterior": 27.313999999999997,
                "projetado": 32.112,
                "percentVolume": 0.17566083327231485,
                "percentProjetado": 0.17566083327231485,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 32,
                    "volumeAnterior": 26,
                    "projetado": 32,
                    "percentVolume": 0.23076923076923084,
                    "percentProjetado": 0.23076923076923084,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 32,
                        "volumeAnterior": 26,
                        "projetado": 32,
                        "percentVolume": 0.23076923076923084,
                        "percentProjetado": 0.23076923076923084,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.072,
                    "volumeAnterior": 0.054,
                    "projetado": 0.072,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.072,
                        "volumeAnterior": 0.054,
                        "projetado": 0.072,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0.06,
                    "projetado": 0.04,
                    "percentVolume": -0.33333333333333326,
                    "percentProjetado": -0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0.06,
                        "projetado": 0.04,
                        "percentVolume": -0.33333333333333326,
                        "percentProjetado": -0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1699502",
                "razaoSocial": "M  M  DE MATTOS LTDA",
                "usuarioId": 892,
                "clienteId": 15139,
                "volumeAtual": 43.2,
                "volumeAnterior": 28.8,
                "projetado": 43.2,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.2,
                    "volumeAnterior": 0.8,
                    "projetado": 1.2,
                    "percentVolume": 0.4999999999999998,
                    "percentProjetado": 0.4999999999999998,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0,
                        "projetado": 1.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 28,
                    "projetado": 42,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 28,
                        "projetado": 42,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1820312",
                "razaoSocial": "WOLNEY GABRYELL NUNES DE CAMARGO LT",
                "usuarioId": 892,
                "clienteId": 397927,
                "volumeAtual": 16.4,
                "volumeAnterior": 8,
                "projetado": 16.4,
                "percentVolume": 1.0499999999999998,
                "percentProjetado": 1.0499999999999998,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 8,
                    "projetado": 16,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 8,
                        "projetado": 16,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1730277",
                "razaoSocial": "SUPERMERCADO ROCHEDO LTDA",
                "usuarioId": 892,
                "clienteId": 15056,
                "volumeAtual": 56.8,
                "volumeAnterior": 42.4,
                "projetado": 56.8,
                "percentVolume": 0.3396226415094339,
                "percentProjetado": 0.3396226415094339,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.4,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.4,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 56,
                    "volumeAnterior": 42,
                    "projetado": 56,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 56,
                        "volumeAnterior": 42,
                        "projetado": 56,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1793420",
                "razaoSocial": "TALITA COSTA DE SOUZA",
                "usuarioId": 892,
                "clienteId": 14643,
                "volumeAtual": 12,
                "volumeAnterior": 13.32,
                "projetado": 12,
                "percentVolume": -0.09909909909909909,
                "percentProjetado": -0.09909909909909909,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 12,
                    "projetado": 12,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 12,
                        "projetado": 12,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1835859",
                "razaoSocial": "AERO LAR UTILIDADES LTDA",
                "usuarioId": 892,
                "clienteId": 644124,
                "volumeAtual": 4,
                "volumeAnterior": 6,
                "projetado": 4,
                "percentVolume": -0.33333333333333337,
                "percentProjetado": -0.33333333333333337,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 6,
                    "projetado": 4,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.33333333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 6,
                        "projetado": 4,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.33333333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1702388",
                "razaoSocial": "BRENO ANTHONY LACERDA",
                "usuarioId": 892,
                "clienteId": 15199,
                "volumeAtual": 2,
                "volumeAnterior": 2,
                "projetado": 2,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 2,
                    "projetado": 2,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 2,
                        "projetado": 2,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1830860",
                "razaoSocial": "K L J ELETRICA & CONSTRUCOES LTDA",
                "usuarioId": 892,
                "clienteId": 623958,
                "volumeAtual": 58,
                "volumeAnterior": 24,
                "projetado": 58,
                "percentVolume": 1.4166666666666665,
                "percentProjetado": 1.4166666666666665,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 24,
                    "projetado": 54,
                    "percentVolume": 1.25,
                    "percentProjetado": 1.25,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 24,
                        "projetado": 54,
                        "percentVolume": 1.25,
                        "percentProjetado": 1.25,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1402454",
                "razaoSocial": "D  H  MOYA DIONISIO",
                "usuarioId": 892,
                "clienteId": 15865,
                "volumeAtual": 56.216,
                "volumeAnterior": 56.162,
                "projetado": 56.216,
                "percentVolume": 0.0009615042199351276,
                "percentProjetado": 0.0009615042199351276,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.216,
                    "volumeAnterior": 0.162,
                    "projetado": 0.216,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.216,
                        "volumeAnterior": 0.108,
                        "projetado": 0.216,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 56,
                    "volumeAnterior": 54,
                    "projetado": 56,
                    "percentVolume": 0.03703703703703698,
                    "percentProjetado": 0.03703703703703698,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 56,
                        "volumeAnterior": 54,
                        "projetado": 56,
                        "percentVolume": 0.03703703703703698,
                        "percentProjetado": 0.03703703703703698,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1477870",
                "razaoSocial": "TRANSCAMARGO COMERCIO E SERVICOS LT",
                "usuarioId": 892,
                "clienteId": 15544,
                "volumeAtual": 14,
                "volumeAnterior": 10,
                "projetado": 14,
                "percentVolume": 0.3999999999999999,
                "percentProjetado": 0.3999999999999999,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 10,
                    "projetado": 14,
                    "percentVolume": 0.3999999999999999,
                    "percentProjetado": 0.3999999999999999,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 10,
                        "projetado": 14,
                        "percentVolume": 0.3999999999999999,
                        "percentProjetado": 0.3999999999999999,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1676894",
                "razaoSocial": "LAURA ELAINE LARICA MELLO",
                "usuarioId": 892,
                "clienteId": 15152,
                "volumeAtual": 4,
                "volumeAnterior": 4,
                "projetado": 4,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 4,
                    "projetado": 4,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 4,
                        "projetado": 4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1058301",
                "razaoSocial": "HUGO LANDIVAR LTDA",
                "usuarioId": 892,
                "clienteId": 16290,
                "volumeAtual": 6,
                "volumeAnterior": 4,
                "projetado": 6,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 4,
                    "projetado": 6,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 4,
                        "projetado": 6,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1894886",
                "razaoSocial": "62 594 274 VILMA DINIZ DE ARRUDA",
                "usuarioId": 892,
                "clienteId": 1116248,
                "volumeAtual": 10,
                "volumeAnterior": 2,
                "projetado": 10,
                "percentVolume": 4,
                "percentProjetado": 4,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 2,
                    "projetado": 10,
                    "percentVolume": 4,
                    "percentProjetado": 4,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 2,
                        "projetado": 10,
                        "percentVolume": 4,
                        "percentProjetado": 4,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1058365",
                "razaoSocial": "JOAO MARIA NANTES DE SOUZA",
                "usuarioId": 892,
                "clienteId": 16295,
                "volumeAtual": 2,
                "volumeAnterior": 6,
                "projetado": 2,
                "percentVolume": -0.6666666666666667,
                "percentProjetado": -0.6666666666666667,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 6,
                    "projetado": 2,
                    "percentVolume": -0.6666666666666667,
                    "percentProjetado": -0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 6,
                        "projetado": 2,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1145418",
                "razaoSocial": "BOHN DA VIDA MATERIAL PARA",
                "usuarioId": 892,
                "clienteId": 16279,
                "volumeAtual": 20.8,
                "volumeAnterior": 22.52,
                "projetado": 20.8,
                "percentVolume": -0.07637655417406741,
                "percentProjetado": -0.07637655417406741,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 20,
                    "volumeAnterior": 22,
                    "projetado": 20,
                    "percentVolume": -0.09090909090909094,
                    "percentProjetado": -0.09090909090909094,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 20,
                        "volumeAnterior": 22,
                        "projetado": 20,
                        "percentVolume": -0.09090909090909094,
                        "percentProjetado": -0.09090909090909094,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1827357",
                "razaoSocial": "E  R  O  FORTE LTDA",
                "usuarioId": 892,
                "clienteId": 464151,
                "volumeAtual": 14.036,
                "volumeAnterior": 0,
                "projetado": 14.036,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.036,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1060252",
                "razaoSocial": "CLODOMIRO SANTOS DA SILVA",
                "usuarioId": 892,
                "clienteId": 16234,
                "volumeAtual": 0,
                "volumeAnterior": 2,
                "projetado": 0,
                "percentVolume": -1,
                "percentProjetado": -1,
                "positivacaoM1": 1,
                "positivacaoM0": 0,
                "gruposProduto": [
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 2,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 2,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1078633",
                "razaoSocial": "MARCILIO DE BARROS ALBUQUERQUE",
                "usuarioId": 892,
                "clienteId": 16260,
                "volumeAtual": 8,
                "volumeAnterior": 0,
                "projetado": 8,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 0,
                    "projetado": 8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 0,
                        "projetado": 8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1571737",
                "razaoSocial": "SOLDAMAQ COMERCIO DE FERRAMENTAS",
                "usuarioId": 892,
                "clienteId": 15350,
                "volumeAtual": 26.924,
                "volumeAnterior": 0,
                "projetado": 26.924,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 26.924,
                    "volumeAnterior": 0,
                    "projetado": 26.924,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 26.924,
                        "volumeAnterior": 0,
                        "projetado": 26.924,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1368675",
                "razaoSocial": "SILVA & SANCHES LTDA",
                "usuarioId": 892,
                "clienteId": 16025,
                "volumeAtual": 14,
                "volumeAnterior": 14.42,
                "projetado": 14,
                "percentVolume": -0.029126213592232997,
                "percentProjetado": -0.029126213592232997,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 14,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 14,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1698535",
                "razaoSocial": "PAULINO ORMONDE PORTELA LTDA",
                "usuarioId": 892,
                "clienteId": 15125,
                "volumeAtual": 14,
                "volumeAnterior": 0,
                "projetado": 14,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1334484",
                "razaoSocial": "R  A  KNAUF LTDA",
                "usuarioId": 892,
                "clienteId": 15970,
                "volumeAtual": 149.93,
                "volumeAnterior": 107.78399999999999,
                "projetado": 149.93,
                "percentVolume": 0.39102278631336773,
                "percentProjetado": 0.39102278631336773,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 149.93,
                    "volumeAnterior": 107.78399999999999,
                    "projetado": 149.93,
                    "percentVolume": 0.39102278631336773,
                    "percentProjetado": 0.39102278631336773,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 149.93,
                        "volumeAnterior": 79.36,
                        "projetado": 149.93,
                        "percentVolume": 0.8892389112903227,
                        "percentProjetado": 0.8892389112903227,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1315755",
                "razaoSocial": "ABREGO & RODRIGUES LTDA",
                "usuarioId": 892,
                "clienteId": 118111,
                "volumeAtual": 9.36,
                "volumeAnterior": 0,
                "projetado": 9.36,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 9.36,
                    "volumeAnterior": 0,
                    "projetado": 9.36,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 9.36,
                        "volumeAnterior": 0,
                        "projetado": 9.36,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1458429",
                "razaoSocial": "AGRO SHOPPING LTDA",
                "usuarioId": 892,
                "clienteId": 15688,
                "volumeAtual": 14,
                "volumeAnterior": 28,
                "projetado": 14,
                "percentVolume": -0.5,
                "percentProjetado": -0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 28,
                    "projetado": 14,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 28,
                        "projetado": 14,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1391694",
                "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                "grupoCentralizador": "LEROY MERLIN",
                "usuarioId": 892,
                "clienteId": 57075,
                "volumeAtual": 41.224000000000004,
                "volumeAnterior": 28,
                "projetado": 41.224000000000004,
                "percentVolume": 0.4722857142857144,
                "percentProjetado": 0.4722857142857144,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 0,
                    "projetado": 10,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Porcelanato Interno",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0,
                    "projetado": 0,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 0,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0,
                        "projetado": 0,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 0,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0,
                        "projetado": 0,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 0,
                        "produto": "Polimerica 7000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 28,
                    "projetado": 28,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 28,
                        "projetado": 28,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 3.224,
                    "volumeAnterior": 0,
                    "projetado": 3.224,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.664,
                        "volumeAnterior": 0,
                        "projetado": 1.664,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1057754",
                "razaoSocial": "GUARAPORA MATERIAIS PARA CONSTRUCAO",
                "grupoCentralizador": "FERRAGENS BARATAO",
                "usuarioId": 892,
                "clienteId": 16219,
                "volumeAtual": 8.92,
                "volumeAnterior": 4.4,
                "projetado": 8.92,
                "percentVolume": 1.027272727272727,
                "percentProjetado": 1.027272727272727,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.52,
                    "volumeAnterior": 0,
                    "projetado": 0.52,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 4,
                    "projetado": 8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 4,
                        "projetado": 8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1552268",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116105,
                "volumeAtual": 18,
                "volumeAnterior": 18,
                "projetado": 18,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 18,
                    "projetado": 18,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 18,
                        "projetado": 18,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1529731",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116104,
                "volumeAtual": 54,
                "volumeAnterior": 172,
                "projetado": 54,
                "percentVolume": -0.686046511627907,
                "percentProjetado": -0.686046511627907,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 172,
                    "projetado": 54,
                    "percentVolume": -0.686046511627907,
                    "percentProjetado": -0.686046511627907,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 172,
                        "projetado": 54,
                        "percentVolume": -0.686046511627907,
                        "percentProjetado": -0.686046511627907,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1367137",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 8231,
                "volumeAtual": 2778.84,
                "volumeAnterior": 2243.04,
                "projetado": 2778.84,
                "percentVolume": 0.2388722448106142,
                "percentProjetado": 0.2388722448106142,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 34.28,
                    "volumeAnterior": 14.04,
                    "projetado": 34.28,
                    "percentVolume": 1.441595441595442,
                    "percentProjetado": 1.441595441595442,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Liga para Massa",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 20.28,
                        "volumeAnterior": 14.04,
                        "projetado": 20.28,
                        "percentVolume": 0.44444444444444464,
                        "percentProjetado": 0.44444444444444464,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 94,
                    "volumeAnterior": 7.2,
                    "projetado": 94,
                    "percentVolume": 12.055555555555555,
                    "percentProjetado": 12.055555555555555,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 64,
                        "volumeAnterior": 7.2,
                        "projetado": 64,
                        "percentVolume": 7.888888888888889,
                        "percentProjetado": 7.888888888888889,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 0,
                        "projetado": 12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 0,
                        "projetado": 12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Porcelanato Interno",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 23.939999999999998,
                    "volumeAnterior": 1.8,
                    "projetado": 23.939999999999998,
                    "percentVolume": 12.299999999999999,
                    "percentProjetado": 12.299999999999999,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 5.58,
                        "volumeAnterior": 0,
                        "projetado": 5.58,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 7000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.26,
                        "volumeAnterior": 0,
                        "projetado": 1.26,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo de Aderência",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2.88,
                        "volumeAnterior": 0,
                        "projetado": 2.88,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 14.22,
                        "volumeAnterior": 1.8,
                        "projetado": 14.22,
                        "percentVolume": 6.9,
                        "percentProjetado": 6.9,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 2626,
                    "volumeAnterior": 2220,
                    "projetado": 2626,
                    "percentVolume": 0.1828828828828828,
                    "percentProjetado": 0.1828828828828828,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 38,
                        "volumeAnterior": 0,
                        "projetado": 38,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cimento 25kg",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2574,
                        "volumeAnterior": 2166,
                        "projetado": 2574,
                        "percentVolume": 0.18836565096952906,
                        "percentProjetado": 0.18836565096952906,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 54,
                        "projetado": 14,
                        "percentVolume": -0.7407407407407407,
                        "percentProjetado": -0.7407407407407407,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.62,
                    "volumeAnterior": 0,
                    "projetado": 0.62,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.6,
                        "volumeAnterior": 0,
                        "projetado": 0.6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Porcelanato",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1060663",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 20743,
                "volumeAtual": 14,
                "volumeAnterior": 0,
                "projetado": 14,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1186391",
                "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                "grupoCentralizador": "ESMAEL",
                "usuarioId": 892,
                "clienteId": 16081,
                "volumeAtual": 130.66,
                "volumeAnterior": 14.04,
                "projetado": 130.66,
                "percentVolume": 8.306267806267806,
                "percentProjetado": 8.306267806267806,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 0,
                    "projetado": 1.6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0,
                        "projetado": 1.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 128,
                    "volumeAnterior": 14,
                    "projetado": 128,
                    "percentVolume": 8.142857142857142,
                    "percentProjetado": 8.142857142857142,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 128,
                        "volumeAnterior": 14,
                        "projetado": 128,
                        "percentVolume": 8.142857142857142,
                        "percentProjetado": 8.142857142857142,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.04,
                    "volumeAnterior": 0,
                    "projetado": 1.04,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.04,
                        "volumeAnterior": 0,
                        "projetado": 1.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0.04,
                    "projetado": 0.02,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0.04,
                        "projetado": 0.02,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1049264",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16403,
                "volumeAtual": 965.8879999999999,
                "volumeAnterior": 761.7819999999999,
                "projetado": 965.8879999999999,
                "percentVolume": 0.2679322955911272,
                "percentProjetado": 0.2679322955911272,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4.68,
                    "volumeAnterior": 0,
                    "projetado": 4.68,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 3.12,
                        "volumeAnterior": 0,
                        "projetado": 3.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 609.208,
                    "volumeAnterior": 441.782,
                    "projetado": 609.208,
                    "percentVolume": 0.3789787723356768,
                    "percentProjetado": 0.3789787723356768,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 609.208,
                        "volumeAnterior": 441.782,
                        "projetado": 609.208,
                        "percentVolume": 0.3789787723356768,
                        "percentProjetado": 0.3789787723356768,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 352,
                    "volumeAnterior": 320,
                    "projetado": 352,
                    "percentVolume": 0.10000000000000009,
                    "percentProjetado": 0.10000000000000009,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 352,
                        "volumeAnterior": 320,
                        "projetado": 352,
                        "percentVolume": 0.10000000000000009,
                        "percentProjetado": 0.10000000000000009,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1206763",
                "razaoSocial": "WANDERSON S GALVAO",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16139,
                "volumeAtual": 66.24000000000001,
                "volumeAnterior": 114,
                "projetado": 66.24000000000001,
                "percentVolume": -0.4189473684210525,
                "percentProjetado": -0.4189473684210525,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 66,
                    "volumeAnterior": 114,
                    "projetado": 66,
                    "percentVolume": -0.42105263157894735,
                    "percentProjetado": -0.42105263157894735,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 66,
                        "volumeAnterior": 114,
                        "projetado": 66,
                        "percentVolume": -0.42105263157894735,
                        "percentProjetado": -0.42105263157894735,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.24,
                    "volumeAnterior": 0,
                    "projetado": 0.24,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.24,
                        "volumeAnterior": 0,
                        "projetado": 0.24,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1536936",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 15498,
                "volumeAtual": 32,
                "volumeAnterior": 32,
                "projetado": 32,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 32,
                    "volumeAnterior": 32,
                    "projetado": 32,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 32,
                        "volumeAnterior": 32,
                        "projetado": 32,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1548795",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15437,
                "volumeAtual": 14,
                "volumeAnterior": 0,
                "projetado": 14,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1476567",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15629,
                "volumeAtual": 41.2,
                "volumeAnterior": 28.400000000000002,
                "projetado": 41.2,
                "percentVolume": 0.45070422535211274,
                "percentProjetado": 0.45070422535211274,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 36,
                    "volumeAnterior": 26,
                    "projetado": 36,
                    "percentVolume": 0.3846153846153846,
                    "percentProjetado": 0.3846153846153846,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 36,
                        "volumeAnterior": 26,
                        "projetado": 36,
                        "percentVolume": 0.3846153846153846,
                        "percentProjetado": 0.3846153846153846,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 5.2,
                    "volumeAnterior": 2.4000000000000004,
                    "projetado": 5.2,
                    "percentVolume": 1.1666666666666665,
                    "percentProjetado": 1.1666666666666665,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 1.6,
                        "projetado": 4,
                        "percentVolume": 1.5,
                        "percentProjetado": 1.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0,
                        "projetado": 1.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1783272",
                "razaoSocial": "COMERCIO COPACABANA LTDA",
                "grupoCentralizador": "COPACABANA",
                "usuarioId": 892,
                "clienteId": 14649,
                "volumeAtual": 28.112000000000002,
                "volumeAnterior": 13.632,
                "projetado": 28.112000000000002,
                "percentVolume": 1.0622065727699534,
                "percentProjetado": 1.0622065727699534,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0,
                        "projetado": 1.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0,
                    "projetado": 0.04,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0,
                        "projetado": 0.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.072,
                    "volumeAnterior": 0.072,
                    "projetado": 0.072,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0.072,
                        "projetado": 0.036,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 7000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 12,
                    "projetado": 26,
                    "percentVolume": 1.1666666666666665,
                    "percentProjetado": 1.1666666666666665,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 12,
                        "projetado": 26,
                        "percentVolume": 1.1666666666666665,
                        "percentProjetado": 1.1666666666666665,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1615426",
                "razaoSocial": "SERTAO COMERCIAL DE EQUIPAMENTOS LT",
                "grupoCentralizador": "SERTÃO",
                "usuarioId": 892,
                "clienteId": 15227,
                "volumeAtual": 27.56,
                "volumeAnterior": 17.12,
                "projetado": 27.56,
                "percentVolume": 0.6098130841121494,
                "percentProjetado": 0.6098130841121494,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.56,
                    "volumeAnterior": 3.12,
                    "projetado": 1.56,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 1.56,
                        "projetado": 1.56,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 14,
                    "projetado": 26,
                    "percentVolume": 0.8571428571428572,
                    "percentProjetado": 0.8571428571428572,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 14,
                        "projetado": 26,
                        "percentVolume": 0.8571428571428572,
                        "percentProjetado": 0.8571428571428572,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1660429",
                "razaoSocial": "SERTAO COMERCIAL DE EQUIPAMENTOS LT",
                "grupoCentralizador": "SERTÃO",
                "usuarioId": 892,
                "clienteId": 15229,
                "volumeAtual": 17.04,
                "volumeAnterior": 0,
                "projetado": 17.04,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 0,
                    "projetado": 16,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 0,
                        "projetado": 16,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.04,
                    "volumeAnterior": 0,
                    "projetado": 1.04,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.04,
                        "volumeAnterior": 0,
                        "projetado": 1.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1473763",
                "razaoSocial": "WILIAN DA CUNHA",
                "grupoCentralizador": "WILIAN DA CUNHA",
                "usuarioId": 892,
                "clienteId": 15616,
                "volumeAtual": 28.107999999999997,
                "volumeAnterior": 28.073999999999998,
                "projetado": 28.107999999999997,
                "percentVolume": 0.0012110849896700415,
                "percentProjetado": 0.0012110849896700415,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 28,
                    "projetado": 28,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 28,
                        "projetado": 28,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0.054,
                    "projetado": 0.108,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.054,
                        "projetado": 0.054,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1463567",
                "razaoSocial": "CECOM COMERCIO DE MATERIAIS PARA",
                "grupoCentralizador": "CECOM",
                "usuarioId": 892,
                "clienteId": 15780,
                "volumeAtual": 83.53999999999999,
                "volumeAnterior": 87.404,
                "projetado": 83.53999999999999,
                "percentVolume": -0.04420850304333901,
                "percentProjetado": -0.04420850304333901,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 53.54,
                    "volumeAnterior": 77.404,
                    "projetado": 53.54,
                    "percentVolume": -0.30830448038861036,
                    "percentProjetado": -0.30830448038861036,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 53.54,
                        "volumeAnterior": 77.404,
                        "projetado": 53.54,
                        "percentVolume": -0.30830448038861036,
                        "percentProjetado": -0.30830448038861036,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 30,
                    "volumeAnterior": 10,
                    "projetado": 30,
                    "percentVolume": 2,
                    "percentProjetado": 2,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 30,
                        "volumeAnterior": 10,
                        "projetado": 30,
                        "percentVolume": 2,
                        "percentProjetado": 2,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1456661",
                "razaoSocial": "JAMES HENRIQUE BOVEDA",
                "grupoCentralizador": "BOVEDA",
                "usuarioId": 892,
                "clienteId": 15774,
                "volumeAtual": 14,
                "volumeAnterior": 42,
                "projetado": 14,
                "percentVolume": -0.6666666666666667,
                "percentProjetado": -0.6666666666666667,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 42,
                    "projetado": 14,
                    "percentVolume": -0.6666666666666667,
                    "percentProjetado": -0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 42,
                        "projetado": 14,
                        "percentVolume": -0.6666666666666667,
                        "percentProjetado": -0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1917096",
                "razaoSocial": "2J MIX LTDA",
                "grupoCentralizador": "BOVEDA",
                "usuarioId": 892,
                "clienteId": 1147717,
                "volumeAtual": 6,
                "volumeAnterior": 0,
                "projetado": 6,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-07-01T00:00:00"
              },
              {
                "codigoCliente": "1401430",
                "razaoSocial": "G  DOS S  MELLO",
                "usuarioId": 892,
                "clienteId": 15881,
                "volumeAtual": 2,
                "volumeAnterior": 2,
                "projetado": 2,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 2,
                    "projetado": 2,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 2,
                        "projetado": 2,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1512063",
                "razaoSocial": "FT DOS SANTOS MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 15458,
                "volumeAtual": 45.654,
                "volumeAnterior": 24.4,
                "projetado": 45.654,
                "percentVolume": 0.871065573770492,
                "percentProjetado": 0.871065573770492,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 44,
                    "volumeAnterior": 24,
                    "projetado": 44,
                    "percentVolume": 0.8333333333333333,
                    "percentProjetado": 0.8333333333333333,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 44,
                        "volumeAnterior": 24,
                        "projetado": 44,
                        "percentVolume": 0.8333333333333333,
                        "percentProjetado": 0.8333333333333333,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.6,
                    "volumeAnterior": 0.4,
                    "projetado": 1.6,
                    "percentVolume": 3,
                    "percentProjetado": 3,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 0.4,
                        "projetado": 1.6,
                        "percentVolume": 3,
                        "percentProjetado": 3,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1334484",
                "razaoSocial": "R  A  KNAUF LTDA",
                "usuarioId": 892,
                "clienteId": 15970,
                "volumeAtual": 107.78399999999999,
                "volumeAnterior": 109.45400000000001,
                "projetado": 107.78399999999999,
                "percentVolume": -0.015257551117364487,
                "percentProjetado": -0.015257551117364487,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 107.78399999999999,
                    "volumeAnterior": 109.45400000000001,
                    "projetado": 107.78399999999999,
                    "percentVolume": -0.015257551117364487,
                    "percentProjetado": -0.015257551117364487,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 28.424,
                        "volumeAnterior": 55.308,
                        "projetado": 28.424,
                        "percentVolume": -0.48607796340493237,
                        "percentProjetado": -0.48607796340493237,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Outros",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 79.36,
                        "volumeAnterior": 54.146,
                        "projetado": 79.36,
                        "percentVolume": 0.46566690060207594,
                        "percentProjetado": 0.46566690060207594,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1669301",
                "razaoSocial": "M V MATERIAIS PARA CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 15127,
                "volumeAtual": 22.894,
                "volumeAnterior": 12.4,
                "projetado": 22.894,
                "percentVolume": 0.8462903225806451,
                "percentProjetado": 0.8462903225806451,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0,
                    "projetado": 0.04,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0,
                        "projetado": 0.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.4,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.4,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 22,
                    "volumeAnterior": 12,
                    "projetado": 22,
                    "percentVolume": 0.8333333333333333,
                    "percentProjetado": 0.8333333333333333,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 22,
                        "volumeAnterior": 12,
                        "projetado": 22,
                        "percentVolume": 0.8333333333333333,
                        "percentProjetado": 0.8333333333333333,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1527581",
                "razaoSocial": "ALVES CONSTRUCAO E AGRO LTDA",
                "usuarioId": 892,
                "clienteId": 15429,
                "volumeAtual": 42,
                "volumeAnterior": 56,
                "projetado": 42,
                "percentVolume": -0.25,
                "percentProjetado": -0.25,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 56,
                    "projetado": 42,
                    "percentVolume": -0.25,
                    "percentProjetado": -0.25,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 56,
                        "projetado": 42,
                        "percentVolume": -0.25,
                        "percentProjetado": -0.25,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1584302",
                "razaoSocial": "JULIO MANOEL DA SILVA NETO LTDA",
                "usuarioId": 892,
                "clienteId": 15480,
                "volumeAtual": 36,
                "volumeAnterior": 24,
                "projetado": 36,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 36,
                    "volumeAnterior": 24,
                    "projetado": 36,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 36,
                        "volumeAnterior": 24,
                        "projetado": 36,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1472823",
                "razaoSocial": "CASA MIX COMERCIO DE MATERIAIS",
                "usuarioId": 892,
                "clienteId": 15602,
                "volumeAtual": 111.22,
                "volumeAnterior": 42,
                "projetado": 111.22,
                "percentVolume": 1.6480952380952383,
                "percentProjetado": 1.6480952380952383,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 110,
                    "volumeAnterior": 42,
                    "projetado": 110,
                    "percentVolume": 1.619047619047619,
                    "percentProjetado": 1.619047619047619,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 110,
                        "volumeAnterior": 42,
                        "projetado": 110,
                        "percentVolume": 1.619047619047619,
                        "percentProjetado": 1.619047619047619,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.2000000000000002,
                    "volumeAnterior": 0,
                    "projetado": 1.2000000000000002,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1056890",
                "razaoSocial": "COMERCIAL JACARE MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16336,
                "volumeAtual": 193.762,
                "volumeAnterior": 67.03999999999999,
                "projetado": 193.762,
                "percentVolume": 1.8902446300715994,
                "percentProjetado": 1.8902446300715994,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 133.762,
                    "volumeAnterior": 27.04,
                    "projetado": 133.762,
                    "percentVolume": 3.946819526627219,
                    "percentProjetado": 3.946819526627219,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 133.762,
                        "volumeAnterior": 27.04,
                        "projetado": 133.762,
                        "percentVolume": 3.946819526627219,
                        "percentProjetado": 3.946819526627219,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 60,
                    "volumeAnterior": 40,
                    "projetado": 60,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 60,
                        "volumeAnterior": 40,
                        "projetado": 60,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1125047",
                "razaoSocial": "ITALAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16318,
                "volumeAtual": 100.108,
                "volumeAnterior": 49.147999999999996,
                "projetado": 100.108,
                "percentVolume": 1.0368682347196225,
                "percentProjetado": 1.0368682347196225,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0.108,
                    "projetado": 0.108,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0.108,
                        "projetado": 0.108,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 100,
                    "volumeAnterior": 48,
                    "projetado": 100,
                    "percentVolume": 1.0833333333333335,
                    "percentProjetado": 1.0833333333333335,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 100,
                        "volumeAnterior": 48,
                        "projetado": 100,
                        "percentVolume": 1.0833333333333335,
                        "percentProjetado": 1.0833333333333335,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1809150",
                "razaoSocial": "J  E  S  MORON LTDA",
                "usuarioId": 892,
                "clienteId": 28606,
                "volumeAtual": 64,
                "volumeAnterior": 28,
                "projetado": 64,
                "percentVolume": 1.2857142857142856,
                "percentProjetado": 1.2857142857142856,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 64,
                    "volumeAnterior": 28,
                    "projetado": 64,
                    "percentVolume": 1.2857142857142856,
                    "percentProjetado": 1.2857142857142856,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 64,
                        "volumeAnterior": 28,
                        "projetado": 64,
                        "percentVolume": 1.2857142857142856,
                        "percentProjetado": 1.2857142857142856,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1368675",
                "razaoSocial": "SILVA & SANCHES LTDA",
                "usuarioId": 892,
                "clienteId": 16025,
                "volumeAtual": 14.42,
                "volumeAnterior": 0,
                "projetado": 14.42,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 0,
                    "projetado": 14,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 0,
                        "projetado": 14,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1145418",
                "razaoSocial": "BOHN DA VIDA MATERIAL PARA",
                "usuarioId": 892,
                "clienteId": 16279,
                "volumeAtual": 22.52,
                "volumeAnterior": 26.894,
                "projetado": 22.52,
                "percentVolume": -0.1626385067301257,
                "percentProjetado": -0.1626385067301257,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.52,
                    "volumeAnterior": 0.84,
                    "projetado": 0.52,
                    "percentVolume": -0.38095238095238093,
                    "percentProjetado": -0.38095238095238093,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 22,
                    "volumeAnterior": 26,
                    "projetado": 22,
                    "percentVolume": -0.15384615384615385,
                    "percentProjetado": -0.15384615384615385,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 22,
                        "volumeAnterior": 26,
                        "projetado": 22,
                        "percentVolume": -0.15384615384615385,
                        "percentProjetado": -0.15384615384615385,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1057403",
                "razaoSocial": "ROSANGELA JORGE DA SILVA",
                "usuarioId": 892,
                "clienteId": 16360,
                "volumeAtual": 19.32,
                "volumeAnterior": 16.4,
                "projetado": 19.32,
                "percentVolume": 0.17804878048780504,
                "percentProjetado": 0.17804878048780504,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 16,
                    "projetado": 18,
                    "percentVolume": 0.125,
                    "percentProjetado": 0.125,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 16,
                        "projetado": 18,
                        "percentVolume": 0.125,
                        "percentProjetado": 0.125,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.2,
                    "volumeAnterior": 0.4,
                    "projetado": 1.2,
                    "percentVolume": 1.9999999999999996,
                    "percentProjetado": 1.9999999999999996,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 0.4,
                        "projetado": 1.2,
                        "percentVolume": 1.9999999999999996,
                        "percentProjetado": 1.9999999999999996,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.12,
                    "volumeAnterior": 0,
                    "projetado": 0.12,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.12,
                        "volumeAnterior": 0,
                        "projetado": 0.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1475913",
                "razaoSocial": "MARCOS CLAROS ESPINOZA LTDA",
                "usuarioId": 892,
                "clienteId": 15637,
                "volumeAtual": 256.02,
                "volumeAnterior": 196.616,
                "projetado": 256.02,
                "percentVolume": 0.3021320747039913,
                "percentProjetado": 0.3021320747039913,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 46,
                    "volumeAnterior": 46,
                    "projetado": 46,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 46,
                        "volumeAnterior": 46,
                        "projetado": 46,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 210.02,
                    "volumeAnterior": 150.616,
                    "projetado": 210.02,
                    "percentVolume": 0.394406968715143,
                    "percentProjetado": 0.394406968715143,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 210.02,
                        "volumeAnterior": 150.616,
                        "projetado": 210.02,
                        "percentVolume": 0.394406968715143,
                        "percentProjetado": 0.394406968715143,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1127407",
                "razaoSocial": "JOSE MARIANO DOS SANTOS",
                "usuarioId": 892,
                "clienteId": 16289,
                "volumeAtual": 70.4,
                "volumeAnterior": 42.42,
                "projetado": 70.4,
                "percentVolume": 0.6595945308816598,
                "percentProjetado": 0.6595945308816598,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 70,
                    "volumeAnterior": 42,
                    "projetado": 70,
                    "percentVolume": 0.6666666666666667,
                    "percentProjetado": 0.6666666666666667,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 70,
                        "volumeAnterior": 42,
                        "projetado": 70,
                        "percentVolume": 0.6666666666666667,
                        "percentProjetado": 0.6666666666666667,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1730277",
                "razaoSocial": "SUPERMERCADO ROCHEDO LTDA",
                "usuarioId": 892,
                "clienteId": 15056,
                "volumeAtual": 42.4,
                "volumeAnterior": 42,
                "projetado": 42.4,
                "percentVolume": 0.00952380952380949,
                "percentProjetado": 0.00952380952380949,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 42,
                    "projetado": 42,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 42,
                        "projetado": 42,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1143334",
                "razaoSocial": "CLAUDEMIRO CALDAS DA SILVA",
                "usuarioId": 892,
                "clienteId": 16272,
                "volumeAtual": 14.02,
                "volumeAnterior": 28.04,
                "projetado": 14.02,
                "percentVolume": -0.5,
                "percentProjetado": -0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 28,
                    "projetado": 14,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 28,
                        "projetado": 14,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0.04,
                    "projetado": 0.02,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0.04,
                        "projetado": 0.02,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1127081",
                "razaoSocial": "RENOVE MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16244,
                "volumeAtual": 50.562000000000005,
                "volumeAnterior": 32.12,
                "projetado": 50.562000000000005,
                "percentVolume": 0.5741594022415943,
                "percentProjetado": 0.5741594022415943,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2.4000000000000004,
                    "volumeAnterior": 4,
                    "projetado": 2.4000000000000004,
                    "percentVolume": -0.3999999999999999,
                    "percentProjetado": -0.3999999999999999,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 3.2,
                        "projetado": 1.6,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.8,
                        "projetado": 0.8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.162,
                    "volumeAnterior": 0,
                    "projetado": 0.162,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0,
                        "projetado": 0.108,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 48,
                    "volumeAnterior": 28,
                    "projetado": 48,
                    "percentVolume": 0.7142857142857142,
                    "percentProjetado": 0.7142857142857142,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 48,
                        "volumeAnterior": 28,
                        "projetado": 48,
                        "percentVolume": 0.7142857142857142,
                        "percentProjetado": 0.7142857142857142,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1658949",
                "razaoSocial": "SILVA & TORRES MATERIAIS PARA",
                "usuarioId": 892,
                "clienteId": 15211,
                "volumeAtual": 26.968,
                "volumeAnterior": 27.599999999999998,
                "projetado": 26.968,
                "percentVolume": -0.022898550724637645,
                "percentProjetado": -0.022898550724637645,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 1.6,
                    "projetado": 0.8,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.4,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "PSP",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.108,
                    "volumeAnterior": 0,
                    "projetado": 0.108,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.06,
                    "volumeAnterior": 0,
                    "projetado": 0.06,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.06,
                        "volumeAnterior": 0,
                        "projetado": 0.06,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 26,
                    "projetado": 26,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 26,
                        "projetado": 26,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1835859",
                "razaoSocial": "AERO LAR UTILIDADES LTDA",
                "usuarioId": 892,
                "clienteId": 644124,
                "volumeAtual": 6,
                "volumeAnterior": 4,
                "projetado": 6,
                "percentVolume": 0.5,
                "percentProjetado": 0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 4,
                    "projetado": 6,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 4,
                        "projetado": 6,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1062632",
                "razaoSocial": "G5 CASA & CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 649981,
                "volumeAtual": 28.8,
                "volumeAnterior": 2.4,
                "projetado": 28.8,
                "percentVolume": 11,
                "percentProjetado": 11,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 2,
                    "projetado": 28,
                    "percentVolume": 13,
                    "percentProjetado": 13,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 2,
                        "projetado": 28,
                        "percentVolume": 13,
                        "percentProjetado": 13,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0.4,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0.4,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1300115",
                "razaoSocial": "BIG CASA MATERIAL DE CONSTRUCAO LTD",
                "usuarioId": 892,
                "clienteId": 15999,
                "volumeAtual": 4,
                "volumeAnterior": 20,
                "projetado": 4,
                "percentVolume": -0.8,
                "percentProjetado": -0.8,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 20,
                    "projetado": 4,
                    "percentVolume": -0.8,
                    "percentProjetado": -0.8,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 20,
                        "projetado": 4,
                        "percentVolume": -0.8,
                        "percentProjetado": -0.8,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1721038",
                "razaoSocial": "DMJ EMPREENDIMENTOS LTDA",
                "usuarioId": 892,
                "clienteId": 12397,
                "volumeAtual": 104.38,
                "volumeAnterior": 134.06799999999998,
                "projetado": 104.38,
                "percentVolume": -0.22143986633648594,
                "percentProjetado": -0.22143986633648594,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 92.38,
                    "volumeAnterior": 124.068,
                    "projetado": 92.38,
                    "percentVolume": -0.2554083244672277,
                    "percentProjetado": -0.2554083244672277,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 92.38,
                        "volumeAnterior": 124.068,
                        "projetado": 92.38,
                        "percentVolume": -0.2554083244672277,
                        "percentProjetado": -0.2554083244672277,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 10,
                    "projetado": 12,
                    "percentVolume": 0.19999999999999996,
                    "percentProjetado": 0.19999999999999996,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 10,
                        "projetado": 12,
                        "percentVolume": 0.19999999999999996,
                        "percentProjetado": 0.19999999999999996,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1141525",
                "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16276,
                "volumeAtual": 4,
                "volumeAnterior": 6,
                "projetado": 4,
                "percentVolume": -0.33333333333333337,
                "percentProjetado": -0.33333333333333337,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 6,
                    "projetado": 4,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.33333333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 6,
                        "projetado": 4,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.33333333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1113701",
                "razaoSocial": "MERCANTIL MATERIAIS DE CONSTRUCAO",
                "usuarioId": 892,
                "clienteId": 16218,
                "volumeAtual": 16.436,
                "volumeAnterior": 16.8,
                "projetado": 16.436,
                "percentVolume": -0.021666666666666723,
                "percentProjetado": -0.021666666666666723,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 16,
                    "volumeAnterior": 16,
                    "projetado": 16,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 16,
                        "volumeAnterior": 16,
                        "projetado": 16,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.8,
                    "projetado": 0.4,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.8,
                        "projetado": 0.4,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.036,
                    "volumeAnterior": 0,
                    "projetado": 0.036,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.036,
                        "volumeAnterior": 0,
                        "projetado": 0.036,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1060546",
                "razaoSocial": "MADESUL MADEIRAS E MATERIAIS DE",
                "usuarioId": 892,
                "clienteId": 16297,
                "volumeAtual": 351.156,
                "volumeAnterior": 494.91200000000003,
                "projetado": 351.156,
                "percentVolume": -0.29046780033622144,
                "percentProjetado": -0.29046780033622144,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 252,
                    "volumeAnterior": 252,
                    "projetado": 252,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 252,
                        "volumeAnterior": 252,
                        "projetado": 252,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 99.156,
                    "volumeAnterior": 242.912,
                    "projetado": 99.156,
                    "percentVolume": -0.5918027927809248,
                    "percentProjetado": -0.5918027927809248,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 99.156,
                        "volumeAnterior": 242.912,
                        "projetado": 99.156,
                        "percentVolume": -0.5918027927809248,
                        "percentProjetado": -0.5918027927809248,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1477870",
                "razaoSocial": "TRANSCAMARGO COMERCIO E SERVICOS LT",
                "usuarioId": 892,
                "clienteId": 15544,
                "volumeAtual": 10,
                "volumeAnterior": 4,
                "projetado": 10,
                "percentVolume": 1.5,
                "percentProjetado": 1.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 4,
                    "projetado": 10,
                    "percentVolume": 1.5,
                    "percentProjetado": 1.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 4,
                        "projetado": 10,
                        "percentVolume": 1.5,
                        "percentProjetado": 1.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1830860",
                "razaoSocial": "K L J ELETRICA & CONSTRUCOES LTDA",
                "usuarioId": 892,
                "clienteId": 623958,
                "volumeAtual": 24,
                "volumeAnterior": 54,
                "projetado": 24,
                "percentVolume": -0.5555555555555556,
                "percentProjetado": -0.5555555555555556,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 24,
                    "volumeAnterior": 46,
                    "projetado": 24,
                    "percentVolume": -0.4782608695652174,
                    "percentProjetado": -0.4782608695652174,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 24,
                        "volumeAnterior": 46,
                        "projetado": 24,
                        "percentVolume": -0.4782608695652174,
                        "percentProjetado": -0.4782608695652174,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1097413",
                "razaoSocial": "JEFERSON DIAS DE VASCONCELOS",
                "usuarioId": 892,
                "clienteId": 16268,
                "volumeAtual": 19.52,
                "volumeAnterior": 0,
                "projetado": 19.52,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 15.52,
                    "volumeAnterior": 0,
                    "projetado": 15.52,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 7.2,
                        "volumeAnterior": 0,
                        "projetado": 7.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Liga para Massa",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 8.32,
                        "volumeAnterior": 0,
                        "projetado": 8.32,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1793420",
                "razaoSocial": "TALITA COSTA DE SOUZA",
                "usuarioId": 892,
                "clienteId": 14643,
                "volumeAtual": 13.32,
                "volumeAnterior": 12,
                "projetado": 13.32,
                "percentVolume": 0.1100000000000001,
                "percentProjetado": 0.1100000000000001,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.12,
                    "volumeAnterior": 0,
                    "projetado": 0.12,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.12,
                        "volumeAnterior": 0,
                        "projetado": 0.12,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.2000000000000002,
                    "volumeAnterior": 0,
                    "projetado": 1.2000000000000002,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 12,
                    "projetado": 12,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 12,
                        "projetado": 12,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1702388",
                "razaoSocial": "BRENO ANTHONY LACERDA",
                "usuarioId": 892,
                "clienteId": 15199,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1170311",
                "razaoSocial": "M DE F OLIVEIRA",
                "usuarioId": 892,
                "clienteId": 16125,
                "volumeAtual": 53.120000000000005,
                "volumeAnterior": 69.32,
                "projetado": 53.120000000000005,
                "percentVolume": -0.23369878822850532,
                "percentProjetado": -0.23369878822850532,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 36,
                    "volumeAnterior": 36,
                    "projetado": 36,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 36,
                        "volumeAnterior": 36,
                        "projetado": 36,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 17.12,
                    "volumeAnterior": 33.32,
                    "projetado": 17.12,
                    "percentVolume": -0.48619447779111646,
                    "percentProjetado": -0.48619447779111646,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 17.12,
                        "volumeAnterior": 33.32,
                        "projetado": 17.12,
                        "percentVolume": -0.48619447779111646,
                        "percentProjetado": -0.48619447779111646,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1657382",
                "razaoSocial": "RURAL MIX LTDA",
                "usuarioId": 892,
                "clienteId": 15324,
                "volumeAtual": 0,
                "volumeAnterior": 4.86,
                "projetado": 0,
                "percentVolume": -1,
                "percentProjetado": -1,
                "positivacaoM1": 1,
                "positivacaoM0": 0,
                "gruposProduto": [
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0.8,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.4,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.4,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0.06,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.06,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 4,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 4,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1458429",
                "razaoSocial": "AGRO SHOPPING LTDA",
                "usuarioId": 892,
                "clienteId": 15688,
                "volumeAtual": 28,
                "volumeAnterior": 14,
                "projetado": 28,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 14,
                    "projetado": 28,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 14,
                        "projetado": 28,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1489185",
                "razaoSocial": "AGEU MATERIAIS DE CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 15630,
                "volumeAtual": 14,
                "volumeAnterior": 26,
                "projetado": 14,
                "percentVolume": -0.46153846153846156,
                "percentProjetado": -0.46153846153846156,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 26,
                    "projetado": 14,
                    "percentVolume": -0.46153846153846156,
                    "percentProjetado": -0.46153846153846156,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 26,
                        "projetado": 14,
                        "percentVolume": -0.46153846153846156,
                        "percentProjetado": -0.46153846153846156,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1080145",
                "razaoSocial": "PIRES MARTINS & MARTINS LTDA",
                "usuarioId": 892,
                "clienteId": 16223,
                "volumeAtual": 28,
                "volumeAnterior": 0,
                "projetado": 28,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 0,
                    "projetado": 28,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 0,
                        "projetado": 28,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1699502",
                "razaoSocial": "M  M  DE MATTOS LTDA",
                "usuarioId": 892,
                "clienteId": 15139,
                "volumeAtual": 28.8,
                "volumeAnterior": 26.8,
                "projetado": 28.8,
                "percentVolume": 0.07462686567164178,
                "percentProjetado": 0.07462686567164178,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 2.8,
                    "projetado": 0.8,
                    "percentVolume": -0.7142857142857142,
                    "percentProjetado": -0.7142857142857142,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 1.2,
                        "projetado": 0.8,
                        "percentVolume": -0.33333333333333326,
                        "percentProjetado": -0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC III",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 24,
                    "projetado": 28,
                    "percentVolume": 0.16666666666666674,
                    "percentProjetado": 0.16666666666666674,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 24,
                        "projetado": 28,
                        "percentVolume": 0.16666666666666674,
                        "percentProjetado": 0.16666666666666674,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1863089",
                "razaoSocial": "HC ENTREGA E TRANSPORTE DE MATERIAI",
                "usuarioId": 892,
                "clienteId": 1055623,
                "volumeAtual": 27.313999999999997,
                "volumeAnterior": 26.42,
                "projetado": 27.313999999999997,
                "percentVolume": 0.03383800151400429,
                "percentProjetado": 0.03383800151400429,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.06,
                    "volumeAnterior": 0.02,
                    "projetado": 0.06,
                    "percentVolume": 2,
                    "percentProjetado": 2,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.06,
                        "volumeAnterior": 0.02,
                        "projetado": 0.06,
                        "percentVolume": 2,
                        "percentProjetado": 2,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 24,
                    "projetado": 26,
                    "percentVolume": 0.08333333333333326,
                    "percentProjetado": 0.08333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 24,
                        "projetado": 26,
                        "percentVolume": 0.08333333333333326,
                        "percentProjetado": 0.08333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.2,
                    "volumeAnterior": 2.4,
                    "projetado": 1.2,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.2,
                        "volumeAnterior": 2.4,
                        "projetado": 1.2,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1217329",
                "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                "usuarioId": 892,
                "clienteId": 16133,
                "volumeAtual": 4.054,
                "volumeAnterior": 0,
                "projetado": 4.054,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0,
                    "projetado": 0.054,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0,
                        "projetado": 0.054,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1885287",
                "razaoSocial": "R  L  BRAGA LTDA",
                "usuarioId": 892,
                "clienteId": 1093541,
                "volumeAtual": 6,
                "volumeAnterior": 2,
                "projetado": 6,
                "percentVolume": 2,
                "percentProjetado": 2,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 2,
                    "projetado": 6,
                    "percentVolume": 2,
                    "percentProjetado": 2,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 2,
                        "projetado": 2,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1377343",
                "razaoSocial": "CONSTRUPORTO MATERIAIS PARA CONSTRU",
                "usuarioId": 892,
                "clienteId": 16033,
                "volumeAtual": 40.8,
                "volumeAnterior": 0,
                "projetado": 40.8,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 36,
                    "volumeAnterior": 0,
                    "projetado": 36,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 36,
                        "volumeAnterior": 0,
                        "projetado": 36,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 4.8,
                    "volumeAnterior": 0,
                    "projetado": 4.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 4.8,
                        "volumeAnterior": 0,
                        "projetado": 4.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1058301",
                "razaoSocial": "HUGO LANDIVAR LTDA",
                "usuarioId": 892,
                "clienteId": 16290,
                "volumeAtual": 4,
                "volumeAnterior": 6,
                "projetado": 4,
                "percentVolume": -0.33333333333333337,
                "percentProjetado": -0.33333333333333337,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 6,
                    "projetado": 4,
                    "percentVolume": -0.33333333333333337,
                    "percentProjetado": -0.33333333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 6,
                        "projetado": 4,
                        "percentVolume": -0.33333333333333337,
                        "percentProjetado": -0.33333333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1288177",
                "razaoSocial": "FARIAS & COSTA LTDA",
                "usuarioId": 892,
                "clienteId": 15917,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1626357",
                "razaoSocial": "MARCELO SOUZA CAVALCANTE 7141861017",
                "usuarioId": 892,
                "clienteId": 14353,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1354226",
                "razaoSocial": "DEPOSITO SANTO EUGENIO EIRELI",
                "usuarioId": 892,
                "clienteId": 16016,
                "volumeAtual": 2.42,
                "volumeAnterior": 0,
                "projetado": 2.42,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0,
                    "projetado": 0.4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1379388",
                "razaoSocial": "ROBERTO GONCALVES MATERIAIS DE CONS",
                "usuarioId": 892,
                "clienteId": 15943,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1875709",
                "razaoSocial": "UNIAO MATERIAIS DE CONSTRUCAO LTDA",
                "usuarioId": 892,
                "clienteId": 1079118,
                "volumeAtual": 14,
                "volumeAnterior": 10,
                "projetado": 14,
                "percentVolume": 0.3999999999999999,
                "percentProjetado": 0.3999999999999999,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 10,
                    "projetado": 14,
                    "percentVolume": 0.3999999999999999,
                    "percentProjetado": 0.3999999999999999,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 10,
                        "projetado": 14,
                        "percentVolume": 0.3999999999999999,
                        "percentProjetado": 0.3999999999999999,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1402454",
                "razaoSocial": "D  H  MOYA DIONISIO",
                "usuarioId": 892,
                "clienteId": 15865,
                "volumeAtual": 56.162,
                "volumeAnterior": 14.108,
                "projetado": 56.162,
                "percentVolume": 2.9808619223135806,
                "percentProjetado": 2.9808619223135806,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 54,
                    "volumeAnterior": 14,
                    "projetado": 54,
                    "percentVolume": 2.857142857142857,
                    "percentProjetado": 2.857142857142857,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 14,
                        "projetado": 54,
                        "percentVolume": 2.857142857142857,
                        "percentProjetado": 2.857142857142857,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.162,
                    "volumeAnterior": 0.108,
                    "projetado": 0.162,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.108,
                        "projetado": 0.054,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.108,
                        "volumeAnterior": 0,
                        "projetado": 0.108,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1058365",
                "razaoSocial": "JOAO MARIA NANTES DE SOUZA",
                "usuarioId": 892,
                "clienteId": 16295,
                "volumeAtual": 6,
                "volumeAnterior": 0,
                "projetado": 6,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 6,
                    "volumeAnterior": 0,
                    "projetado": 6,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 6,
                        "volumeAnterior": 0,
                        "projetado": 6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1532186",
                "razaoSocial": "COOPERATIVA AGROINDUSTRIAL ALFA",
                "usuarioId": 892,
                "clienteId": 15506,
                "volumeAtual": 14,
                "volumeAnterior": 28,
                "projetado": 14,
                "percentVolume": -0.5,
                "percentProjetado": -0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 28,
                    "projetado": 14,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 28,
                        "projetado": 14,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1558982",
                "razaoSocial": "BALBINO E BARBOSA LTDA",
                "usuarioId": 892,
                "clienteId": 15468,
                "volumeAtual": 12.8,
                "volumeAnterior": 28,
                "projetado": 12.8,
                "percentVolume": -0.5428571428571428,
                "percentProjetado": -0.5428571428571428,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.8,
                    "volumeAnterior": 0,
                    "projetado": 0.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 28,
                    "projetado": 12,
                    "percentVolume": -0.5714285714285714,
                    "percentProjetado": -0.5714285714285714,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 28,
                        "projetado": 12,
                        "percentVolume": -0.5714285714285714,
                        "percentProjetado": -0.5714285714285714,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1691844",
                "razaoSocial": "JR EMPREENDIMENTOS LTDA",
                "usuarioId": 892,
                "clienteId": 15142,
                "volumeAtual": 14.02,
                "volumeAnterior": 14.054,
                "projetado": 14.02,
                "percentVolume": -0.002419240074000295,
                "percentProjetado": -0.002419240074000295,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 14,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 14,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1676894",
                "razaoSocial": "LAURA ELAINE LARICA MELLO",
                "usuarioId": 892,
                "clienteId": 15152,
                "volumeAtual": 4,
                "volumeAnterior": 2,
                "projetado": 4,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 2,
                    "projetado": 4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 2,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1125330",
                "razaoSocial": "MINEIRAO COMERCIO DE MATERIAIS PARA",
                "usuarioId": 892,
                "clienteId": 16258,
                "volumeAtual": 10,
                "volumeAnterior": 10,
                "projetado": 10,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 10,
                    "projetado": 10,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 10,
                        "projetado": 10,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1563084",
                "razaoSocial": "CASTANHEIRA PRESTADORA DE SERVICOS",
                "usuarioId": 892,
                "clienteId": 15417,
                "volumeAtual": 5,
                "volumeAnterior": 0,
                "projetado": 5,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1,
                    "volumeAnterior": 0,
                    "projetado": 1,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0.52,
                        "volumeAnterior": 0,
                        "projetado": 0.52,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 0.48,
                        "volumeAnterior": 0,
                        "projetado": 0.48,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 0,
                    "projetado": 4,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 0,
                        "projetado": 4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1061121",
                "razaoSocial": "MATERIAIS DE CONSTRUCAO ANDRADE LTD",
                "usuarioId": 892,
                "clienteId": 16324,
                "volumeAtual": 8.4,
                "volumeAnterior": 4.42,
                "projetado": 8.4,
                "percentVolume": 0.9004524886877829,
                "percentProjetado": 0.9004524886877829,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0.4,
                        "projetado": 0.4,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 4,
                    "projetado": 8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 4,
                        "projetado": 8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1894886",
                "razaoSocial": "62 594 274 VILMA DINIZ DE ARRUDA",
                "usuarioId": 892,
                "clienteId": 1116248,
                "volumeAtual": 2,
                "volumeAnterior": 0,
                "projetado": 2,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 0,
                    "projetado": 2,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 0,
                        "projetado": 2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1060252",
                "razaoSocial": "CLODOMIRO SANTOS DA SILVA",
                "usuarioId": 892,
                "clienteId": 16234,
                "volumeAtual": 2,
                "volumeAnterior": 4,
                "projetado": 2,
                "percentVolume": -0.5,
                "percentProjetado": -0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 4,
                    "projetado": 2,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 4,
                        "projetado": 2,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1783291",
                "razaoSocial": "VERISSIMO COMERCIO LTDA",
                "usuarioId": 892,
                "clienteId": 14608,
                "volumeAtual": 4.44,
                "volumeAnterior": 22,
                "projetado": 4.44,
                "percentVolume": -0.7981818181818181,
                "percentProjetado": -0.7981818181818181,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.36,
                    "volumeAnterior": 0,
                    "projetado": 0.36,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.36,
                        "volumeAnterior": 0,
                        "projetado": 0.36,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 22,
                    "projetado": 4,
                    "percentVolume": -0.8181818181818181,
                    "percentProjetado": -0.8181818181818181,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 22,
                        "projetado": 4,
                        "percentVolume": -0.8181818181818181,
                        "percentProjetado": -0.8181818181818181,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.08,
                    "volumeAnterior": 0,
                    "projetado": 0.08,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.08,
                        "volumeAnterior": 0,
                        "projetado": 0.08,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1820312",
                "razaoSocial": "WOLNEY GABRYELL NUNES DE CAMARGO LT",
                "usuarioId": 892,
                "clienteId": 397927,
                "volumeAtual": 8,
                "volumeAnterior": 16.454,
                "projetado": 8,
                "percentVolume": -0.5137960374377051,
                "percentProjetado": -0.5137960374377051,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 16,
                    "projetado": 8,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 16,
                        "projetado": 8,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1779252",
                "razaoSocial": "G & A COMERCIO E SERVICOS LTDA",
                "usuarioId": 892,
                "clienteId": 14648,
                "volumeAtual": 4,
                "volumeAnterior": 8,
                "projetado": 4,
                "percentVolume": -0.5,
                "percentProjetado": -0.5,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 8,
                    "projetado": 4,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 8,
                        "projetado": 4,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1391694",
                "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                "grupoCentralizador": "LEROY MERLIN",
                "usuarioId": 892,
                "clienteId": 57075,
                "volumeAtual": 28,
                "volumeAnterior": 70,
                "projetado": 28,
                "percentVolume": -0.6,
                "percentProjetado": -0.6,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 70,
                    "projetado": 28,
                    "percentVolume": -0.6,
                    "percentProjetado": -0.6,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 70,
                        "projetado": 28,
                        "percentVolume": -0.6,
                        "percentProjetado": -0.6,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1258703",
                "razaoSocial": "FERRAGEM ALVORADA LTDA",
                "grupoCentralizador": "ALVORADA",
                "usuarioId": 892,
                "clienteId": 16070,
                "volumeAtual": 1.088,
                "volumeAnterior": 0,
                "projetado": 1.088,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.088,
                    "volumeAnterior": 0,
                    "projetado": 1.088,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.088,
                        "volumeAnterior": 0,
                        "projetado": 1.088,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1057754",
                "razaoSocial": "GUARAPORA MATERIAIS PARA CONSTRUCAO",
                "grupoCentralizador": "FERRAGENS BARATAO",
                "usuarioId": 892,
                "clienteId": 16219,
                "volumeAtual": 4.4,
                "volumeAnterior": 8.92,
                "projetado": 4.4,
                "percentVolume": -0.506726457399103,
                "percentProjetado": -0.506726457399103,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 4,
                    "volumeAnterior": 8,
                    "projetado": 4,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 4,
                        "volumeAnterior": 8,
                        "projetado": 4,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.4,
                    "volumeAnterior": 0.4,
                    "projetado": 0.4,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.4,
                        "volumeAnterior": 0,
                        "projetado": 0.4,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0,
                    "volumeAnterior": 0.52,
                    "projetado": 0,
                    "percentVolume": -1,
                    "percentProjetado": -1,
                    "positivacaoM1": 1,
                    "positivacaoM0": 0,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 0,
                        "volumeAnterior": 0.52,
                        "projetado": 0,
                        "percentVolume": -1,
                        "percentProjetado": -1,
                        "positivacaoM1": 1,
                        "positivacaoM0": 0,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1529731",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116104,
                "volumeAtual": 172,
                "volumeAnterior": 143.8,
                "projetado": 172,
                "percentVolume": 0.19610570236439484,
                "percentProjetado": 0.19610570236439484,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 172,
                    "volumeAnterior": 136,
                    "projetado": 172,
                    "percentVolume": 0.2647058823529411,
                    "percentProjetado": 0.2647058823529411,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 172,
                        "volumeAnterior": 136,
                        "projetado": 172,
                        "percentVolume": 0.2647058823529411,
                        "percentProjetado": 0.2647058823529411,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1552268",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116105,
                "volumeAtual": 18,
                "volumeAnterior": 18,
                "projetado": 18,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 18,
                    "volumeAnterior": 18,
                    "projetado": 18,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 18,
                        "volumeAnterior": 18,
                        "projetado": 18,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1538881",
                "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                "grupoCentralizador": "TODIMO",
                "usuarioId": 892,
                "clienteId": 116106,
                "volumeAtual": 8,
                "volumeAnterior": 8,
                "projetado": 8,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 8,
                    "volumeAnterior": 8,
                    "projetado": 8,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 8,
                        "volumeAnterior": 8,
                        "projetado": 8,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1367137",
                "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                "grupoCentralizador": "ELOS",
                "usuarioId": 892,
                "clienteId": 8231,
                "volumeAtual": 2243.04,
                "volumeAnterior": 2290.6600000000003,
                "projetado": 2243.04,
                "percentVolume": -0.02078876830258547,
                "percentProjetado": -0.02078876830258547,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2220,
                    "volumeAnterior": 2248,
                    "projetado": 2220,
                    "percentVolume": -0.01245551601423489,
                    "percentProjetado": -0.01245551601423489,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 54,
                        "volumeAnterior": 42,
                        "projetado": 54,
                        "percentVolume": 0.2857142857142858,
                        "percentProjetado": 0.2857142857142858,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Obras Especiais",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 2166,
                        "volumeAnterior": 2206,
                        "projetado": 2166,
                        "percentVolume": -0.018132366273798772,
                        "percentProjetado": -0.018132366273798772,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 7.2,
                    "volumeAnterior": 0.8,
                    "projetado": 7.2,
                    "percentVolume": 8,
                    "percentProjetado": 8,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 7.2,
                        "volumeAnterior": 0,
                        "projetado": 7.2,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 1.8,
                    "volumeAnterior": 0,
                    "projetado": 1.8,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 1.8,
                        "volumeAnterior": 0,
                        "projetado": 1.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14.04,
                    "volumeAnterior": 41.84,
                    "projetado": 14.04,
                    "percentVolume": -0.6644359464627152,
                    "percentProjetado": -0.6644359464627152,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 14.04,
                        "volumeAnterior": 20.28,
                        "projetado": 14.04,
                        "percentVolume": -0.3076923076923078,
                        "percentProjetado": -0.3076923076923078,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1186391",
                "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                "grupoCentralizador": "ESMAEL",
                "usuarioId": 892,
                "clienteId": 16081,
                "volumeAtual": 14.04,
                "volumeAnterior": 83.596,
                "projetado": 14.04,
                "percentVolume": -0.8320493803531269,
                "percentProjetado": -0.8320493803531269,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 82,
                    "projetado": 14,
                    "percentVolume": -0.8292682926829268,
                    "percentProjetado": -0.8292682926829268,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 82,
                        "projetado": 14,
                        "percentVolume": -0.8292682926829268,
                        "percentProjetado": -0.8292682926829268,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.04,
                    "volumeAnterior": 0,
                    "projetado": 0.04,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.04,
                        "volumeAnterior": 0,
                        "projetado": 0.04,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1536936",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 15498,
                "volumeAtual": 32,
                "volumeAnterior": 32,
                "projetado": 32,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 32,
                    "volumeAnterior": 32,
                    "projetado": 32,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 32,
                        "volumeAnterior": 32,
                        "projetado": 32,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1049264",
                "razaoSocial": "WANDERSON MATERIAIS DE CONSTRUCOES",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16403,
                "volumeAtual": 761.7819999999999,
                "volumeAnterior": 1389.9940000000001,
                "projetado": 761.7819999999999,
                "percentVolume": -0.4519530300130793,
                "percentProjetado": -0.4519530300130793,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 320,
                    "volumeAnterior": 384,
                    "projetado": 320,
                    "percentVolume": -0.16666666666666663,
                    "percentProjetado": -0.16666666666666663,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 320,
                        "volumeAnterior": 384,
                        "projetado": 320,
                        "percentVolume": -0.16666666666666663,
                        "percentProjetado": -0.16666666666666663,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 441.782,
                    "volumeAnterior": 1005.9939999999999,
                    "projetado": 441.782,
                    "percentVolume": -0.5608502635204584,
                    "percentProjetado": -0.5608502635204584,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 441.782,
                        "volumeAnterior": 1005.9939999999999,
                        "projetado": 441.782,
                        "percentVolume": -0.5608502635204584,
                        "percentProjetado": -0.5608502635204584,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1206763",
                "razaoSocial": "WANDERSON S GALVAO",
                "grupoCentralizador": "WANDERSON",
                "usuarioId": 892,
                "clienteId": 16139,
                "volumeAtual": 114,
                "volumeAnterior": 144.12,
                "projetado": 114,
                "percentVolume": -0.20899250624479604,
                "percentProjetado": -0.20899250624479604,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 114,
                    "volumeAnterior": 144,
                    "projetado": 114,
                    "percentVolume": -0.20833333333333337,
                    "percentProjetado": -0.20833333333333337,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 114,
                        "volumeAnterior": 144,
                        "projetado": 114,
                        "percentVolume": -0.20833333333333337,
                        "percentProjetado": -0.20833333333333337,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1476567",
                "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                "grupoCentralizador": "CONSTRU UTIL",
                "usuarioId": 892,
                "clienteId": 15629,
                "volumeAtual": 28.400000000000002,
                "volumeAnterior": 28,
                "projetado": 28.400000000000002,
                "percentVolume": 0.014285714285714457,
                "percentProjetado": 0.014285714285714457,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 26,
                    "volumeAnterior": 28,
                    "projetado": 26,
                    "percentVolume": -0.0714285714285714,
                    "percentProjetado": -0.0714285714285714,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 26,
                        "volumeAnterior": 28,
                        "projetado": 26,
                        "percentVolume": -0.0714285714285714,
                        "percentProjetado": -0.0714285714285714,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 2.4000000000000004,
                    "volumeAnterior": 0,
                    "projetado": 2.4000000000000004,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Colantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.8,
                        "volumeAnterior": 0,
                        "projetado": 0.8,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC II",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.6,
                        "volumeAnterior": 0,
                        "projetado": 1.6,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "AC I",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1783272",
                "razaoSocial": "COMERCIO COPACABANA LTDA",
                "grupoCentralizador": "COPACABANA",
                "usuarioId": 892,
                "clienteId": 14649,
                "volumeAtual": 13.632,
                "volumeAnterior": 27.513999999999996,
                "projetado": 13.632,
                "percentVolume": -0.5045431416733299,
                "percentProjetado": -0.5045431416733299,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 1.56,
                    "volumeAnterior": 1.04,
                    "projetado": 1.56,
                    "percentVolume": 0.5,
                    "percentProjetado": 0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 1.04,
                        "projetado": 1.56,
                        "percentVolume": 0.5,
                        "percentProjetado": 0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.072,
                    "volumeAnterior": 0.054,
                    "projetado": 0.072,
                    "percentVolume": 0.33333333333333326,
                    "percentProjetado": 0.33333333333333326,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.072,
                        "volumeAnterior": 0.054,
                        "projetado": 0.072,
                        "percentVolume": 0.33333333333333326,
                        "percentProjetado": 0.33333333333333326,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Polimerica 1000",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 12,
                    "volumeAnterior": 24,
                    "projetado": 12,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 12,
                        "volumeAnterior": 24,
                        "projetado": 12,
                        "percentVolume": -0.5,
                        "percentProjetado": -0.5,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1615426",
                "razaoSocial": "SERTAO COMERCIAL DE EQUIPAMENTOS LT",
                "grupoCentralizador": "SERTÃO",
                "usuarioId": 892,
                "clienteId": 15227,
                "volumeAtual": 17.12,
                "volumeAnterior": 14,
                "projetado": 17.12,
                "percentVolume": 0.22285714285714286,
                "percentProjetado": 0.22285714285714286,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 3.12,
                    "volumeAnterior": 0,
                    "projetado": 3.12,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cales",
                    "produtos": [
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Pintura",
                        "inicioMes": "0001-01-01T00:00:00"
                      },
                      {
                        "volumeAtual": 1.56,
                        "volumeAnterior": 0,
                        "projetado": 1.56,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Cal Hidratada",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 14,
                    "volumeAnterior": 14,
                    "projetado": 14,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 14,
                        "volumeAnterior": 14,
                        "projetado": 14,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1582572",
                "razaoSocial": "RECANTO MATERIAIS DE CONSTRUCAO LTD",
                "grupoCentralizador": "CASABELLA",
                "usuarioId": 892,
                "clienteId": 15500,
                "volumeAtual": 2,
                "volumeAnterior": 2,
                "projetado": 2,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 2,
                    "projetado": 2,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 2,
                        "projetado": 2,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1330360",
                "razaoSocial": "MIRANDA PEREIRA MATERIAIS PARA",
                "grupoCentralizador": "CASABELLA",
                "usuarioId": 892,
                "clienteId": 15931,
                "volumeAtual": 2,
                "volumeAnterior": 2,
                "projetado": 2,
                "percentVolume": 0,
                "percentProjetado": 0,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 2,
                    "volumeAnterior": 2,
                    "projetado": 2,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 2,
                        "volumeAnterior": 2,
                        "projetado": 2,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1473763",
                "razaoSocial": "WILIAN DA CUNHA",
                "grupoCentralizador": "WILIAN DA CUNHA",
                "usuarioId": 892,
                "clienteId": 15616,
                "volumeAtual": 28.073999999999998,
                "volumeAnterior": 28.108,
                "projetado": 28.073999999999998,
                "percentVolume": -0.001209620037000203,
                "percentProjetado": -0.001209620037000203,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 0.02,
                    "volumeAnterior": 0,
                    "projetado": 0.02,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Rejuntes",
                    "produtos": [
                      {
                        "volumeAtual": 0.02,
                        "volumeAnterior": 0,
                        "projetado": 0.02,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Rejunte Ceramica",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 28,
                    "volumeAnterior": 28,
                    "projetado": 28,
                    "percentVolume": 0,
                    "percentProjetado": 0,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 28,
                        "volumeAnterior": 28,
                        "projetado": 28,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 0.054,
                    "volumeAnterior": 0.108,
                    "projetado": 0.054,
                    "percentVolume": -0.5,
                    "percentProjetado": -0.5,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Impermeabilizantes",
                    "produtos": [
                      {
                        "volumeAtual": 0.054,
                        "volumeAnterior": 0.054,
                        "projetado": 0.054,
                        "percentVolume": 0,
                        "percentProjetado": 0,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Aditivo Impermeabili",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1463567",
                "razaoSocial": "CECOM COMERCIO DE MATERIAIS PARA",
                "grupoCentralizador": "CECOM",
                "usuarioId": 892,
                "clienteId": 15780,
                "volumeAtual": 87.404,
                "volumeAnterior": 14,
                "projetado": 87.404,
                "percentVolume": 5.243142857142857,
                "percentProjetado": 5.243142857142857,
                "positivacaoM1": 1,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 77.404,
                    "volumeAnterior": 0,
                    "projetado": 77.404,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Agregados",
                    "produtos": [
                      {
                        "volumeAtual": 77.404,
                        "volumeAnterior": 0,
                        "projetado": 77.404,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Nobres",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  },
                  {
                    "volumeAtual": 10,
                    "volumeAnterior": 14,
                    "projetado": 10,
                    "percentVolume": -0.2857142857142857,
                    "percentProjetado": -0.2857142857142857,
                    "positivacaoM1": 1,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 10,
                        "volumeAnterior": 14,
                        "projetado": 10,
                        "percentVolume": -0.2857142857142857,
                        "percentProjetado": -0.2857142857142857,
                        "positivacaoM1": 1,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              },
              {
                "codigoCliente": "1456661",
                "razaoSocial": "JAMES HENRIQUE BOVEDA",
                "grupoCentralizador": "BOVEDA",
                "usuarioId": 892,
                "clienteId": 15774,
                "volumeAtual": 42,
                "volumeAnterior": 0,
                "projetado": 42,
                "percentVolume": 1,
                "percentProjetado": 1,
                "positivacaoM1": 0,
                "positivacaoM0": 1,
                "gruposProduto": [
                  {
                    "volumeAtual": 42,
                    "volumeAnterior": 0,
                    "projetado": 42,
                    "percentVolume": 1,
                    "percentProjetado": 1,
                    "positivacaoM1": 0,
                    "positivacaoM0": 1,
                    "produto": "Cimentos",
                    "produtos": [
                      {
                        "volumeAtual": 42,
                        "volumeAnterior": 0,
                        "projetado": 42,
                        "percentVolume": 1,
                        "percentProjetado": 1,
                        "positivacaoM1": 0,
                        "positivacaoM0": 1,
                        "produto": "Todas as Obras",
                        "inicioMes": "0001-01-01T00:00:00"
                      }
                    ],
                    "inicioMes": "0001-01-01T00:00:00"
                  }
                ],
                "inicioMes": "2026-06-01T00:00:00"
              }
            ]
          },
          {
            "id": 6,
            "filtros": [
              {
                "produto": "Cal Hidratada",
                "grupoProduto": "Cales"
              },
              {
                "produto": "Nobres",
                "grupoProduto": "Agregados"
              },
              {
                "produto": "Todas as Obras",
                "grupoProduto": "Cimentos"
              },
              {
                "produto": "Polimerica 1000",
                "grupoProduto": "Impermeabilizantes"
              },
              {
                "produto": "AC I",
                "grupoProduto": "Colantes"
              },
              {
                "produto": "AC II",
                "grupoProduto": "Colantes"
              },
              {
                "produto": "Rejunte Ceramica",
                "grupoProduto": "Rejuntes"
              },
              {
                "produto": "PSP",
                "grupoProduto": "Colantes"
              },
              {
                "produto": "AC III",
                "grupoProduto": "Colantes"
              },
              {
                "produto": "Aditivo de Aderência",
                "grupoProduto": "Impermeabilizantes"
              },
              {
                "produto": "Cal Pintura",
                "grupoProduto": "Cales"
              },
              {
                "produto": "Outros",
                "grupoProduto": "Agregados"
              },
              {
                "produto": "Aditivo Impermeabili",
                "grupoProduto": "Impermeabilizantes"
              },
              {
                "produto": "Obras Especiais",
                "grupoProduto": "Cimentos"
              },
              {
                "produto": "Liga para Massa",
                "grupoProduto": "Cales"
              },
              {
                "produto": "Porcelanato Interno",
                "grupoProduto": "Colantes"
              },
              {
                "produto": "Polimerica 7000",
                "grupoProduto": "Impermeabilizantes"
              },
              {
                "produto": "Cimento 25kg",
                "grupoProduto": "Cimentos"
              },
              {
                "produto": "Rejunte Porcelanato",
                "grupoProduto": "Rejuntes"
              }
            ]
          }
        ]
      }
    ]
  ],
  "existentes": []
}
]]